import { Injectable } from '@angular/core';
import {
  LookupField, LookupApi, Employee, RoleType,
  UserApi, CandidateDocuments, CandidateProfile, DeptCodeblock, RankGrade, ImmigrationProfile,
  EmailApi, EmailTemplateEditorInfo, OfficeEntity, ServiceLine,

  SubServiceLine, SMU, Sector, UserRole, OfficeLocation, ImmigrationApi, ValidationApi, AuthorisedHub, ImmigrationMailTemplateInfo, FilterParams, GlobalRank, GlobalGrade, ExitRequest, LookupType, Companies, EmployeeProfile, EmployeeProfileApi, ExitMailTemplateInfo, DocumentInstructions, EmployeeDoc, Speciality, Cities, EmployeeDocCombined, CandidateApi,
  ConfigurationApi,
  ValueTupleOfIntegerAndInteger,
  EAAllocator,
  CountryVisaOptionDto,
} from './api.gen';
import { takeUntil, map, shareReplay, startWith, tap, filter, distinctUntilChanged, debounceTime, switchMap, take, catchError, skip } from 'rxjs/operators';
import { Subject, Observable, EMPTY, BehaviorSubject, OperatorFunction, combineLatest, of, merge } from 'rxjs';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { getMergedConfig, setDisableWhen } from '../shared/form';
import { LookupTypeKeys } from '../shared/lookup-type-keys';
import { HttpClient } from '@angular/common/http';
import { AbstractControl, FormControl } from '@angular/forms';
import { PbFieldTypes } from '../shared/pb-field-types';
import { getDateAsUTC, isNullOrUndefined } from '../../app/core/utils';
import { nullSafe } from '../utils';
import { AuthService } from './auth.service';
import { ValidityTypes } from '../immigration/services/validations/validatity-types.enum';
import { ToastService } from './toast.service';
import { Router } from '@angular/router';
import { addDays, addMonths, addYears, differenceInCalendarDays, differenceInYears, isWithinInterval, subYears } from 'date-fns';
import { EmployeeCategory, ImmStatusType, StatusTypes } from '../shared/status-types';
//import { stringify } from '@angular/compiler/src/util';
import { differenceInCalendarYears, differenceInDays } from 'date-fns/esm';
import { VisaTypesValues } from '../immigration/services/visatypes/visa-types-values.enum';
import { BusinessTravel, CountryTypeIds, CountryTypesValues } from '../immigration/services/visatypes/country-types.enum';
import { DialogService } from './dialog.service';
import { LookupFieldKeys } from '../shared/lookup-fields-keys';
import { LoaderService } from './loader.service';

@Injectable()
export class CommonService {
  documentSupportTypeId: number = 0;
  visaTypeId: number = 0;
  fieldToolTipTextsByVisa: any;
  AddTooltipToControl(tooltipMessage: string): FormlyFieldConfig {
    return {
      templateOptions: {
        tooltip: {
          content: tooltipMessage
        }
      },
      wrappers: ['tooltip-field']
    };
  }
  lookUp = 0;
  candidateId = 0;
  immigrationProfileId: number = 0;
  exitProfileId: number = 0;
  isRecruitment = false;
  isVisaApprover = false;
  isExecAssistant = false;
  isRewardsTeam = false;
  isExitTeam = false;
  isContingentWorkerTeam = false;
  destroyed$ = new Subject();
  lookups$: Observable<LookupField[]>;
  delegateStatus$ = new Subject<boolean>();
  deptCodeBlock$ = new BehaviorSubject<DeptCodeblock[]>([]);
  nationality$ = new BehaviorSubject<LookupField[]>([]);
  immCaseType$ = new BehaviorSubject<LookupField[]>([]);
  officeLocation$ = new BehaviorSubject<LookupField[]>([]);
  rankGrade$ = new BehaviorSubject<RankGrade[]>([]);
  Grade$ = new BehaviorSubject<RankGrade[]>([]);
  durationOfStay$ = new BehaviorSubject<LookupField[]>([]);
  offcLocationAsBS$ = new BehaviorSubject<LookupField[]>([]);
  hotelAndHotelBooking$ = new BehaviorSubject<LookupField[]>([]);
  relocationBenefit$ = new BehaviorSubject<LookupField[]>([]);
  visaTypes$: Observable<LookupField[]> = null;
  exitTypes$: Observable<LookupField[]> = null;
  visaDisplayText = new BehaviorSubject<string>(null);
  missionVisaCateogryAsBS$ = new BehaviorSubject<LookupField[]>([]);
  categoryOfJobOfferAsBS$ = new BehaviorSubject<LookupField[]>([]);
  updateUI$ = new Subject<boolean>();
  yesNo$ = new BehaviorSubject<LookupField[]>([]);
  preboardingType$ = new BehaviorSubject<LookupField[]>([]);
  typeOfVisa$ = new BehaviorSubject<LookupField[]>([]);
  officeLEforSL$ = new BehaviorSubject<OfficeEntity[]>([]);
  ptc$ = new BehaviorSubject<Employee[]>([]);
  cities$ = new BehaviorSubject<OfficeLocation[]>([]);
  acceptDate: Date = null;
  VendorDetails: FormlyFieldConfig;
  SHARED_LOOKUP_TYPES = [1, 2, 4, 7, 9, 10, 11, 12, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 43];
  immigrationCountry: string; // country value from the url
  pendingStartdateProfiles$ = new Subject<boolean>();
  pendingCommentProfiles$ = new Subject<boolean>();
  pendingImmAutoVisaRequestProfiles$ = new Subject<boolean>();
  menaOffice$ = new BehaviorSubject<LookupField[]>([]);
  isAllVisaRequest = new BehaviorSubject<boolean>(null);
  isUpdateProfileTask = new BehaviorSubject<boolean>(null);
  isUserProfileExpiryDatesUpdated = new BehaviorSubject<boolean>(null);
  workpermitJobTitles$ = new BehaviorSubject<LookupField[]>([]);
  caneditCompletedProfile :boolean = false;
  isAdminProfileEdit = false;
  constructor(
    private lookupApi: LookupApi,
    private appConfig: ConfigurationApi,
    private emailApi: EmailApi,
    private userAPI: UserApi,
    private empProfile: EmployeeProfileApi,
    private http: HttpClient,
    private authService: AuthService,
    private toast: ToastService,
    private route: Router,
    private validationApi: ValidationApi,
    private loader: LoaderService,
    private dialog: DialogService, private candidateApi: CandidateApi,
  private immigrationService:ImmigrationApi) {
    this.lookups$ = this.prepareCommonLookupObservable();
  }

  get LookUp() {
    return this.lookUp;
  }

  set LookUp(lookup) {
    this.LookUp = lookup;
  }

  getDestroyed() {
    return this.destroyed$;
  }

  //prepareEmployeeObservable(
  //    teamId: number
  //): Observable<LookupField[]> {
  //    return this.lookupApi.getEmployeesByTeam(teamId).pipe(
  //        takeUntil(this.destroyed$),
  //        map(x => x),
  //        shareReplay()
  //    );
  //}
  OpenAlert(message: string) {
    // this.toast.error('Please enter valid value');
    this.dialog.showConfirmationBox('Alert', message, () => { });

  }

  executeConfirmedEndDate(
    setCEDOnCDChange?: (duration: number) => void,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    let contractType: AbstractControl;
    let contractDuration: AbstractControl;
    let msg: string;

    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        cdvalidator: {
          expression: (c) => {
            msg = nullSafe(() => this.getContractDurationValidationError(contractType.value, contractDuration.value), '');
            if (msg !== '') {
              return false;
            }
            return true;
          },
          message: (error, field: FormlyFieldConfig) => msg,
        }
      },
    };

    config.hooks = {
      onInit: field => {
        contractDuration = field.formControl;
        contractType = this.findFormControl("contractType.id", field);
        contractDuration.valueChanges.pipe(
          takeUntil(this.destroyed$),
          startWith(contractDuration.value),
          tap(duration => {
            if (setCEDOnCDChange instanceof Function) {
              setCEDOnCDChange(duration);
            }
          }))
          .subscribe();

        contractType.valueChanges.pipe(
          takeUntil(this.destroyed$),
          startWith(contractType.value),
          tap((id) => {
            if (!isNullOrUndefined(contractDuration.value) && nullSafe<number>(() => contractDuration.value, -1) >= 0) {
              contractDuration.updateValueAndValidity();
              setTimeout(() => {
                contractDuration.markAsTouched();
              }, 1);
            }
          })
        )
          .subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  getContractDurationValidationError(currentContType, duration): string {
    const fixedTypeValidation = `Invalid 'Contract duration'. For the selected contract type, duration should be greater than 0`;
    const unlimitedTypeValidation = `Invalid 'Contract duration'. For the selected contract type, duration should be 0`;
    const fixedTermIds = [1056, 714, 1058, 1059, 720, 1063, 1064, 1065, 1061, 4839, 5907];
    const unlimitedTermIds = [1057, 716, 721, 1060, 4840, 4834];

    if (fixedTermIds.includes(currentContType)
      && !(Number(duration) > 0)) {
      return fixedTypeValidation;
    } else if (unlimitedTermIds.includes(currentContType)
      && (Number(duration) !== 0)) {
      return unlimitedTypeValidation;
    }
    return '';
  }

  setCED(
    parentKey: string,
    setCEDOnSDChange: (startDate: Date) => Date,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
      }
    };

    config.hooks = {
      onInit: field => {
        const ele = this.findFormControl(parentKey, field);
        let isFirst = true;
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            distinctUntilChanged(),
            tap(date => {                          
              if(!isFirst)
              {
                field.formControl.setValue(setCEDOnSDChange(date));
              }
              isFirst = false;
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);

  }

  isLastDateAValid(lDate: Date, sDate: Date) {

    if (isNullOrUndefined(lDate) || isNullOrUndefined(sDate)) {
      return true;
    }

    const dateOnly = new Date(lDate.getFullYear(), lDate.getMonth(), lDate.getDate(), 0);

    if (sDate && !isNullOrUndefined(sDate)) {
      const startDate = new Date(
        sDate.getFullYear(),
        sDate.getMonth(),
        sDate.getDate(), 0);
      return dateOnly < startDate;
    }

    return true;
  }

  validateLastDay(
    parentKey: string,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const validationMsg = 'Please enter a date before start date';
    let startDate: AbstractControl;
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        ldvalidator: {
          expression: (c) => {
            if (c && c.value && startDate && startDate.value) {
              return this.isLastDateAValid(c.value, startDate.value);
            } else {
              return true;
            }
          },
          message: (error, field: FormlyFieldConfig) => validationMsg
        }
      }
    };

    config.hooks = {
      onInit: field => {
        // const validationMsg = 'Please enter a date before start date';
        const lastDate = field.formControl;
        startDate = this.findFormControl(parentKey, field);

        startDate.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            distinctUntilChanged(),
            tap(date => {
              if (lastDate && lastDate.value) {
                lastDate.updateValueAndValidity();
                setTimeout(() => {
                  lastDate.markAsTouched();
                }, 1);
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);

  }
  validateEndDateOnStartDate(
    parentKey: string,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const validationMsg = 'Please enter a date after start date';
    let startDate: AbstractControl;
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        ldvalidator: {
          expression: (c) => {
            if (c && c.value && startDate && startDate.value) {
              return this.isLastDateAValid(startDate.value, c.value);
            } else {
              return true;
            }
          },
          message: (error, field: FormlyFieldConfig) => validationMsg
        }
      }
    };

    config.hooks = {
      onInit: field => {
        // const validationMsg = 'Please enter a date before start date';
        const lastDate = field.formControl;
        startDate = this.findFormControl(parentKey, field);

        startDate.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            distinctUntilChanged(),
            tap(date => {
              if (lastDate && lastDate.value) {
                lastDate.updateValueAndValidity();
                setTimeout(() => {
                  lastDate.markAsTouched();
                }, 1);
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);

  }

  validateStartDateStatusOnPBstatus(
    parentKey: string,
    validityChecker: (id, isPbStatus) => boolean,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
      }
    };

    config.hooks = {
      onInit: field => {
        const form = field.parent.formControl;
        const ele = form.get(parentKey);
        const validationMsg = 'Tentative status is not valid for joined profiles';

        field.formControl.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            distinctUntilChanged(),
            tap(id => {
              this.setError(validityChecker(id, false),
                field,
                { 'custom-error': validationMsg });
            })
          )
          .subscribe();

        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            distinctUntilChanged(),
            tap(id => {
              this.setError(validityChecker(id, true),
                field,
                { 'custom-error': validationMsg });
            })
          )
          .subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  validateStartDate(
    parentKey1: string,
    parentKey2: string,
    tooltipText: () => string,
    validityChecker: (value, type) => boolean,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
      }
    };

    config.hooks = {
      onInit: field => {
        const form = field.parent.formControl;
        const PbStatus = form.get(parentKey2);
        const message = 'Future date is not valid for joined status';

        field.formControl.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            distinctUntilChanged()
          )
          .subscribe(value => {
            const isValid = validityChecker(value, PbFieldTypes.StartDate);
            this.setError(!isValid, field, { 'custom-error': message });

            const tooltip = tooltipText();
            if (!field.formControl.pristine && tooltip != null && tooltip != "") {
              const tooltipPopup = tooltip.split('|');
              this.dialog.showPopUpMessage(tooltipPopup[1], null, tooltipPopup[0] + " - Joining cut off Dates");
            }
          }
          );

        PbStatus.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            distinctUntilChanged(),
            tap(id => {
              this.setError(!validityChecker(id, PbFieldTypes.PbStatus),
                field,
                { 'custom-error': message });
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }


  private setError(
    valid: boolean,
    field: FormlyFieldConfig,
    errorObj) {
    if (!valid) {
      field.formControl.setErrors(errorObj);
      field.formControl.markAsTouched();
    } else {

      if (!isNullOrUndefined(field.formControl.value)) {
        field.formControl.setErrors(null);
        field.formControl.markAsUntouched();
      }
    }
  }


  prepareEmployeeByRoleObservable(
    roleType: RoleType
  ): Observable<LookupField[]> {
    return this.userAPI.getEmployeesByRole(roleType).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  prepareEmployeeByRoleForGridFilterObservable(
    roleType: RoleType
  ): Observable<LookupField[]> {
    return this.userAPI.getEmployeesByRoleForGridFilter(roleType).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  prepareEmployeeByRoleInLocationId(
    roleType: RoleType,
    officeLocationId: number
  ): Observable<LookupField[]> {
    const fl = new FilterParams();
    fl.officeLocationId = [officeLocationId];

    return this.userAPI.getAllEmployeesByRoleAndOfficeLocation(roleType, this.immigrationCountry, fl).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareEmployeeByRoleInCountry(
    roleType: RoleType
  ): Observable<Employee[]> {
    const fl = new FilterParams();
    return this.userAPI.getAllEmployeesByRoleInCountry(roleType, this.immigrationCountry, fl).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareEmployeeByRoleInLegalEntityId(
    roleType: RoleType,
    officeLEId: number
  ): Observable<LookupField[]> {
    const fl = new FilterParams();
    fl.legalEntityId = [officeLEId];

    return this.userAPI.getAllEmployeesByRoleAndOfficeLegalEntity(roleType, this.immigrationCountry, fl).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareEmployeeInRolesObservable(
    roleTypes: RoleType[]
  ): Observable<LookupField[]> {
    return this.userAPI.getEmployeesInRoles(roleTypes).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareRolesObservable(): Observable<UserRole[]> {
    return this.userAPI.getRoles().pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  private tap_SelectFieldOptionsWithDisable(field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any, itemsToDisble: number[]) {

    let data = dataSource$.pipe(
      map(fields => {
        const clone = JSON.parse(JSON.stringify(fields))
        clone.forEach(x => {
          x.disabled = itemsToDisble.includes(x.id);
        })
        return clone;
      }));
    field.props.options = data.pipe(map(fields => fields.filter(f => f.parentFieldId === id)));

  }



  getSelectFieldWithParentDisableOptions(
    dataSource$: Observable<LookupField[]>,
    itemsToDisble: number[],
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldWithParentDisableOptions(this.tap_SelectFieldOptionsWithDisable, dataSource$, itemsToDisble, parentKey, additionalConfig);
  }

//   private _getSelectFieldWithParentDisableOptions(
//   tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, parentId: any, itemsToDisable: number[]) => void,
//   dataSource$: Observable<LookupField[]>,
//   itemsToDisable: number[],
//   parentKey?: string,
//   additionalConfig?: FormlyFieldConfig,
// ): FormlyFieldConfig {
//   const config: FormlyFieldConfig = {
//     templateOptions: {
//       options: dataSource$.pipe(
//         map(list =>
//           list.map(opt => ({
//             ...opt,
//             disabled: itemsToDisable.includes(+opt.id),
//           }))
//         )
//       ),
//       valueProp: "id",
//       labelProp: "displayText",
//       compareWith: (a: any, b: any) => a == b, // safe compare (string/number)
//     },
//     hooks: {
//       onInit: field => {
//         if (parentKey) {
//           const parentCtrl = this.findFormControl(parentKey, field);
//           if (parentCtrl) {
//             let isFirst = true;

//             parentCtrl.valueChanges
//               .pipe(startWith(parentCtrl.value), takeUntil(this.destroyed$))
//               .subscribe(parentId => {
//                 // reset only after init, if parent actually changed
//                 if (!isFirst && parentId !== null) {
//                   field.formControl.setValue(null, { emitEvent: false });
//                 }
//                 isFirst = false;

//                 // run tapFn with parentId + disabled items
//                 tapFn?.(field, dataSource$, parentId, itemsToDisable);
//               });
//           }
//         }
//       }
//     }
//   };

//   return getMergedConfig(config, additionalConfig);
// }
  getContractTypeSelectFieldWithParentDisableOptions(
    dataSource$: Observable<LookupField[]>,
    itemsToDisble: number[],
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getContractTypeSelectFieldWithParentDisableOptions(this.tap_SelectFieldOptionsWithDisable, dataSource$, itemsToDisble, parentKey, additionalConfig);
  }

private _contractTypeFilteringanddisabling(
  field: FormlyFieldConfig,
  dataSource$: Observable<LookupField[]>,
  itemsToDisable: number[],
  parentKey: string
) {
  const parentCtrl = this.findFormControl(parentKey, field);
  const countryCtrl = this.findFormControl('officeLocationCountry.id', field);
  if (!parentCtrl || !countryCtrl) return;

  field.templateOptions.options = combineLatest([
    dataSource$,
    parentCtrl.valueChanges.pipe(startWith(parentCtrl.value)),
    countryCtrl.valueChanges.pipe(startWith(countryCtrl.value)),
  ]).pipe(
    map(([list, parentId, countryId]) => {
      let filtered = [...list];

      // COUNTRY filter
      if (countryId !== 13410) {
        filtered = filtered.filter(x => ![16282].includes(x.id));
      }

      // PARENT filter
      if (parentId !== null && parentId !== undefined) {
        filtered = filtered.filter(opt => opt.parentFieldId === parentId);
      }

      // DISABLE logic
      return filtered.map(opt => ({
        ...opt,
        disabled: itemsToDisable.includes(+opt.id)
      }));
    }),
    takeUntil(this.destroyed$)
  );

  // When parent changes -> reset contractType
  // parentCtrl.valueChanges
  //   .pipe(takeUntil(this.destroyed$))
  //   .subscribe((parentId) => {
  //     field.formControl.setValue(null, { emitEvent: false });
  //   });
}
private _getContractTypeSelectFieldWithParentDisableOptions(
  tapFn: Function,
  dataSource$: Observable<LookupField[]>,
  itemsToDisable: number[],
  parentKey?: string,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {

  const config: FormlyFieldConfig = {
    templateOptions: {
      valueProp: "id",
      labelProp: "displayText",
      options: dataSource$,
    },
    hooks: {
      onInit: (field) => {
       // dataSource$.subscribe(res => {
       // // Apply Not Applicable logic for related fields 
       //// this._setNotApplicable(field);
       // });
        // Parent-based filtering and disable logic
        if (parentKey) {
          this._contractTypeFilteringanddisabling(field, dataSource$, itemsToDisable, parentKey);
        }
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}
  private _getSelectFieldWithParentDisableOptions(
  tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, parentId: any, itemsToDisable: number[]) => void,
  dataSource$: Observable<LookupField[]>,
  itemsToDisable: number[],
  parentKey?: string,
  additionalConfig?: FormlyFieldConfig,
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      options: dataSource$.pipe(
        map(list =>
          list.map(opt => ({
            ...opt,
            disabled: itemsToDisable.includes(+opt.id),
          }))
        )
      ),
      valueProp: "id",
      labelProp: "displayText",
      compareWith: (a: any, b: any) => a == b, // safe compare (string/number)
    },
    hooks: {
      onInit: field => {
        if (parentKey) {
          const parentCtrl = this.findFormControl(parentKey, field);
          if (parentCtrl) {
            let isFirst = true;

            parentCtrl.valueChanges
              .pipe(startWith(parentCtrl.value), takeUntil(this.destroyed$))
              .subscribe(parentId => {
                // reset only after init, if parent actually changed
                if (!isFirst && parentId !== null) {
                  field.formControl.setValue(null, { emitEvent: false });
                }
                isFirst = false;

                // run tapFn with parentId + disabled items
                tapFn?.(field, dataSource$, parentId, itemsToDisable);
              });
          }
        }
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}

 getEAallocatorSelectFieldOptions(
   dataSource$: Observable<EAAllocator[]>,
   parentKey?: string,
   additionalConfig?: FormlyFieldConfig,
   defaultValue?: any
 ): FormlyFieldConfig {
   return this._getEAAllocatorSelectFieldOptions(dataSource$, parentKey, additionalConfig);
 }

 private _getEAAllocatorSelectFieldOptions(
   dataSource$: Observable<EAAllocator[]>,
   parentKey?: string,
   additionalConfig?: FormlyFieldConfig
 ): FormlyFieldConfig {
   const config: FormlyFieldConfig = {
     templateOptions: {
       options: [], // Initialize as an empty array
       valueProp: "id",
       labelProp: "name"
     }
   };
   config.hooks = {
     onInit: field => {
       const ele = this.findFormControl('officeLocationCountry.id', field);
       ele.valueChanges
         .pipe(
           takeUntil(this.destroyed$),
           startWith(ele.value),
           tap(selectedCountryId => {
             dataSource$.subscribe(data => {
               if (parentKey === 'additional') {
                 // For additional EA allocators, list all allocators without setting a default value
               const uniqueAllocators = Array.from(new Set(data.map(allocator => allocator.emailAddress)))
                 .map(email => data.find(allocator => allocator.emailAddress === email));
               field.templateOptions.options = uniqueAllocators;
               field.formControl.enable();
               } else {
                 // Filter the options based on the selected officeLocationCountryId
                 const filteredOptions = data.filter(allocator =>
                   allocator.officeLocationCountryId === selectedCountryId
                 );
                 field.templateOptions.options = filteredOptions;
                 field.formControl.enable();
                 // Set default value only for EA Allocator field
                 const defaultAllocator = filteredOptions.find(allocator => allocator.isDefault);                
                 setTimeout(() => {
                 if (defaultAllocator && (field.formControl.value == null || field.formControl.value == undefined) ) {
                 field.formControl.setValue(defaultAllocator.id)
                  }
                  }, 0);
                   //field.formControl.setValue(defaultAllocator.id);
               }
             });
           })
         )
         .subscribe();
     }
   };

   return getMergedConfig(config, additionalConfig);
 }
getEAallocatorSelectFieldOptionsPreboarding(
  dataSource$: Observable<EAAllocator[]>,
  parentKey?: string,
  officeLocationCountryId$?: Observable<number>,
  additionalConfig?: FormlyFieldConfig,
  defaultValue?: any
): FormlyFieldConfig {
  return this._getEAallocatorSelectFieldOptionsPreboarding(dataSource$, parentKey, officeLocationCountryId$, additionalConfig);
}

private _getEAallocatorSelectFieldOptionsPreboarding(
  dataSource$: Observable<EAAllocator[]>,
  parentKey?: string,
  officeLocationCountryId$?: Observable<number>,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
        options: [], // Initialize as an empty array
      valueProp: "id",
      labelProp: "name"
    }
  };

  config.hooks = {
    onInit: field => {
      combineLatest([
        dataSource$,
        officeLocationCountryId$.pipe(filter(id => id != null && id !== undefined))
      ])
      .pipe(takeUntil(this.destroyed$))
      .subscribe(([data, countryId]) => {
        console.log("EA Allocator countryId:", countryId);
        if (parentKey === 'additional') {
          // For additional EA allocators, list all allocators without setting a default value
                const uniqueAllocators = Array.from(new Set(data.map(allocator => allocator.emailAddress)))
                  .map(email => data.find(allocator => allocator.emailAddress === email));
          field.templateOptions.options = uniqueAllocators;
          field.formControl.enable();
        } else {
                  // Filter the options based on the selected officeLocationCountryId
                  const filteredOptions = data.filter(allocator =>
                    allocator.officeLocationCountryId === countryId
                  );
          field.templateOptions.options = filteredOptions;
          field.formControl.enable();
                  // Set default value only for EA Allocator field
                  const defaultAllocator = filteredOptions.find(allocator => allocator.isDefault);                
          setTimeout(() => {
                  if (defaultAllocator && (field.formControl.value == null || field.formControl.value == undefined) ) {
                  field.formControl.setValue(defaultAllocator.id)
            }
          }, 0);
                    //field.formControl.setValue(defaultAllocator.id);
        }
      });
    }
  };

  return getMergedConfig(config, additionalConfig);
}
  getSelectFieldOptionsWithVendor(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionsWithVendor(this.tap_SelectFieldOptions, dataSource$, parentKey, additionalConfig);
  }
  private _getSelectFieldOptionsWithVendor(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl(parentKey, field);
          if (ele) {
            ele.valueChanges
              .pipe(
                takeUntil(this.destroyed$),
                startWith(ele.value),
                tap(id => {
                  const vendorField = this.VendorDetails || field;
                  const eduDoc = this.findFormControl('eduDocAttestationId', vendorField);
                  const famDoc = this.findFormControl('famDocAttestationId', vendorField);
                  const relocBenefit = this.findFormControl('reallocationBenefitID', vendorField);

                  const eduDocValue = eduDoc ? eduDoc.value : null;
                  const famDocValue = famDoc ? famDoc.value : null;
                  const relocBenefitValue = relocBenefit ? relocBenefit.value : null;

                  const service: number[] = [];
                  if (id == 15085 && eduDocValue == 15076)
                    service.push(15095);
                  if (id == 15085 && famDocValue == 15076)
                    service.push(15096);
                  if (id == 15086 && eduDocValue == 15076)
                    service.push(15100);
                  if (id == 15086 && famDocValue == 15076)
                    service.push(15101);
                  if (id == 15088 && (relocBenefitValue == 1043 || relocBenefitValue == 1044))
                    service.push(15106, 15107);
                  if (id == 16115 && (relocBenefitValue == 1043 || relocBenefitValue == 1044))
                    service.push(16116, 16117);

                  field.formControl.setValue(service);
                  // if (!field.form.disabled && (prevValueOfParent != id)) {
                  //   field.formControl.setValue(null);
                  //   prevValueOfParent = id;
                  // }
                  tapFn(field, dataSource$, id);
                })
              )
              .subscribe();
          }
        }
      };
    }

    return getMergedConfig(config, additionalConfig);
  }

  getOfficeTobeVisitedPak(dataSource$: Observable<LookupField[]>, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {

  const config: FormlyFieldConfig = {
    templateOptions: {
      options: dataSource$,
      valueProp: "id",
      labelProp: "displayText",
      }
    };
    config.hooks = {
      onInit: field => {
        const pakOffice = this.findFormControl('pakOfficeToVisit.id', field);
        const ele = field.formControl;

        if (pakOffice) {
          let isFirst = true;

          pakOffice.valueChanges
            .pipe(startWith(pakOffice.value), takeUntil(this.destroyed$))
            .subscribe(pb => {
              if (pb === 15165) {
                if (isFirst) {
                  ele.setValue(13411, { emitEvent: false });
                }
                ele.disable();
              } else {
                if (!field.form.disabled) {
                  ele.enable();
                  if (!isFirst) {
                    ele.setValue(null, { emitEvent: false });
                  }
                }
              }
              isFirst = false;
            });
        }
      }
    }

  return getMergedConfig(config, additionalConfig);
}
getFlightAndHotelBookingOptions(
  profileId: number, isnationalwithinsameofice: () => boolean,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {

  return this._getFlightAndHotelSelectFieldOptions(profileId,isnationalwithinsameofice, additionalConfig);
}

private _getFlightAndHotelSelectFieldOptions(
  profileId: number, isnationalwithinsameofice: () => boolean,
  additionalConfig?: FormlyFieldConfig,
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      valueProp: "id",
      labelProp: "displayText"
    }
  };
  config.hooks = {
    onInit: field => {
     this.prepareFlightBookingObservable
        (LookupTypeKeys.HOTEL_AND_FLIGHT_BOOKING, profileId).subscribe(
          res => {
            field.templateOptions.options = res;
          }
        )
        const transferEle = this.findFormControl('transferTypeID', field);       
        const ele = field.formControl;
        let isNatITsameOffice = false;
        ele.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(ele.value),
          tap(id => {
            this.findFormControl('hotelBookingStatusID', field)?.setValue(null);
        this.findFormControl('bookingInitiationDate', field)?.setValue(null);
        this.findFormControl('bookingCompletionDate', field)?.setValue(null);
            
          })
        )
        .subscribe();
        transferEle.valueChanges.subscribe(pb => {
          if (isnationalwithinsameofice instanceof Function) {
            isNatITsameOffice = isnationalwithinsameofice();
          }
          if (isNatITsameOffice) {
            let hotel = this.hotelAndHotelBooking$.getValue().find(n => n.id === 1020);
            ele.setValue(nullSafe(() => hotel.id, null));
          }

        });

    }
  }
  return getMergedConfig(config, additionalConfig);
}
prepareFlightBookingObservable(
  lookupTypeKey: number,
  profileId?: number
): Observable<LookupField[]> {

  if(isNullOrUndefined(profileId)){
    return this.lookupApi.getLookupFieldsByTypes([lookupTypeKey]).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  return this.candidateApi.getLookupFieldsByTypePbprofileId(lookupTypeKey, profileId).pipe(
    takeUntil(this.destroyed$),
    shareReplay()
  );
}
  getImmCaseTypeOptions(
    profileId?: number,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {

    return this._getImmCaseSelectFieldOptions(profileId, additionalConfig);
  }

  private _getImmCaseSelectFieldOptions(
    profileId: number,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        field.templateOptions.options = this.prepareImmCaseCandidadateObservable
          (LookupTypeKeys.IMMIGRATION_CASE_TYPE, profileId)
      }
    }
    return getMergedConfig(config, additionalConfig);
  }
  //List all the active records and if it is saved and it is disabled then that also will list
  getSelectActiveFieldOptionsWithFilter(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {


    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        dataSource$.subscribe(res => {
          let fieldOptions = res;
          const fieldValue = field.formControl.value
          fieldOptions = !isNullOrUndefined(fieldValue) && fieldOptions.filter(x => x.id == fieldValue)[0].disabled ? fieldOptions.filter(x => !x.disabled || x.id == fieldValue) : fieldOptions.filter(x => !x.disabled);
          field.templateOptions.options = fieldOptions;
        });
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getSelectFieldOptionsWithFilter(dataSource$: Observable<LookupField[]>, filterItems?: number[], disabledItems?: number[], additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        dataSource$.subscribe(res => {
          let fieldOptions = res;
          if (filterItems && filterItems.length > 0) {
            fieldOptions = fieldOptions.filter(f => filterItems.includes(f.id));
          }
          if (disabledItems && disabledItems.length > 0) {
            fieldOptions.forEach(x => {
              x.disabled = disabledItems.includes(x.id);
            })
          }
          field.templateOptions.options = fieldOptions;

          field.formControl.valueChanges.subscribe((fieldValue) => {
            if (field.key === 'immigrationCaseType.id') {
              const option = fieldOptions.find(x => x.id === fieldValue);
              if (option && option.disabled) {
                field.templateOptions.options = fieldOptions.filter(x => !x.disabled || x.id === fieldValue);
              } else {
                field.templateOptions.options = fieldOptions.filter(x => !x.disabled);
              }
            }
          });
          field.formControl.updateValueAndValidity();
        });
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  setDisableWhenMultiSelectIncludes(
    fieldKey: string,
    targetId: number,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    return setDisableWhen(
      (model) => {
        const selected = model[fieldKey] || [];

        const includesTarget = selected.some((item: any) =>
          typeof item === "object" ? item.id === targetId : item === targetId
        );
        const disable = !includesTarget;
        return disable;
      },
      additionalConfig
    );
  }

  getSelectFieldOptions(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string | null,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptions(this.tap_SelectFieldOptions, dataSource$, parentKey, additionalConfig);
  }
  getSelectActiveFieldOptionsWithParentFilter(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    fieldKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getActiveSelectFieldOptions(this.tap_ActiveSelectFieldOptions, dataSource$, parentKey, fieldKey, additionalConfig);
  }
  getSelectFieldOptionsWithEmployeeCategory(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionsWithEmployeeCategory(this.tap_SelectFieldOptions, dataSource$, parentKey, additionalConfig);
  }
  getSelectFieldOptionsEntryType(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionsEntryType(this.disableIds, dataSource$, parentKey, additionalConfig);
  }
  private _getSelectFieldOptionsEntryType(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl('isFirstVisitToJordan.id', field);
          ele.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(ele.value),
              tap(id => {
                if (!field.form.disabled) {
                  field.formControl.setValue(null);
                }
                tapFn(field, dataSource$, id);
              })
            )
            .subscribe();
        }
      };
    }

    return getMergedConfig(config, additionalConfig);
  }

  private disableIds(field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) {
    field.templateOptions.options = dataSource$.pipe(map(fields => {
      const fieldsCopy = [...fields];
      if (id == 1074) {
        fieldsCopy.forEach(f => {
          f.disabled = [15251, 15252].includes(f.id);
        })
      }
      else {
        fieldsCopy.forEach(f => {
          f.disabled = false;
        })
      }
      return fieldsCopy;
    }));
  }

    getUniversityDegree(
    //tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const ele = field.formControl;
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(id => {
              // if (!isNullOrUndefined(id) && (id === 2348)) {
              //   field.templateOptions.options = EMPTY;
              //   field.templateOptions.options = dataSource$;
              // }
              // else {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(x => x.filter(v => v.id !== 2348)));
              //}
              //field.templateOptions.options = !isNullOrUndefined(ele.value) && dataSource$.pipe(map(x => x.filter(v => v.id == ele.value)))[0].disabled ? res.filter(x => !x.disabled || x.id == fieldValue) : res.filter(x => !x.disabled);
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
    private _getSelectFieldOptionsWithEmployeeCategory(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const ele = this.findFormControl('employeeCategory.id', field);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(id => {
              if (!field.form.disabled && (prevValueOfParent != id)) {
               // field.formControl.setValue(null);
                prevValueOfParent = id;
              }
              if (!isNullOrUndefined(ele.value) && (ele.value === 12411)) {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(x => x.filter(v => [13410,5897].includes(v.id))));
                // field.formControl.enable();
              }
              else {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$;
                //field.formControl.enable();
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

// private _getSelectFieldOptions(
//   tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
//   dataSource$: Observable<LookupField[]>,
//   parentKey?: string,
//   additionalConfig?: FormlyFieldConfig,
// ): FormlyFieldConfig {
//   let prevValueOfParent = 0;
//   const config: FormlyFieldConfig = {
//     templateOptions: {
//       options: dataSource$,
//       valueProp: "id",
//       labelProp: "displayText"
//     }
//   };

//   if (parentKey && parentKey.length > 0) {
//     config.hooks = {
//       onInit: field => {
//         const ele = this.findFormControl(parentKey, field);
//         if (ele) {
//           let isFirst = true;
//           ele.valueChanges
//             .pipe(takeUntil(this.destroyed$))
//             .subscribe(id => {
//               if (isFirst) {
//                 tapFn(field, dataSource$, id);
//                 isFirst = false;
//               } else {
//                 if (!field.form.disabled && (prevValueOfParent != id)) {
//                   field.formControl.setValue(null);
//                 }
//                 tapFn(field, dataSource$, id);
//               }
//             });
//         }
//       }
//     };
//   } else {
//     config.hooks = {
//       onInit: field => {
//         if (field.key == "eduDocAttestationId") {
//           this.VendorDetails = field;
//         }
//       }
//     };
//   }

//   return getMergedConfig(config, additionalConfig);
// }
private _getSelectFieldOptions(
  tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, parentId: any) => void,
  dataSource$: Observable<LookupField[]>,
  parentKey?: string,
  additionalConfig?: FormlyFieldConfig,
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      options: dataSource$,
      valueProp: "id",
      labelProp: "displayText",
      compareWith: (a: any, b: any) => a == b, // safe compare (string/number)
    },
    hooks: {
      onInit: field => {
        if (parentKey) {
          const parentCtrl = this.findFormControl(parentKey, field);
          if (parentCtrl) {
            let isFirst = true;

            parentCtrl.valueChanges
              .pipe(startWith(parentCtrl.value), takeUntil(this.destroyed$))
              .subscribe(parentId => {
                // only reset after init, if parent changed
                if (!isFirst && parentId !== null) {
                  field.formControl.setValue(undefined, { emitEvent: false });
                }
                isFirst = false;

                //  run tapFn with current parentId
                tapFn?.(field, dataSource$, parentId);
              });
          }
        }
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}

  private _getActiveSelectFieldOptions(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any, fieldKey?: string) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    fieldKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl(parentKey, field);
          if (ele) {
            ele.valueChanges
              .pipe(
                takeUntil(this.destroyed$),
                startWith(ele.value),
                tap(id => {
                  if (!field.form.disabled && (prevValueOfParent != id)) {
                    field.formControl.setValue(null);
                    prevValueOfParent = id;
                  }
                  tapFn(field, dataSource$, id, fieldKey);
                })
              )
              .subscribe();
          }
        }
      };
    }

    return getMergedConfig(config, additionalConfig);
  }

  getSelectFieldOptionsWithDefault(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
    defaultValue?: any
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionsWithDefault(dataSource$, parentKey, additionalConfig, defaultValue);
  }

  private _getSelectFieldOptionsWithDefault(
    //tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
    defaultValue?: any
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    config.hooks = {
      onInit: field => {
        field.formControl.setValue(defaultValue);
        field.formControl.valueChanges.subscribe((value) => {
          setTimeout(() => {
            field.formControl.setValue(defaultValue)
          }, 0);
        });


      }
    }

    return getMergedConfig(config, additionalConfig);
  }

  getSelectFieldOptionsWithSL(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionsWithSL(this.tap_SelectFieldOptions, dataSource$, parentKey, additionalConfig);
  }

  private _getSelectFieldOptionsWithSL(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const ele = this.findFormControl('serviceLine.id', field);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(id => {
              if (!isNullOrUndefined(ele.value) && ele.value === 256) {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(x => x.filter(v => [704].includes(v.id))));//this.prepareLEForSLObservable(ele.value);                
                field.formControl.setValue(704);
                field.formControl.enable();
              } else if (!isNullOrUndefined(ele.value) && ele.value !== 256 && ele.value !== 258) {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(x => x.filter(v => [703].includes(v.id))));//this.prepareLEForSLObservable(slId);
                field.formControl.setValue(703);
                field.formControl.enable();
              }
              else {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(x => x.filter(v => [703, 704].includes(v.id))));
                //field.formControl.setValue(null);
                field.formControl.enable();
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
  getSelectFieldOptionsWithLE(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionsWithLE(this.tap_SelectFieldOptions, dataSource$, parentKey, additionalConfig);
  }

  private _getSelectFieldOptionsWithLE(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const ele = this.findFormControl('officeLE.id', field);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(id => {
              if (!isNullOrUndefined(ele.value) && ele.value === 704) {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(x => x.filter(v => [663, 668].includes(v.id))));
                field.formControl.enable();
              }
              else {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(x => x.filter(v => [655, 663, 668].includes(v.id))));
                //field.formControl.setValue(null);
                field.formControl.enable();
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
  getSelectFieldOptionsWithNationalityType(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionsWithNationalityType(this.tap_SelectFieldOptions, dataSource$, parentKey, additionalConfig);
  }

  private _getSelectFieldOptionsWithNationalityType(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const ele = this.findFormControl('nationalityType.id', field);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(id => {
              if (!isNullOrUndefined(ele.value) && (ele.value === 14572 || ele.value === 14571)) {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$.pipe(map(x => x.filter(v => [175, 241, 203, 188, 26, 127].includes(v.id))));
                field.formControl.enable();
              }
              else {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$;
                field.formControl.enable();
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getCurrentLocSelectFieldOptions(
    dataSource$: Observable<LookupField[]>,
    validationKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getCurrentLocSelectFieldOptions(dataSource$, validationKey, additionalConfig);
  }

  private _getCurrentLocSelectFieldOptions(
    dataSource$: Observable<LookupField[]>,
    validationKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText",
        searchInput$: (term) => {
          if ((!term || term === '')) {
            return dataSource$;
          }
          return dataSource$.pipe(map(items =>
            items.filter(v => v.displayText.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)))
            ;
        }
      }
    };


    if (validationKey && validationKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl(validationKey, field);
          ele.valueChanges
            .pipe(
              tap(id => {
                if (!isNullOrUndefined(ele.value)) {
                  field.formControl.setValue(this.offcLocationAsBS$.getValue().find(x => x.id == ele.value));
                  field.formControl.disable();
                } else {
                  field.formControl.setValue(null);
                  field.formControl.enable();
                }

              })
            )
            .subscribe();
        }
      };
    }
    return getMergedConfig(config, additionalConfig);
  }


  getCategoryOptions(
    visatype: string,
    dataSource$: Observable<LookupField[]>,
    validationKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getCategoryOptions(visatype, dataSource$, validationKey, additionalConfig);
  }

  private _getCategoryOptions(
    visatype: string,
    dataSource$: Observable<LookupField[]>,
    validationKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText",
        searchInput$: (term) => {
          if ((!term || term === '')) {
            return dataSource$;
          }
          return dataSource$.pipe(map(items =>
            items.filter(v => v.displayText.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)));
        }
      }
    };


    if (validationKey && validationKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl(validationKey, field);
          ele.valueChanges
            .pipe(
              tap(id => {
                if (!isNullOrUndefined(ele.value)) {
                  var cat;
                  if (visatype == "Missionvisa") {
                    if (ele.value == 1074) {
                      cat = 10300;
                    } else if (ele.value == 1075) {
                      cat = 10301;
                    }
                    field.formControl.setValue(this.missionVisaCateogryAsBS$.getValue().find(x => x.id == cat));
                  }
                  if (visatype == "Relativeworkpermit") {
                    if (ele.value == 1074) {
                      cat = 10940;
                    } else if (ele.value == 1075) {
                      cat = 10941;
                    }
                    field.formControl.setValue(this.categoryOfJobOfferAsBS$.getValue().find(x => x.id == cat));
                  }
                } else {
                  field.formControl.setValue(null);
                }
                field.formControl.disable();
              })
            )
            .subscribe();
        }
      };
    }
    return getMergedConfig(config, additionalConfig);
  }



  getParentKeySubscription(parentKey, dataSource$, field, tapFn: Function) {
    const ele = this.findFormControl(parentKey, field);
    return ele.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        startWith(ele.value),
        tap(id => {
          if (!field.form.disabled) {
            field.formControl.setValue(null);
          }
          tapFn(field, dataSource$, id);
        })
      )
      .subscribe();
  }
  getSelectFieldOptionswithValue(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionswithValue(this.tap_SelectFieldOptions, dataSource$, parentKey, additionalConfig);
  }

  private _getSelectFieldOptionswithValue(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    if (parentKey && parentKey.length > 0) {      
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl(parentKey, field);
          ele.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(ele.value),
              tap(id => {
                 tapFn(field, dataSource$, id);
              })
            )
            .subscribe();
        }
      };
    }

    return getMergedConfig(config, additionalConfig);
  }

  getTypeAheadSelectFieldOptions(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getTypeAheadSelectFieldOptions(this.tap_SelectFieldOptions, dataSource$, parentKey, additionalConfig);
  }

  private _getTypeAheadSelectFieldOptions(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {

        valueProp: "id",
        labelProp: "displayText",
        searchInput$: (term) => {
          if ((!term || term === '')) {
            return dataSource$;
          }
          return dataSource$.pipe(map(items =>
            items.filter(v => v.displayText.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)))
            ;
        },
      }
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl(parentKey, field);
          ele.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(ele.value),
              tap(id => {
                if (!field.form.disabled) {
                  field.formControl.setValue(null);
                }
                tapFn(field, dataSource$, id);
              })
            )
            .subscribe();
        }
      };
    }

    return getMergedConfig(config, additionalConfig);
  }

  getTypeAheadEmployeeSelectFieldOptions(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getTypeAheadEmployeeSelectFieldOptions(this.tap_SelectFieldOptions, dataSource$, parentKey, additionalConfig);
  }

  private _getTypeAheadEmployeeSelectFieldOptions(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<Employee[]>, id: any) => void,
    dataSource$: Observable<Employee[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {

        valueProp: "id",
        labelProp: "name",
        searchInput$: (term) => {
          if ((!term || term === '')) {
            return dataSource$;
          }
          return dataSource$.pipe(map(items =>
            items.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)))
            ;
        },
      }
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl(parentKey, field);
          ele.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(ele.value),
              tap(id => {
                if (!field.form.disabled) {
                  field.formControl.setValue(null);
                }
                tapFn(field, dataSource$, id);
              })
            )
            .subscribe();
        }
      };
    }

    return getMergedConfig(config, additionalConfig);
  }




  private resetField(field: FormlyFieldConfig) {
    if (!field.form.disabled) {
      const currVal = field.formControl.value;
      if (currVal) {
        field.formControl.setValue(currVal);
      } else {
        field.formControl.setValue(null);
      }
    }
  }

  private tap_SelectFieldOptions(field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) {

    field.props.options = dataSource$.pipe(map(fields => fields.filter(f => f.parentFieldId === id)));
    //  if(id==257){
    //      field.templateOptions.options.subscribe(x=>console.log(x))
    // }

  }

  private tap_ActiveSelectFieldOptions(field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any, fieldKey?: string) {

    dataSource$.pipe(
      map(fields => fields.filter(f => f.parentFieldId === id))
    ).subscribe(filteredOptions => {
      field.templateOptions.options = filteredOptions;

      field.formControl.valueChanges.subscribe((fieldValue) => {
        if (field.key === fieldKey) {
          const option = filteredOptions.find(x => x.id === fieldValue);
          if (option && option.disabled) {
            // If the selected option is disabled, filter the options to show only enabled options or the selected one
            field.templateOptions.options = filteredOptions.filter(x => !x.disabled || x.id === fieldValue);
          } else {
            //show all enabled options
            field.templateOptions.options = filteredOptions.filter(x => !x.disabled);
          }
        }
      });

      field.formControl.updateValueAndValidity();
    });

  }


  getEmpCategoryOptions(
    dataSource$: Observable<LookupField[]>,
    pbTypeKey?: string,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    return this._getSelectFieldOptions(this.tap_EmpCategoryOptions, dataSource$, pbTypeKey, additionalConfig);
  }

  private tap_EmpCategoryOptions(field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) {
    field.templateOptions.options = dataSource$.pipe(map(fields => fields.filter(f => {
      if ([1079, 1080, 1081].findIndex(x => x === id) > -1) {
        return f.id === 717;
      }
      return f.id !== 717;
    })));
  }


  getScenarioSelectFieldsWithValue(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    return this._getSelectFieldOptionswithValue(this.tap_ScenarioSelectFields, dataSource$, parentKey, additionalConfig);
  }

  private tap_ScenarioSelectFields(field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) {
    const excluded = LookupFieldKeys.EXCLUDED_TRANSFER_SCENARIO_IDS;
    dataSource$.subscribe(res => {
      const fieldOptions = id === 975
        ? res.filter(f => f.parentFieldId === id)
        : res.filter(f => f.parentFieldId === null);

      field.templateOptions.options = fieldOptions;

      field.formControl.valueChanges.subscribe((fieldValue) => {
        const isExcluded = excluded.includes(fieldValue);
        if (isExcluded) {
          field.templateOptions.options = fieldOptions.filter(x => !excluded.includes(x.id) || x.id === fieldValue);
        } else {
          field.templateOptions.options = fieldOptions.filter(x => !excluded.includes(x.id));
        }
      });

      field.formControl.updateValueAndValidity();
    });
  }

  prepareCommonLookupObservable(): Observable<LookupField[]> {
    return this.lookupApi.getLookupFieldsByTypes(this.SHARED_LOOKUP_TYPES).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareDepartmentsObservable(
    leId: number,
    smuId: number,
    specialityId: number
  ): Observable<DeptCodeblock[]> {
    if (!leId || (!smuId && !specialityId)) {
      return EMPTY;
    }
    const cb$ = this.lookupApi.getDeptCodeblocks(leId, smuId || 0, specialityId || 0).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    cb$.subscribe(dcb => {
      this.deptCodeBlock$.next(dcb);
    });
    return cb$;
  }

  prepareRankGradeObservable(
    cId: number,
    slId: number
  ): Observable<RankGrade[]> {
    if (!cId || !slId) {
      return EMPTY;
    }
    const cb$ = this.lookupApi.getRank(cId, slId).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    cb$.subscribe(dcb => {
      this.rankGrade$.next(dcb);
    });
    return cb$;
  }

  prepareExitRankGradeObservable(
    lId: number,
    slId: number
  ): Observable<RankGrade[]> {
    if (!lId || !slId) {
      return EMPTY;
    }
    const cb$ = this.lookupApi.getExitRank(lId, slId).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    cb$.subscribe(dcb => {
      this.rankGrade$.next(dcb);
    });
    return cb$;
  }

  prepareMenaCountryLocations(): Observable<LookupField[]> {
    return this.lookupApi.getLookupFieldsByType(LookupTypeKeys.NATIONALITY, undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  prepareMenaOfcLocations(): Observable<LookupField[]> {
    return this.lookupApi.getLookupFieldsByType(LookupTypeKeys.OFFICE_LOCATION, undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareOfcLocationsWithCountryCode(): Observable<LookupField[]> {
    return this.lookupApi.getOfficeLocations(this.immigrationCountry).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  prepareKSAOfcLocationsWithCountryCode(): Observable<LookupField[]> {
    return this.lookupApi.getOfficeLocations("SAU").pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  prepareOfcLocationsWithCountryCodeAsBehaviourSub(): Observable<LookupField[]> {
    const offc = this.lookupApi.getOfficeLocations(this.immigrationCountry).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    )
    offc.subscribe(resp => this.offcLocationAsBS$.next(resp));
    return offc;
  }


  prepareMissionVisaCateogryAsBehaviourSub(): Observable<LookupField[]> {
    const visa = this.prepareLookupObservable(LookupTypeKeys.MISSION_VISA_CATEGORY).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    )
    visa.subscribe(resp => this.missionVisaCateogryAsBS$.next(resp));
    return visa;
  }
  prepareCategoryOfJobOfferAsBehaviourSub(): Observable<LookupField[]> {
    const visa = this.prepareLookupObservable(LookupTypeKeys.CATEGORY_OF_JOBOFFER).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    )
    visa.subscribe(resp => this.categoryOfJobOfferAsBS$.next(resp));
    return visa;
  }

  prepareOfcLEWithConCode(): Observable<LookupField[]> {
    return this.lookupApi.getOfficeLEByCountryCode(this.immigrationCountry).pipe(
      takeUntil(this.destroyed$),
      map(item => {
        item.forEach(i => {
          i.disabled = !i.isActive;
          return i;
        })
        return item;
      }),
      shareReplay()
    );
  }

  GetAllForeignOfficeLocation(): Observable<LookupField[]> {
    return this.lookupApi.getAllForeignOffices(this.immigrationCountry).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  GetAllOfficeLocation(): Observable<OfficeLocation[]> {
    return this.lookupApi.getAllOfficeLocations(this.immigrationCountry).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  GetOfficeLocationsAllCountries(): Observable<OfficeLocation[]> {
    return this.lookupApi.getAllOfficeLocations("").pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }


  GetUsersByClaimValue(claimValue: string, countryValue: string): Observable<LookupField[]> {
    return this.userAPI.getUsersByClaimValue(claimValue, countryValue).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  GetLegalEntitesByCountryCode(): Observable<LookupField[]> {
    return this.lookupApi.getOfficeLEByCountryCode(this.immigrationCountry).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  prepareKSALegalEntitiesWithCountryCode(): Observable<LookupField[]> {
    return this.lookupApi.getOfficeLEByCountryCode("SAU").pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  GetDocumentInstructions(): Observable<DocumentInstructions[]> {
    return this.empProfile.getDocumentInstructions().pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareImmCaseCandidadateObservable(
    lookupTypeKey: number,
    candidateId?: number
  ): Observable<LookupField[]> {

    return this.candidateApi.getCandidateImmCaseType(lookupTypeKey, candidateId).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

C
  prepareEmployeeCategoryLookupObservable(
    lookupTypeKey: number,
  ): Observable<LookupField[]> {
    const employeeId = this.authService.ActiveUser.employeeId;
    if (employeeId > 0) {
      return this.lookupApi.getEmployeeCategoryOptions(employeeId,lookupTypeKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }
  }
  prepareContractTypeLookupObservable(
    lookupTypeKey: number,
  ): Observable<LookupField[]> {
    const employeeId = this.authService.ActiveUser.employeeId;
    if (employeeId > 0) {
      return this.lookupApi.getContractTypeOptions(employeeId,lookupTypeKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }
  }


  prepareLookupObservable(
    lookupTypeKey: number,
    parentId?: number,
    filterKey?: number
  ): Observable<LookupField[]> {
    if (!!parentId && parentId > 0 && !!filterKey && filterKey > 0) {
      return this.lookupApi.getLookupFieldsByType(lookupTypeKey, parentId, filterKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (!!parentId && parentId > 0) {
      return this.lookupApi.getLookupFieldsByType(lookupTypeKey, parentId, undefined).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (this.SHARED_LOOKUP_TYPES.indexOf(lookupTypeKey) > -1) {
      return this.lookups$.pipe(
        takeUntil(this.destroyed$),
        map(lfArr => lfArr.filter(lf => lf.lookupTypeId == lookupTypeKey)),
        shareReplay()
      );
    }

    return this.lookupApi.getLookupFieldsByType(lookupTypeKey, undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareImmCaseTypeObservable(
    lookupTypeKey: number,
    parentId?: number,
    filterKey?: number
  ): Observable<LookupField[]> {

    return this.lookupApi.getLookupFieldsByType(lookupTypeKey, undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareOfficeEntityObservable(
    parentId?: number,
    filterKey?: number
  ): Observable<OfficeEntity[]> {
    if (!!parentId && parentId > 0 && !!filterKey && filterKey > 0) {
      return this.lookupApi.getOfficeEntities(parentId, filterKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (!!parentId && parentId > 0) {
      return this.lookupApi.getOfficeEntities(parentId, undefined).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    return this.lookupApi.getOfficeEntities(undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
    officeEntityByCurrentLocationCountryObservable(
    parentId?: number,
    filterKey?: number
  ): Observable<OfficeEntity[]> {
    if (!!parentId && parentId > 0 && !!filterKey && filterKey > 0) {
      return this.lookupApi.getOfficeEntitiesByNationality(parentId, filterKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (!!parentId && parentId > 0) {
      return this.lookupApi.getOfficeEntitiesByNationality(parentId, undefined).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    return this.lookupApi.getOfficeEntitiesByNationality(undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
   getParentIdByCurrentLocationCountryObservable(
    parentId?: number,
    profileId? :number
  ): Observable<number|ValueTupleOfIntegerAndInteger> {
   
    if (!!parentId && parentId > 0) {
      return this.lookupApi.getLookUpFieldParent(parentId,profileId).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }
  }
  prepareCitiesObservable(
    parentId?: number,
    filterKey?: number
  ): Observable<Cities[]> {
    if (!!parentId && parentId > 0 && !!filterKey && filterKey > 0) {
      return this.lookupApi.getCities(parentId, filterKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (!!parentId && parentId > 0) {
      return this.lookupApi.getCities(parentId, undefined).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    return this.lookupApi.getCities(undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareDOSObservable(
    lookupTypeKey: number,
    filterKey?: number
  ): Observable<LookupField[]> {

    const cb$ = this.lookupApi.getLookupFieldsWithParentAndFilterKey(lookupTypeKey, undefined, filterKey).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );

    cb$.subscribe(dcb => {
      this.durationOfStay$.next(dcb);
    });
    return cb$;
  }

  prepareServiceLineObservable(
    parentId?: number,
    filterKey?: number
  ): Observable<ServiceLine[]> {
    if (!!parentId && parentId > 0 && !!filterKey && filterKey > 0) {
      return this.lookupApi.getServiceLines(parentId, filterKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (!!parentId && parentId > 0) {
      return this.lookupApi.getServiceLines(parentId, undefined).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    return this.lookupApi.getServiceLines(undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

   prepareEAallocatorObservable(
    parentId?: number,
    filterKey?: number
  ): Observable<EAAllocator[]> {

    return this.candidateApi.getEAallocators().pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareAuthHubObservable(
    parentId?: number,
    filterKey?: number
  ): Observable<AuthorisedHub[]> {
    if (!!parentId && parentId > 0 && !!filterKey && filterKey > 0) {
      return this.lookupApi.getAuthorisedHubs(parentId, filterKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (!!parentId && parentId > 0) {
      return this.lookupApi.getAuthorisedHubs(parentId, undefined).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    return this.lookupApi.getAuthorisedHubs(undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareSubServiceLineObservable(
    parentId?: number,
    filterKey?: number
  ): Observable<SubServiceLine[]> {
    if (!!parentId && parentId > 0 && !!filterKey && filterKey > 0) {
      return this.lookupApi.getSubServiceLines(parentId, filterKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (!!parentId && parentId > 0) {
      return this.lookupApi.getSubServiceLines(parentId, undefined).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    return this.lookupApi.getSubServiceLines(undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareSpecialityObservable(
    parentId?: number,
    filterKey?: number
  ): Observable<Speciality[]> {
    if (!!parentId && parentId > 0 && !!filterKey && filterKey > 0) {
      return this.lookupApi.getSpecialities(parentId, filterKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (!!parentId && parentId > 0) {
      return this.lookupApi.getSpecialities(parentId, undefined).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    return this.lookupApi.getSpecialities(undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareSMUObservable(
    parentId?: number,
    filterKey?: number
  ): Observable<SMU[]> {
    if (!!parentId && parentId > 0 && !!filterKey && filterKey > 0) {
      return this.lookupApi.getSMUs(parentId, filterKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (!!parentId && parentId > 0) {
      return this.lookupApi.getSMUs(parentId, undefined).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    return this.lookupApi.getSMUs(undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  prepareSectorObservable(
    parentId?: number,
    filterKey?: number
  ): Observable<Sector[]> {
    if (!!parentId && parentId > 0 && !!filterKey && filterKey > 0) {
      return this.lookupApi.getSectors(parentId, filterKey).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    if (!!parentId && parentId > 0) {
      return this.lookupApi.getSectors(parentId, undefined).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

    return this.lookupApi.getSectors(undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  getTravelDate(additionalConfig: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      expressionProperties: {
        'templateOptions.placeholder': (formData: any, formState: any, field: FormlyFieldConfig) => {
          if (!isNullOrUndefined(formData.dependentCurrentLocation) && formData.dependentCurrentLocation.id === 26)
            return 'Not Applicable';
        },
        'templateOptions.required': (formData: any, formState: any, field: FormlyFieldConfig) => {
          if (!isNullOrUndefined(formData.dependentCurrentLocation) && formData.dependentCurrentLocation.id === 26)
            return false;
          else
            return true;
        },
        'templateOptions.disabled': (formData: any, formState: any, field: FormlyFieldConfig) => {
          var disable = false;
          if (!isNullOrUndefined(formData.dependentCurrentLocation) && formData.dependentCurrentLocation.id === 26)
            disable = true;

          if (disable && field.formControl.value !== null) {
            field.formControl.setValue(null);
          }
          return disable;
        }
      }
    };

    config.hooks = {
      onInit: field => {
        const currentcountry = this.findFormControl('dependentCurrentLocation.id', field);
        const ele = field.formControl;
        currentcountry.valueChanges.subscribe(cc => {
          if (currentcountry.value == 26) {
            ele.disable();
            ele.setValue(null);
          }
          else {
            ele.enable();
          }
        }

        )
      }
    }
    return getMergedConfig(config, additionalConfig);
  }
  getRelocationBenefits(relocationBenefit$: Observable<LookupField[]>, isnationalwithinsameofice: () => boolean, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: relocationBenefit$,
        valueProp: "id",
        labelProp: "displayText",
      }
    };
    config.hooks = {
      onInit: field => {
        const transferEle = this.findFormControl('transferTypeID', field);
        const ele = field.formControl;
        var isNatITsameOffice = false;
        transferEle.valueChanges.subscribe(pb => {
          if (isnationalwithinsameofice instanceof Function) {
            isNatITsameOffice = isnationalwithinsameofice();
          }
          if (isNatITsameOffice) {
            let relocation = this.relocationBenefit$.getValue().find(n => n.id === 1041);
            ele.setValue(nullSafe(() => relocation.id, null));

          }

        })
      }
    }
    return getMergedConfig(config, additionalConfig);
  }
  getFlightBookingStatus(FlightBookingStatus$: Observable<LookupField[]>, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: FlightBookingStatus$,
        valueProp: "id",
        labelProp: "displayText",
      }
    };
    return getMergedConfig(config, additionalConfig);

}
  getflightAndHotelBooking(
    isnationalwithinsameofice: () => boolean, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {

    const config: FormlyFieldConfig = {
      templateOptions: {
        //options: hotelAndFlightBooking$,
        valueProp: "id",
        labelProp: "displayText",
       
      }
    };
    
    config.hooks = {
      onInit: field => {
        const transferEle = this.findFormControl('transferTypeID', field);
        const ele = field.formControl;
        let isNatITsameOffice = false;
       
        
        
        transferEle.valueChanges.subscribe(pb => {
          if (isnationalwithinsameofice instanceof Function) {
            isNatITsameOffice = isnationalwithinsameofice();
          }
          if (isNatITsameOffice) {
            let hotel = this.hotelAndHotelBooking$.getValue().find(n => n.id === 1020);
            ele.setValue(nullSafe(() => hotel.id, null));
          }

        });

      }
    };
    return getMergedConfig(config, additionalConfig);
  }
  getflightAndHotelBookingStatus(hoelBookingStatus$: Observable<LookupField[]>, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: hoelBookingStatus$,
        valueProp: "id",
        labelProp: "displayText",
      }
    };
    config.hooks = {
      onInit: field => {
        const ele = this.findFormControl('hotelBookingID', field);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(id => {
              // if (!isNullOrUndefined(ele.value) && ele.value === 7025) {
              //   field.templateOptions.options = EMPTY;
              //   field.templateOptions.options = hoelBookingStatus$.pipe(map(x => x.filter(v => [7040,7041,7042,7043,7044].includes(v.id))));
              //   field.formControl.enable();
              // }
              // else if (!isNullOrUndefined(ele.value) && ele.value === 7026) {
              //   field.templateOptions.options = EMPTY;
              //   field.templateOptions.options = hoelBookingStatus$.pipe(map(x => x.filter(v => [7040,7041,7042,7043,7045].includes(v.id))));
              //   field.formControl.enable();
              // }
              //else 
                if(!isNullOrUndefined(ele.value) && ele.value === 1020) {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = hoelBookingStatus$.pipe(map(x => x.filter(v => [7040].includes(v.id))));
                field.formControl.setValue(7040)
                field.formControl.disable();
              }
              else{
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = hoelBookingStatus$;             
                field.formControl.enable();

              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);

}
getDateOfInitiation(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      valueProp: "id",
      labelProp: "displayText",
    }
  };
  config.hooks = {
    onInit: field => {
      const ele = this.findFormControl('hotelBookingStatusID', field);
      ele.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(ele.value),
          tap(id => {
            if (isNullOrUndefined(ele.value) || [7040,7041,7042].includes(ele.value)) {
              field.formControl.setValue(null)
              field.formControl.disable();
            }
            else  {
              field.formControl.setValue(field.formControl.value?field.formControl.value:new Date())
                   field.formControl.enable();
            }
          })
        )
        .subscribe();
    }
  };
  return getMergedConfig(config, additionalConfig);

}
getDateOfCompletion(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      valueProp: "id",
      labelProp: "displayText",
    }
  };
  config.hooks = {
    onInit: field => {
      const ele = this.findFormControl('hotelBookingStatusID', field);
      ele.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(ele.value),
          tap(id => {
            if (isNullOrUndefined(ele.value) || [7040,7041,7042,7043].includes(ele.value)) {
              field.formControl.setValue(null)
              field.formControl.disable();
            }
            else  {
              field.formControl.setValue(field.formControl.value?field.formControl.value:new Date())
                   field.formControl.enable();
            }
          })
        )
        .subscribe();
    }
  };
  return getMergedConfig(config, additionalConfig);

}
getDateOfInitiationEmp(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      valueProp: "id",
      labelProp: "displayText",
    }
  };
  config.hooks = {
    onInit: field => {
      const ele = this.findFormControl('flightBookingstatusIDEmp', field);
      ele.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(ele.value),
          tap(id => {
            if (isNullOrUndefined(ele.value) || [7030, 7031, 7032].includes(ele.value)) {
              field.formControl.setValue(null)
              field.formControl.disable();
            }            
            else  {
              field.formControl.setValue(field.formControl.value?field.formControl.value:new Date())
                   field.formControl.enable();
            }
          })
        )
        .subscribe();
    }
  };
  return getMergedConfig(config, additionalConfig);

}
getDateOfCompletionEmp(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      valueProp: "id",
      labelProp: "displayText",
    }
  };
  config.hooks = {
    onInit: field => {
      const ele = this.findFormControl('flightBookingstatusIDEmp', field);
      ele.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(ele.value),
          tap(id => {
            if (isNullOrUndefined(ele.value) || [7030, 7031, 7032,7033].includes(ele.value)) {
              field.formControl.setValue(null)
              field.formControl.disable();
            }
            else  {
              field.formControl.setValue(field.formControl.value?field.formControl.value:new Date())
                   field.formControl.enable();
            }
          })
        )
        .subscribe();
    }
  };
  return getMergedConfig(config, additionalConfig);

}
getDateOfInitiationDep(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      valueProp: "id",
      labelProp: "displayText",
    }
  };
  config.hooks = {
    onInit: field => {
      const ele = this.findFormControl('flightBookingstatusIDDep', field);
      const startDate = this.findFormControl('startdate', field);
      let days;
      startDate.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        distinctUntilChanged(),
        tap(date => {
          if (date) {
            days = differenceInCalendarDays( new Date(),date);
          }
        })
      )
      .subscribe();
   
      
      ele.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(ele.value),
          tap(id => {
            if(days>365){
              field.formControl.disable();
            }
            else if (isNullOrUndefined(ele.value) || [7035,7036,7037].includes(ele.value)) {
              field.formControl.setValue(null)
              field.formControl.disable();
            }
            else  {
              field.formControl.setValue(field.formControl.value?field.formControl.value:new Date())
              field.formControl.enable();
            }
          })
        )
        .subscribe();
    }
  };
  return getMergedConfig(config, additionalConfig);

}
getDateOfCompletionDep(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      valueProp: "id",
      labelProp: "displayText",
    }
  };
  config.hooks = {
    onInit: field => {
      const ele = this.findFormControl('flightBookingstatusIDDep', field);
      const startDate = this.findFormControl('startdate', field);
      let days;
      startDate.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        distinctUntilChanged(),
        tap(date => {
          if (date) {
            days = differenceInCalendarDays( new Date(),date);
          }
        })
      )
      .subscribe();

      ele.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(ele.value),
          tap(id => {
            if(days >365){
              field.formControl.disable();
            }
            else if (isNullOrUndefined(ele.value) || [7035,7036,7037,7038].includes(ele.value)) {
              field.formControl.setValue(null)
              field.formControl.disable();
            }
            else  {
              field.formControl.setValue(field.formControl.value?field.formControl.value:new Date())
              field.formControl.enable();
            }
          })
        )
        .subscribe();
    }
  };
  return getMergedConfig(config, additionalConfig);

}
  getNationalityFieldOptions(additionalConfig?: FormlyFieldConfig, isInvite = false): FormlyFieldConfig {
    const isPB = this.route.url.indexOf('pre-boarding/pb-profile') > 0;
    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    nat$.subscribe(n => this.nationality$.next(n));
    const olc$ = this.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION_COUNTRY);
    olc$.subscribe(o => this.officeLocation$.next(o));

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: nat$,
        valueProp: "id",
        labelProp: "displayText",
        disabled: isInvite

      }
    };
    config.hooks = {
      onInit: field => {
        const pbTypeEle = this.findFormControl('onboardingType.id', field);
        const officeCountryEle = this.findFormControl('officeLocationCountry.id', field);
        const ele = field.formControl;
        if (isPB) {
          ele.disable();
        }
        pbTypeEle.valueChanges.subscribe(pb => {
          if (pbTypeEle.value === 1046 || isInvite) {
            const country = this.officeLocation$.getValue().find(o => o.id === officeCountryEle.value);
            let nationalty = this.nationality$.getValue().find(n => n.value === nullSafe(() => country.value, ''));
            if (officeCountryEle.value == 13410) {
              nationalty = this.nationality$.getValue().find(n => n.id === 176);
            }
            ele.setValue(nullSafe(() => nationalty.id, null));
            ele.disable();
            if (isInvite) {
              ele.setValue(null);
            }
          } else {
            if (!field.form.disabled) {
              ele.enable();
              // ele.setValue(null);
            }
          }

          if (isPB) {
            ele.disable();
          }
        });
        officeCountryEle.valueChanges.subscribe(oc => {
          if (pbTypeEle.value === 1046 || isInvite) {
            const country = this.officeLocation$.getValue().find(o => o.id === oc);
            let nationalty = this.nationality$.getValue().find(n => n.value === nullSafe(() => country.value, ''));
            if (officeCountryEle.value == 13410) {
              nationalty = this.nationality$.getValue().find(n => n.id === 176);
            }
            ele.setValue(nullSafe(() => nationalty.id, null));
            ele.disable();
            if (isInvite) {
              ele.setValue(null);
            }
          } else {
            const country = this.officeLocation$.getValue().find(o => o.id === oc);
            if (!isNullOrUndefined(oc)) {
              field.templateOptions.options = this.nationality$.getValue().map(nat => {
                nat.disabled = nat.value === country.value;
                return nat;
              })
            };
            if (!field.form.disabled) {
              ele.enable();
              // ele.setValue(null);
            }
          }
          if (isPB) {
            ele.disable();
          }
        });
      }
    };

    return getMergedConfig(config, additionalConfig);
  }
getProbationFieldVaule(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: 'probationMonth',
        labelProp: 'probationMonth'
      }
    };
    config.hooks = {
      onInit: field => {
        const officeCountryEle = this.findFormControl('officeLocationCountry.id', field);
        const empCatEle = this.findFormControl('employeeCategory.id', field);
        const ele = field.formControl;
 
        const loadOptionsForCountry = (countryId: any, preserveExisting: boolean) => {
          if (countryId == null || countryId === '' || countryId === undefined) {
            field.templateOptions.options = [];
            if (!preserveExisting) {
              ele.setValue(null);
            }
            return;
          }
          this.lookupApi.getProbationMonthOptions(countryId)
            .pipe(
              take(1),
              map(opts => opts || []),
              catchError(() => of([]))
            )
            .subscribe(probationOptions => {
              field.templateOptions.options = probationOptions;
              if (preserveExisting && ele.value != null && ele.value !== '') {
                return; 
              }
              if (probationOptions.length === 1) {
                ele.setValue(probationOptions[0].probationMonth);
              } else {
                ele.setValue(null);
              }
            });
        };
 
        let isFirstLoad = true;
        let prevEmpCat = empCatEle.value;
      
        if (empCatEle) {
          
          empCatEle.valueChanges
            .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
            .subscribe(emp => {
             if ([EmployeeCategory.INTERNAL_TRANSFER, EmployeeCategory.DAP_EXECUTIVE, EmployeeCategory.DAP_EXECUTIVE_IT, EmployeeCategory.INTERN].includes(emp)) {
                field.templateOptions.options = [{ probationMonth: 0 } as any];
                ele.setValue(0);
              } else if(prevEmpCat !=undefined && 
                       [EmployeeCategory.INTERNAL_TRANSFER, EmployeeCategory.DAP_EXECUTIVE, EmployeeCategory.DAP_EXECUTIVE_IT, EmployeeCategory.INTERN].includes(prevEmpCat)) {
                loadOptionsForCountry(officeCountryEle ? officeCountryEle.value : null, false);
              }
              prevEmpCat = emp;         
            });
        }
        if (officeCountryEle) {
          officeCountryEle.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(officeCountryEle.value),
              filter(id => id != null && id !== '' && id !== undefined),
              distinctUntilChanged()
            )
            .subscribe(countryId => {
              if (empCatEle &&  [EmployeeCategory.INTERNAL_TRANSFER, EmployeeCategory.DAP_EXECUTIVE, EmployeeCategory.DAP_EXECUTIVE_IT, EmployeeCategory.INTERN].includes(empCatEle.value)) {
                isFirstLoad = false;
                  ele.setValue(0);
                return;
              }
              const preserve = isFirstLoad;
              isFirstLoad = false;
              loadOptionsForCountry(countryId, preserve);
            });
        } else {
          isFirstLoad = false;
        }
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
  getNationalityWrtPbType(
    country: string,
    additionalConfig?: FormlyFieldConfig,
    filterMethod = (item) => item): FormlyFieldConfig {
    let pbTypeEle: AbstractControl;
    let oldpbType = null;
    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    nat$.subscribe(n => {
      this.nationality$.next(n);
      pbTypeEle.updateValueAndValidity();
    });
    const isApprove = (this.route.url.indexOf('approve') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: nat$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        pbTypeEle = this.findFormControl('preboardingType.id', field);
        const ele = field.formControl;

        pbTypeEle.valueChanges.subscribe(pb => {
          if (pbTypeEle.value === 1046) {
            const nationalty = this.nationality$.getValue()
              .filter((item) => filterMethod(item))
              .find(n => n.value === nullSafe(() => country, ''));
            ele.setValue(nullSafe(() => nationalty.id, null));
            ele.disable();
          } else {
            if (!field.form.disabled) {
              field.templateOptions.options = this.nationality$.getValue()
                .filter((item) => filterMethod(item))
                .map(nat => {
                  nat.disabled = nat.value === country;
                  return nat;
                });
              if (oldpbType != pb) {
                ele.setValue(null);
                oldpbType = pb;
              }
              if (!isApprove) { ele.enable(); }
            }
          }
        });
      }
    };

    return getMergedConfig(config, additionalConfig);
  }
  getNationalityWrtNatType(
    country: string,
    additionalConfig?: FormlyFieldConfig,
    filterMethod = (item) => item): FormlyFieldConfig {
    let natTypeEle: AbstractControl;
    let oldpbType = null;
    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    nat$.subscribe(n => {
      this.nationality$.next(n);
      natTypeEle.updateValueAndValidity();
    });
    const isApprove = (this.route.url.indexOf('approve') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: nat$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        natTypeEle = this.findFormControl('nationalityType.id', field);
        const ele = field.formControl;

        natTypeEle.valueChanges.subscribe(pb => {
          if (natTypeEle.value === 14572 ||natTypeEle.value === 14573) {
            const nationalty = this.nationality$.getValue()
              .filter((item) => filterMethod(item))
              .find(n => n.value === nullSafe(() => country, ''));
            ele.setValue(nullSafe(() => nationalty.id, null));
            ele.disable();
          } else {
             if (!field.form.disabled) {
              ele.enable();
              ele.setValue(null);
            if (natTypeEle.value === 14570) {
              field.templateOptions.options = this.nationality$.getValue()
                .filter((item) => filterMethod(item))
                .map(nat => {
                  nat.disabled = nat.value === country;
                  return nat;
                });}
                else if (natTypeEle.value === 14571) {
                  field.templateOptions.options = this.nationality$.getValue().filter(i =>
                    [175, 241, 203, 188, 26, 127].includes(i.id)
                  ).map(nat => {
                    nat.disabled = nat.value === this.immigrationCountry;
                    return nat;
                  });
              if (oldpbType !== pb) {
                ele.setValue(null);
                oldpbType = pb;
              }
              if (!isApprove) { ele.enable(); }
            }}
          }
        });
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  getImmCaseTypeWrtNationalityTypeWithDisable(
    itemsToDisble: any[],
    Disable: boolean,
    additionalConfig?: FormlyFieldConfig,
    filterMethod = (item) => item): FormlyFieldConfig {
    let NationalityTypEle: AbstractControl;
    let oldNationalityTyp = null;
    const imm$ = this.prepareLookupObservable(LookupTypeKeys.IMMIGRATION_CASE_TYPE);
    imm$.subscribe(n => {
      this.immCaseType$.next(n);
      NationalityTypEle.updateValueAndValidity();
    });
    const isApprove = (this.route.url.indexOf('approve') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: imm$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        NationalityTypEle = this.findFormControl('nationalityType.id', field);
        const ele = field.formControl;

        NationalityTypEle.valueChanges.subscribe(nt => {
          if (NationalityTypEle.value === 14573) {
            const immcasetyp = this.immCaseType$.getValue()
              .filter((item) => filterMethod(item))
              .find(n => n.id === 15068);
            ele.setValue(nullSafe(() => immcasetyp.id, null));
            ele.disable();
          } else {
            if (!field.form.disabled) {
              const fieldValue = field.formControl.value
              field.templateOptions.options = this.immCaseType$.getValue()
                .filter((item) => filterMethod(item) && (!itemsToDisble.includes(item.id) || item.id == fieldValue))
                .map(imm => {
                  if (Disable)
                    imm.disabled = itemsToDisble.includes(imm.id);
                  return imm;
                });
              if (oldNationalityTyp != nt) {
                ele.setValue(null);
                oldNationalityTyp = nt;
              }
              if (!isApprove) { ele.enable(); }
            }
          }
        });
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  getImmCaseTypeWrtOfficeLoc(
    country: string,

    additionalConfig?: FormlyFieldConfig,
    filterMethod = (item) => item): FormlyFieldConfig {
    const immcasetypes$ = this.prepareLookupObservable(LookupTypeKeys.IMMIGRATION_CASE_TYPE);
    immcasetypes$.subscribe(n => this.immCaseType$.next(n));

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: immcasetypes$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const officeLocEle = this.findFormControl('officeLocationCountry.id', field);
        const ele = field.formControl;

        officeLocEle.valueChanges.subscribe(oc => {
          if (officeLocEle.value !== 1047) {
            if (!field.form.disabled) {
              field.templateOptions.options = this.immCaseType$.getValue()
                .filter((item) => filterMethod(item))
                .map(immcasetype => ({
                  ...immcasetype,
                  disabled: immcasetype.value === 'Business Visa- Covid scenario'
                }));
              ele.setValue(null);
              ele.enable();
            }
          }
        });
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  findField(key: string, field: FormlyFieldConfig): FormlyFieldConfig | undefined {
  if (!field) return undefined;

  if (field.key === key) {
    return field;
  }

  if (field.fieldGroup && field.fieldGroup.length > 0) {
    for (const child of field.fieldGroup) {
      const found = this.findField(key, child);
      if (found) return found;
    }
  }

  return undefined;
}
  findFormControl(path: string, field: FormlyFieldConfig): AbstractControl {
    const form = field.parent.formControl;
    const control = form.get(path);
    if (control) {
      return control;
    }
    const emptyarr: Array<AbstractControl> = [];
    const forms = nullSafe(() => field.parent.formControl.parent.controls, emptyarr);
    for (const fc of forms) {
      const ctrl = fc.get(path);
      if (ctrl) {
        return ctrl;
      }
    }
    return null;
  }

 getDepartmentSelectFieldOption(additionalConfig?: FormlyFieldConfig) {
 
   let smuId = -1;
   let specialityId = -1;
   let leId = -1;
 
   const config: FormlyFieldConfig = {
     templateOptions: {
       options: [],
       valueProp: "deptCode",
       labelProp: "displayText"
     }
   };
 
   config.hooks = {
     onInit: field => {
       const smuEle = this.findFormControl('smu.id', field);
       const specialityEle = this.findFormControl('speciality.id', field);
       const leEle = this.findFormControl('officeLegalEntity.id', field);
       const ele = field.formControl;
       const costCentreControl = this.findFormControl('costCentre', field);
 
       const patchCostCentre = (selectedItem: any, deptValue: any) => {
         if (!costCentreControl) {
           return;
         }
 
         if (selectedItem) {
           costCentreControl.patchValue(nullSafe(() => selectedItem.costCentre, ""));
           return;
         }
         if (deptValue === null || deptValue === undefined || deptValue === "") {
           costCentreControl.patchValue("");
         }
       };
 
       this.deptCodeBlock$.subscribe(dp => {
         const deptValue = ele.value;
         const selectedItem = dp.find(d => d.deptCode === nullSafe(() => deptValue, "-1"));
         patchCostCentre(selectedItem, deptValue);
       });
       ele.valueChanges.subscribe(ev => {
         const selectedItem = this.deptCodeBlock$.getValue().find(d => d.deptCode === nullSafe(() => ev, "-1"));
         patchCostCentre(selectedItem, ev);
       });
       if (specialityEle)
         specialityEle.valueChanges
           .pipe(
             takeUntil(this.destroyed$),
             startWith(specialityEle.value),
             tap(id => {
               if (!field.form.disabled) {
                 field.formControl.setValue(null);
               }
               specialityId = id;
               if ((specialityId > 0 || smuId > 0) && leId > 0) {
                 field.templateOptions.options = this.prepareDepartmentsObservable(leId, smuId, specialityId);
               } else {
                 field.templateOptions.options = EMPTY;
               }
             })
           )
           .subscribe();
 
       if (smuEle)
         smuEle.valueChanges
           .pipe(
             takeUntil(this.destroyed$),
             startWith(smuEle.value),
             tap(id => {
               if (!field.form.disabled) {
                 field.formControl.setValue(null);
               }
               smuId = id;
               if ((specialityId > 0 || smuId > 0) && leId > 0) {
                 field.templateOptions.options = this.prepareDepartmentsObservable(leId, smuId, specialityId);
               } else {
                 field.templateOptions.options = EMPTY;
               }
             })
           )
           .subscribe();
 
       if (leEle)
         leEle.valueChanges
           .pipe(
             takeUntil(this.destroyed$),
             startWith(leEle.value),
             tap(id => {
               if (!field.form.disabled) {
                 field.formControl.setValue(null);
               }
               leId = id;
               if ((specialityId > 0 || smuId > 0) && leId > 0) {
                 field.templateOptions.options = this.prepareDepartmentsObservable(leId, smuId, specialityId);
               } else {
                 field.templateOptions.options = EMPTY;
               }
             })
           )
           .subscribe();
     }
   };
 
   return getMergedConfig(config, additionalConfig);
}


  getImmigrationCaseTypeSelectFieldOption(additionalConfig?: FormlyFieldConfig)
  : FormlyFieldConfig {

    let nationalityTypeId = -1;
    let genderId = -1;

    const imm$ = this.prepareLookupObservable(LookupTypeKeys.IMMIGRATION_CASE_TYPE);
    imm$.subscribe(n => this.immCaseType$.next(n));
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: imm$,
        valueProp: "id",
        labelProp: "value"
      }
    }; 
    config.hooks = {
      onInit: field => {
        const nationalityTypeEle = this.findFormControl('nationalityType.id', field);
        const genderEle = this.findFormControl('gender.id', field);

        if (nationalityTypeEle)
          nationalityTypeEle.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(nationalityTypeEle.value),
              tap(id => {
                if (!field.form.disabled) {
                  field.formControl.setValue(null);
                }
                nationalityTypeId = id;
                this.setImmigrationCaseTypeFieldOptions(genderId, nationalityTypeId, field); 
              })
            )
            .subscribe();
        if (genderEle)
          genderEle.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(genderEle.value),
              tap(id => {
                if (!field.form.disabled) {
                  field.formControl.setValue(null);
                }
                genderId = id;
                this.setImmigrationCaseTypeFieldOptions(genderId, nationalityTypeId, field);
              })
            )
            .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

setImmigrationCaseTypeFieldOptions(genderId: number, nationalityTypeId: number, field: any): void {

  if (this.immCaseType$.getValue()?.length == 0) {
    this.prepareLookupObservable(LookupTypeKeys.IMMIGRATION_CASE_TYPE).subscribe(n => {
      this.immCaseType$.next(n);
      if (genderId == 8 && nationalityTypeId == 14570) {
        field.templateOptions.options = this.immCaseType$.getValue().filter(i => [1008, 1009, 12025, 12026].includes(i.id));
      } else if (nationalityTypeId == 14571 || nationalityTypeId == 14572) {
        field.templateOptions.options = this.immCaseType$.getValue().filter(i => [12025, 12026].includes(i.id));
      } else {
        field.templateOptions.options = EMPTY;
      }
    });
  }
  else{
    if (genderId == 8 && nationalityTypeId == 14570) {
      field.templateOptions.options = this.immCaseType$.getValue().filter(i => [1008, 1009, 12025, 12026].includes(i.id));
    } else if (nationalityTypeId == 14571 || nationalityTypeId == 14572) {
      field.templateOptions.options = this.immCaseType$.getValue().filter(i => [12025, 12026].includes(i.id));
    } else {
      field.templateOptions.options = EMPTY;
    }
  }  
}


  private setBuOuMuValues(field: FormlyFieldConfig, selectedItem: DeptCodeblock) {
    const buEle = this.findFormControl('buCode', field);
    const ouEle = this.findFormControl('ouCode', field);
    const muEle = this.findFormControl('muCode', field);
    buEle.patchValue(nullSafe(() => selectedItem.buCode, ""));
    ouEle.patchValue(nullSafe(() => selectedItem.ouCode, ""));
    muEle.patchValue(nullSafe(() => selectedItem.muCode, ""));
  }

  prepareGradeObservable(
    rank: string,
    slId: number,
    cId: number): Observable<RankGrade[]> {
    if (!rank) {
      return EMPTY;
    }
    const cb$ = this.lookupApi.getGrades(rank, slId, cId).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    cb$.subscribe(dcb => {
      this.Grade$.next(dcb);
    });
    return cb$;
  }

  prepareExitGradeObservable(
    rank: string,
    slId: number,
    lId: number): Observable<RankGrade[]> {
    if (!rank || !slId || !lId) {
      return EMPTY;
    }
    const cb$ = this.lookupApi.getExitGrades(rank, slId, lId).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    cb$.subscribe(dcb => {
      this.Grade$.next(dcb);
    });
    return cb$;
  }

  getGradeSelectFieldOptions(additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "jobCode",
        labelProp: "grade_Descr"
      }
    };
    config.hooks = {
      onInit: field => {
        const rankEle = this.findFormControl('job.rank', field);
        const ele = field.formControl;
        const slEle = this.findFormControl('serviceLine.id', field);
        const countryEle = this.findFormControl('officeLocationCountry.id', field);

        rankEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(rankEle.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (id > 0) {
                field.templateOptions.options = this.prepareGradeObservable(id, slEle.value, countryEle.value);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
  getSearchableGradeSelectFieldOptions(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  return getMergedConfig(
    {
      className: 'col-md-4',
      key: 'job.jobCode',
      type: 'grade-select',
      templateOptions: {
        label: 'Grade',
        required: true
      }
    },
    additionalConfig
  );
}

  getExitGradeSelectFieldOptions(additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "jobCode",
        labelProp: "grade_Descr"
      }
    };
    config.hooks = {
      onInit: field => {
        const rankEle = this.findFormControl('job.rank', field);
        const ele = field.formControl;
        const slEle = this.findFormControl('serviceLine.id', field);
        const locationEle = this.findFormControl('officeLocation.id', field);

        rankEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(rankEle.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (id > 0) {
                field.templateOptions.options = this.prepareExitGradeObservable(id, slEle.value, locationEle.value);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getRankSelectFieldOptions(additionalConfig?: FormlyFieldConfig) {

    let slId = -1;
    let countryId = -1;

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "rank",
        labelProp: "rank_Descr"
      }
    };

    config.hooks = {
      onInit: field => {
        const countryEle = this.findFormControl('officeLocationCountry.id', field);
        const slEle = this.findFormControl('serviceLine.id', field);
        const ele = field.formControl;

        countryEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(countryEle.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              countryId = id;
              if (countryId > 0 && slId > 0) {
                field.templateOptions.options = this.prepareRankGradeObservable(countryId, slId);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();

        slEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(slEle.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              slId = id;
              if (countryId > 0 && slId > 0) {
                field.templateOptions.options = this.prepareRankGradeObservable(countryId, slId);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  //for curent Rank and Grade for Internal Transfer in PJ
  getRankSelectFieldOptionsPb(
    officeLocationCountryId$: Observable<number>,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    let slId = -1;
    let countryId = -1;

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "rank",
        labelProp: "rank_Descr"
      }
    };

    config.hooks = {
      onInit: field => {
        const slEle = this.findFormControl('currentServiceLineId', field);
         const gradeEle = this.findFormControl('currentJob.jobCode', field);

        const refresh = () => {
          if (countryId > 0 && slId > 0) {
            field.templateOptions.options = this.prepareRankGradeObservable(countryId, slId);
          } else {
            field.templateOptions.options = EMPTY;
          }
        };

                field.formControl.valueChanges
          .pipe(
            skip(1),
            takeUntil(this.destroyed$)
          )
          .subscribe(() => {
            if (!field.form.disabled && gradeEle) {
              gradeEle.setValue(undefined);
            }
          });

        officeLocationCountryId$
          .pipe(takeUntil(this.destroyed$))
          .subscribe(id => {
            countryId = id ?? -1;
            refresh();
          });

        if (slEle) {
          slEle.valueChanges
            .pipe(takeUntil(this.destroyed$), startWith(slEle.value))
            .subscribe(id => {
              if (!field.form.disabled && id !== slId && slId !== -1) {
                field.formControl.setValue(null);
              }
              slId = id ?? -1;
              refresh();
            });
        }
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

 getGradeSelectFieldOptionsPb(
    officeLocationCountryId$: Observable<number>,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "jobCode",
        labelProp: "grade_Descr"
      }
    };

    config.hooks = {
      onInit: field => {
        const rankEle = this.findFormControl('currentJob.rank', field);
        const slEle = this.findFormControl('currentServiceLineId', field);

        field.templateOptions.options = combineLatest([
          rankEle.valueChanges.pipe(startWith(rankEle.value)),
          slEle.valueChanges.pipe(startWith(slEle.value)),
          officeLocationCountryId$
        ]).pipe(
          takeUntil(this.destroyed$),
          switchMap(([rank, slId, countryId]) => {
            const list$ = (!rank || !slId || slId <= 0 || !countryId || countryId <= 0)
              ? of([] as RankGrade[])
              : this.prepareGradeObservable(rank, slId, countryId);

            return list$.pipe(
              map(list => {
                const currentJob = field.model?.currentJob;
                const savedCode = currentJob?.jobCode;
                const savedDescr = currentJob?.grade_Descr;
                if (savedCode && !list.some(x => x.jobCode === savedCode)) {
                  return [
                    ...list,
                    { jobCode: savedCode, grade_Descr: savedDescr || savedCode } as RankGrade
                  ];
                }
                return list;
              })
            );
          })
        );
      }
    };

    return getMergedConfig(config, additionalConfig);
  }


  getExitRankSelectFieldOptions(additionalConfig?: FormlyFieldConfig) {

    let slId = -1;
    let locationId = -1;

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "rank",
        labelProp: "rank_Descr"
      }
    };

    config.hooks = {
      onInit: field => {
        const locationEle = this.findFormControl('officeLocation.id', field);
        const slEle = this.findFormControl('serviceLine.id', field);
        const ele = field.formControl;

        locationEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(locationEle.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              locationId = id;
              if (locationId > 0 && slId > 0) {
                field.templateOptions.options = this.prepareExitRankGradeObservable(locationId, slId);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();

        slEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(slEle.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              slId = id;
              if (locationId > 0 && slId > 0) {
                field.templateOptions.options = this.prepareExitRankGradeObservable(locationId, slId);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }


  getGlobalRanks(additionalConfig?: FormlyFieldConfig) {

    let slId = -1;

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: this.getAllGlobalRanks(),
        valueProp: "rankCode",
        labelProp: "rankName"
      }
    };

    return getMergedConfig(config, additionalConfig);
  }


  getRankOptionsOnCountryCode(additionalConfig?: FormlyFieldConfig) {

    let slId = -1;
    let prevValueOfSl = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "rank",
        labelProp: "rank_Descr"
      }
    };

    config.hooks = {
      onInit: field => {
        const slEle = this.findFormControl('serviceLine.id', field);
        const ele = field.formControl;

        slEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(slEle.value),
            tap(id => {
              slId = id;
              if (!field.form.disabled && (prevValueOfSl != id)) {
                field.formControl.setValue(null);
                prevValueOfSl = id;
              }

              if (slId > 0) {
                field.templateOptions.options
                  = this.prepareRankOnCountryCode(this.immigrationCountry, slId);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getGradesOnCountryCode(additionalConfig?: FormlyFieldConfig) {
    let prevValueOfRank = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "jobCode",
        labelProp: "grade_Descr"
      }
    };
    config.hooks = {
      onInit: field => {
        const rankEle = this.findFormControl('job.rank', field);
        const ele = field.formControl;
        const slEle = this.findFormControl('serviceLine.id', field);

        rankEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(rankEle.value),
            tap(id => {
              if (!field.form.disabled && (prevValueOfRank != id)) {
                field.formControl.setValue(null);
                prevValueOfRank = id;
              }
              if (id > 0) {
                field.templateOptions.options = this.prepareGradeOnCountryCode(id, slEle.value, this.immigrationCountry);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getGlobalGrades(additionalConfig?: FormlyFieldConfig) {
    let prevValueOfRank = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "gradeCode",
        labelProp: "grade"
      }
    };
    config.hooks = {
      onInit: field => {
        const rankEle = this.findFormControl('globalRank.rankCode', field);
        const ele = field.formControl;

        rankEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(rankEle.value),
            tap(id => {
              if (!field.form.disabled && prevValueOfRank != id) {
                field.formControl.setValue(null);
                prevValueOfRank = id;
              }
              if (id > 0) {
                field.templateOptions.options = this.getGlobalGradeForRank(rankEle.value);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getRankOptionsOnCountryCodewithValue(additionalConfig?: FormlyFieldConfig) {

    let slId = -1;

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "rank",
        labelProp: "rank_Descr"
      }
    };

    config.hooks = {
      onInit: field => {
        const slEle = this.findFormControl('serviceLine.id', field);
        const ele = field.formControl;

        slEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(slEle.value),
            tap(id => {
              slId = id;
              if (slId > 0) {
                field.templateOptions.options
                  = this.prepareRankOnCountryCode(this.immigrationCountry, slId);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getGradesOnCountryCodewithValue(additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "jobCode",
        labelProp: "grade_Descr"
      }
    };
    config.hooks = {
      onInit: field => {
        const rankEle = this.findFormControl('job.rank', field);
        const ele = field.formControl;
        const slEle = this.findFormControl('serviceLine.id', field);

        rankEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(rankEle.value),
            tap(id => {
              if (id > 0) {
                field.templateOptions.options = this.prepareGradeOnCountryCode(id, slEle.value, this.immigrationCountry);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }


  prepareRankOnCountryCode(
    countryCode: string,
    slId: number
  ): Observable<RankGrade[]> {
    if (!slId) {
      return EMPTY;
    }
    const cb$ = this.lookupApi.getRankByCountryCode(countryCode, slId).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    cb$.subscribe(dcb => {
      this.rankGrade$.next(dcb);
    });
    return cb$;
  }


  getAllGlobalRanks(): Observable<GlobalRank[]> {
    return this.lookupApi.getGlobalRanks().pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }


  getGlobalGradeForRank(rankCode: string): Observable<GlobalRank[]> {
    return this.lookupApi.getGlobalGradeForRank(rankCode).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }


  prepareGradeOnCountryCode(
    rank: string,
    slId: number,
    countryCode: string): Observable<RankGrade[]> {
    if (!rank) {
      return EMPTY;
    }
    const cb$ = this.lookupApi.getGradeByCountryCode(rank, slId, countryCode).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    cb$.subscribe(dcb => {
      this.Grade$.next(dcb);
    });
    return cb$;
  }

  getRoleSelectFieldOptions(dataSource$: Observable<UserRole[]>, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "role",
        labelProp: "role"
      }
    };

    return getMergedConfig(config, additionalConfig);
  }


  getEmployeeSelectFieldOptions(dataSource$: Observable<Employee[]>, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "name"
      }
    };
    config.hooks = {
      onInit: field => {
        dataSource$.subscribe(res => {
          field.templateOptions.options = res;
          if (field.key == 'processor.id' || field.key == 'ptc.id') {
            // this.appConfig.getAppConfigValues('IC_AdminConfig,PJC_AdminConfig').subscribe(resp => {
            //   const ptc = resp.filter(x => x.configKey == 'PJC_AdminConfig')[0].configValue == 'true' ? true : false;
            //   const ic = resp.filter(x => x.configKey == 'IC_AdminConfig')[0].configValue == 'true' ? true : false;
            //   if ((field.key == 'ptc.id' && ptc) || (field.key == 'processor.id' && ic)) {
            const fieldValue = field.formControl.value
            field.templateOptions.options = !isNullOrUndefined(fieldValue) && res.filter(x => x.id == fieldValue)[0].disabled ? res.filter(x => !x.disabled || x.id == fieldValue) : res.filter(x => !x.disabled);
            //   }
            // });
          }
        });
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  // getEmployeeWithClaims(dataSource$: Observable<Employee[]>,
  //   additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  //   const config: FormlyFieldConfig = {
  //     templateOptions: {
  //       options: dataSource$,
  //       valueProp: "id",
  //       labelProp: "name"
  //     }
  //   };

  //   return getMergedConfig(config, additionalConfig);
  // }

  getEmployeeWithClaims(dataSource$: Observable<Employee[]>,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "name"
      }
    };

    config.hooks = {
      onInit: field => {
        field.formControl.setValue(this.authService.ActiveUser.employeeId);
      }
    };


    return getMergedConfig(config, additionalConfig);
  }
  getEmployeeByOfficeLocationSelectFieldOptions(dataSource$: Observable<Employee[]>,
    roleId: number,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "name"
      }
    };


    config.hooks = {
      onInit: field => {
        const officeToBeVisited = this.findFormControl('officeToBeVisited', field);

        officeToBeVisited.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(officeToBeVisited.value),
            tap(data => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (data.id > 0) {
                this.prepareEmployeeByRoleInLocationId(roleId, data.id).subscribe(res => {
                  field.templateOptions.options = res;
                  if (field.key == 'processor.id' || field.key == 'ptc.id') {
                    // this.appConfig.getAppConfigValues('IC_AdminConfig,PJC_AdminConfig').subscribe(resp => {
                    //   const ptc = resp.filter(x => x.configKey == 'PJC_AdminConfig')[0].configValue == 'true' ? true : false;
                    //   const ic = resp.filter(x => x.configKey == 'IC_AdminConfig')[0].configValue == 'true' ? true : false;
                    //   if ((field.key == 'ptc.id' && ptc) || (field.key == 'processor.id' && ic)) {
                    const fieldValue = field.formControl.value
                    field.templateOptions.options = !isNullOrUndefined(fieldValue) && res.filter(x => x.id == fieldValue)[0].disabled ? res.filter(x => !x.disabled || x.id == fieldValue) : res.filter(x => !x.disabled);
                    //   }
                    // });
                  }
                });
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }
  getEmployeeByRoleInCountrySelectFieldOptions(roleType: RoleType,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "id",
        labelProp: "name"
      }
    };
    config.hooks = {
      onInit: field => {
        this.prepareEmployeeByRoleInCountry(roleType).subscribe(res => {
          field.templateOptions.options = res;
          if (field.key == 'ptc.id') {
            // this.appConfig.getAppConfigValues('IC_AdminConfig,PJC_AdminConfig').subscribe(resp => {
            //   const ptc = resp.filter(x => x.configKey == 'PJC_AdminConfig')[0].configValue == 'true' ? true : false;
            //   if (ptc) {
            const fieldValue = field.formControl.value
            field.templateOptions.options = !isNullOrUndefined(fieldValue) && res.filter(x => x.id == fieldValue)[0].disabled ? res.filter(x => !x.disabled || x.id == fieldValue) : res.filter(x => !x.disabled);
            // }
            // });
          }
        });
      }
    }
    return getMergedConfig(config, additionalConfig);
  }
  getEmployeeByOfficeLESelectFieldOptions(dataSource$: Observable<Employee[]>,
    roleId: number,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "name"
      }
    };


    config.hooks = {
      onInit: field => {
        const officeToBeVisited = this.findFormControl('officeLE', field);

        officeToBeVisited.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(officeToBeVisited.value),
            tap(data => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (data.id > 0) {
                this.prepareEmployeeByRoleInLegalEntityId(roleId, data.id).subscribe(res => {
                  field.templateOptions.options = res;
                  if (field.key == 'processor.id') {
                    // this.appConfig.getAppConfigValues('IC_AdminConfig,PJC_AdminConfig').subscribe(resp => {
                    //   const ic = resp.filter(x => x.configKey == 'IC_AdminConfig')[0].configValue == 'true' ? true : false;
                    //   if (ic) {
                    const fieldValue = field.formControl.value
                    field.templateOptions.options = !isNullOrUndefined(fieldValue) && res.filter(x => x.id == fieldValue)[0].disabled ? res.filter(x => !x.disabled || x.id == fieldValue) : res.filter(x => !x.disabled);
                    //   }
                    // });
                  }
                });
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? "." + /[^.]+$/.exec(filename)[0] : undefined;
  }

  getFilename(details: CandidateDocuments): string {
    let fileName = details.documentType.displayText.trim() + '_' + details.documentName.trim();
    return fileName.replace(/ +/g, "_") + this.getFileExtension(details.fileName);
  }

  getCountryCodes(): Observable<LookupField[]> {
    return this.http.get<LookupField[]>('/assets/country-codes.json').pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  getCurrencyCodes(): Observable<LookupField[]> {
    return this.http.get<LookupField[]>('/assets/currency-codes.json').pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }

  getcandidateInfo(candProf: CandidateProfile): string {
    let result = '';
    if (candProf) {
      const name = [candProf.firstName, candProf.middleName, candProf.lastName]
        .filter(n => !isNullOrUndefined(n))
        .join(' ');

      if (candProf.contactNumber) {
        result = `(${name}, ${candProf.contactNumber})`;
      } else { result = `(${name})`; }
    }
    return result;
  }

  getemployeeStatus(status: number, EmpStatus: number): string {
    let res = '';
    if (status == StatusTypes.JOINED) {
      res = EmpStatus == 1 ? "Active Employee" : "Inactive Employee";
    }
    return res;
  }

  updateDelegateStatus(userId?: number) {
    if (userId && userId > 0) {
      this.userAPI.getUserDetails(userId).subscribe(user => {
        if (user && user.delegateId) {
          this.delegateStatus$.next(true);
        } else {
          this.delegateStatus$.next(false);
        }
      });
    }
  }
  canViewActivityList(statusId) {
    return (this.authService.isAuthorised('CanEditActivities-PTC')
      && !this.isRecruitment
      && ![1, 2, 4].includes(statusId));

  }

  isApplicableCBTSRole() {
    return ![13, 14].includes(this.authService.ActiveUser.activeRoleId);
  }

 
  // isOTPApplicable(): boolean {
  //   const roleId = this.authService.ActiveUser?.activeRoleId;
  //   return [10].includes(roleId);
  // }

  getISBritSelectFieldOptions(
    dataSource$: Observable<LookupField[]>,
    validationKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getISBritSelectFieldOptions(dataSource$, validationKey, additionalConfig);
  }

  private _getISBritSelectFieldOptions(
    dataSource$: Observable<LookupField[]>,
    validationKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };


    if (validationKey && validationKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl(validationKey, field);
          ele.valueChanges
            .pipe(

              tap(id => {
                if (ele.value !== 717 && !isNullOrUndefined(ele.value)) {
                  field.formControl.setValue(2348);
                  field.formControl.disable();
                } else {
                  field.formControl.setValue(null);
                  field.formControl.enable();
                }

              })
            )
            .subscribe();
        }
      };
    }
    return getMergedConfig(config, additionalConfig);
  }

  prepareEmailTemplatesObservable(
    empCatId: number,
    OffLocId: number,
    pbTypeId: number,
    iswso: boolean
  ): Observable<EmailTemplateEditorInfo[]> {
    if (!empCatId || !OffLocId) {
      return EMPTY;
    }
    iswso = (iswso == null) ? false : iswso;
    const cb$ = this.emailApi.getEmailTemplates(empCatId, OffLocId, pbTypeId, iswso).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    // cb$.subscribe(dcb => {
    //     this.deptCodeBlock$.next(dcb);
    // });
    return cb$;
  }

  prepareSystemEmailTemplatesObservable(
  ): Observable<EmailTemplateEditorInfo[]> {
    const et$ = this.emailApi.getPBGeneralTemplates().pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    return et$;
  }
  prepareWebJobEmailTemplatesObservable(
  ): Observable<EmailTemplateEditorInfo[]> {
    const et$ = this.emailApi.getWebJobEmailTemplates().pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    return et$;
  }
  // prepareSystemEmailTemplatesObservableWebJob(): Observable<EmailTemplateEditorInfo[]> {
  //   return this.emailApi.getPBWebJobGeneralTemplates().pipe(
  //     takeUntil(this.destroyed$),
  //     shareReplay(),
  //     map(templates => templates.filter(t => 
  //       t.code?.startsWith("PJ") || t.code?.startsWith("PTC")
  //     ))
  //   );
  // }
  

  getEmailTemplateSelectFieldOptions(onChange: (obj: EmailTemplateEditorInfo) => void, additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: (option) => option,
        compareWith: (o1, o2) => o1.id === o2.id,
        labelProp: "activityHeader"
      }
    };
    config.hooks = {
      onInit: field => {
        const empCat = this.findFormControl('employeeCategory.id', field);
        const offLoc = this.findFormControl('officeLocation.id', field);
        const pbType = this.findFormControl('onboardingType.id', field);
        const iswso = this.findFormControl('iswso', field);

        field.formControl.valueChanges.pipe(
          takeUntil(this.destroyed$),
        ).subscribe(onChange);

        empCat.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(empCat.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (id > 0 && offLoc.value > 0 && pbType.value > 0) {
                field.templateOptions.options = this.prepareEmailTemplatesObservable(id, offLoc.value, pbType.value, this.iswsovalue(field));
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          ).subscribe();

        offLoc.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(offLoc.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (id > 0 && empCat.value > 0 && pbType.value > 0) {
                field.templateOptions.options = this.prepareEmailTemplatesObservable(empCat.value, id, pbType.value, this.iswsovalue(field));
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          ).subscribe();

        pbType.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(pbType.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (id > 0 && empCat.value > 0 && offLoc.value > 0) {
                field.templateOptions.options = this.prepareEmailTemplatesObservable(empCat.value, offLoc.value, id, this.iswsovalue(field));
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          ).subscribe();

        iswso.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(pbType.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (empCat.value > 0 && offLoc.value > 0 && pbType.value > 0) {
                field.templateOptions.options = this.prepareEmailTemplatesObservable(empCat.value, offLoc.value, pbType.value, id);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          ).subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  iswsovalue(field) {
    return (this.findFormControl('iswso', field) == null) ? false : this.findFormControl('iswso', field).value;
  }
  getWebJobEmailTemplateSelectFieldOptions(onChange: (obj: EmailTemplateEditorInfo) => void, additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: this.prepareWebJobEmailTemplatesObservable(),
        valueProp: (option) => option,
        compareWith: (o1, o2) => o1.id === o2.id,
        labelProp: "activityHeader"
      }
    };
    config.hooks = {
      onInit: field => {
        field.formControl.valueChanges.pipe(
          takeUntil(this.destroyed$),
        ).subscribe(onChange);
      }
    };

    return getMergedConfig(config, additionalConfig);
  }
  getSystemEmailTemplateSelectFieldOptions(onChange: (obj: EmailTemplateEditorInfo) => void, additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: this.prepareSystemEmailTemplatesObservable(),
        valueProp: (option) => option,
        compareWith: (o1, o2) => o1.id === o2.id,
        labelProp: "activityHeader"
      }
    };
    config.hooks = {
      onInit: field => {
        field.formControl.valueChanges.pipe(
          takeUntil(this.destroyed$),
        ).subscribe(onChange);
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  getCancellationVisa(
    dataSource$: Observable<LookupField[]>,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getCancellationVisa(dataSource$, additionalConfig);
  }

_getCancellationVisa(
  dataSource$: Observable<LookupField[]>,
  additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      valueProp: "id",
      labelProp: "displayText",
      options: dataSource$
    }
  };
  let cancellationVisaoptions$: Observable<LookupField[]>;
  config.hooks = {
    onInit: field => {
      const officeToBeVisited = this.findFormControl('officeLocation', field);
      const nationalityTypeId = this.findFormControl('nationalityTypeId', field);
      const officeLoc$ = this.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION);
      officeLoc$.subscribe(n => this.officeLocation$.next(n));
      const validIds = [654, 655, 660, 661, 663, 664, 665, 666, 668];
      officeToBeVisited.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(officeToBeVisited.value),
          switchMap(loc => {
            const officeId = nullSafe<number>(() => loc?.id, -1);

            if (officeId > 0) {
              cancellationVisaoptions$ = this.prepareCancellationVisa(officeId).pipe(
                tap(options => {
                })
              );

              return cancellationVisaoptions$;
            }
            return EMPTY;
          })
        )
        .subscribe(options => {
          const officeId = nullSafe<number>(() => officeToBeVisited.value.id, -1);
          const natId = nationalityTypeId.value?.id;
          const country = this.officeLocation$.getValue().find(o => o.id === officeId);

          if (!options) {
            field.templateOptions.options = EMPTY;
            return;
          }

          if (natId === 14570 && country?.parentFieldId === 1048) {
            field.templateOptions.options = of(options.filter(f => ![5903].includes(f.id)));
          } else if (country?.parentFieldId === 1048 && [14571, 14572, 15233].includes(natId)) {
            field.templateOptions.options = of(options.filter(f => ![5904, 5905].includes(f.id)));
            field.formControl.setValue(5903);
            field.formControl.disable();
          } else {
            field.templateOptions.options = of(options);
          }
          const savedVal = field.formControl.value;
          if (savedVal && options.some(o => o.id === savedVal)) {
         
            field.formControl.setValue(savedVal, { emitEvent: false });
          }
          if (!validIds.includes(officeId)) {
            field.formControl.disable({ emitEvent: false });
          } else {
            field.formControl.enable({ emitEvent: false });
          }
        });

      nationalityTypeId.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(nationalityTypeId.value),
          tap(() => {
            const officeId = nullSafe<number>(() => officeToBeVisited.value.id, -1);
            if (!validIds.includes(officeId)) {
              field.formControl.disable({ emitEvent: false });
            } else {
              field.formControl.enable({ emitEvent: false });
            }
          })
        )
        .subscribe(() => {
          const officeId = nullSafe<number>(() => officeToBeVisited.value.id, -1);
          const natId = nationalityTypeId.value?.id;
          const country = this.officeLocation$.getValue().find(o => o.id === officeId);

          if (cancellationVisaoptions$) {
            cancellationVisaoptions$.pipe(take(1)).subscribe(options => {
              if (natId === 14570 && country?.parentFieldId === 1048) {
                field.templateOptions.options = of(options.filter(f => ![5903].includes(f.id)));
              } else if (country?.parentFieldId === 1048 && [14571, 14572, 15233].includes(natId)) {
                field.templateOptions.options = of(options.filter(f => ![5904, 5905].includes(f.id)));
                field.formControl.setValue(5903);
                field.formControl.disable();
              } else {
                field.templateOptions.options = of(options);
              }
              const savedVal = field.formControl.value;
            });
          }
        });
    }
  };

  return getMergedConfig(config, additionalConfig);
}


  prepareCancellationVisa(
    officeLocationId: number
  ): Observable<LookupField[]> {

    return this.lookupApi.getCancellationVisa(officeLocationId).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }


  initImmigrationProfile(): ImmigrationProfile {
    const model = new ImmigrationProfile();

    model.nationality = new LookupField();
    model.gender = new LookupField();
    model.officeLocation = new LookupField();
    model.serviceLine = new LookupField();
    model.subServiceLine = new LookupField();
    model.embassy = new LookupField();
    model.job = new RankGrade();
    model.globalRank = new GlobalRank();
    model.globalGrade = new GlobalGrade();
    model.officeLocationCountry = new LookupField();


    model.officeToBeVisited = new LookupField();
    model.ptc = new Employee();
    model.requestor = new Employee();
    model.processor = new Employee();
    model.recruiter = new Employee();

    // model.employeeCurrentLocation = new LookupField();
    model.employeeCurrentLocationCountry = new LookupField();
    model.globalEmployeeLocation = new LookupField();
    model.immigrationCaseType = new LookupField();
    model.immigrationStatus = new LookupField();

    model.visaType = new LookupField();
    model.createdByEmployee = new Employee();
    model.modifiedByEmployee = new Employee();
    model.status = new LookupField();
    model.entryType = new LookupField();
    model.createdBy = null;
    model.residencyStatus = new LookupField();

    model.sponsorDepsInKSA = new LookupField();
    model.depsAlreadyInKSA = new LookupField();
    model.onboardingType = new LookupField();

    model.durationOfStay = new LookupField();
    model.dualCitizenship = new LookupField();
    model.secondNationality = new LookupField();
    model.officeLE = new OfficeEntity();
    model.distanceLearning = new LookupField();
    model.currentEyEmployee = new LookupField();
    model.onBehalfOfAnotherEYEmployee = new LookupField();
    model.onEntryBusinessVisa = new LookupField();
    model.currentGccResident = new LookupField();
    model.prevCurrentGccResident = new LookupField();
    model.preboardingType = new LookupField();
    model.cancellationReason = new LookupField();
    model.immigrationStatus = new LookupField();
    model.ewakalaAgent = new LookupField();
    model.spouseDetails = '';
    model.childrenDetails = '';

    model.passportType = new LookupField();
    model.maritalStatus = new LookupField();
    model.shortTermVisa = new LookupField();
    model.relationship = new LookupField();
    model.dependentDetails = '';
    model.religion = new LookupField();
    model.sect = new LookupField();
    model.visaAlignment = new LookupField();
    model.molContract = new LookupField();
    model.typeOfRequest = new LookupField();
    model.isYourMarriageOrBirthCertificateAttested = new LookupField();
    model.dependentsUnderSponsorship = new LookupField();
    model.dependentsVisaOnHold = new LookupField();
    model.visaCancellationRequired = new LookupField();
    model.cprCaseType = new LookupField();
    model.cprType = new LookupField();
    model.reasonForVisit = new LookupField();
    model.doYouHaveValidKSABusinessVisa = new LookupField();
    model.hireType = new LookupField();
    model.visaStatus = new LookupField();
    model.permitType = new LookupField();
    model.bloodGroup = new LookupField();
    model.enrollmentType = new LookupField();
    model.workTimings = new LookupField();
    model.language = new LookupField();
    model.workWeek = new LookupField();
    model.jobBenefits = new LookupField();
    model.oldNationality = new LookupField();
    model.currentlyInKuwait = new LookupField();
    model.typeOfSupport = new LookupField();
    model.dependentsInKuwait = new LookupField();
    model.typeOfModification = new LookupField();
    model.attrestedDegree = new LookupField();
    model.attestedbyKwait = new LookupField();
    // model.durationOfStayShortTerm = new LookupField();
    model.missionVisaCategory = new LookupField();

    model.attestedByUAE = new LookupField();
    model.qualification = new LookupField();
    model.reasonForRenewal = new LookupField();
    model.reasonForVisitUAEBusinessVisa = new LookupField();
    model.alreadyHaveGoldenVisa = new LookupField();
    model.travelType = new LookupField();
    model.nomination = new LookupField();
    model.labourCardCancellationType = new LookupField();
    model.terminationType = new LookupField();
    model.wantToUpdateDependentPassport = new LookupField();
    model.employeeSearchTerm = null;//new EmployeeProfile();
    model.eyInternalTransfer = new LookupField();
    model.travelPurpose = new LookupField();
    model.reasonForExit = new LookupField();
    model.noOfExtensionTimes = new LookupField();
    model.currentBahrainResident = new LookupField();
    model.isBahrainResident = new LookupField();
    model.isdependentsUnderSponsorship = new LookupField();
    model.vaccinationStatus = new LookupField();
    model.vaccineType = new LookupField();
    model.employeeCategory = new LookupField();
    model.categoryOfJobOffer = new LookupField();
    model.typeOfDocRequested = [];
    model.documentSupportType = new LookupField();
    model.isEYFirstEmployer = new LookupField();
    model.previousNationality = new LookupField();
    model.nationalityType = new LookupField();
    model.currentKSAbusinessvisa = new LookupField();
    model.completedUAEPassRegistration = new LookupField();
    model.isFirstVisitToPakistan = new LookupField();
    model.isFirstVisitToJordan = new LookupField();
    model.reasonForVisitPAKBusinessVisa = new LookupField();
    model.pakOfficeToVisit = new LookupField();
    model.typeOfVisa = new LookupField();
    model.typeOfWorkPermit = new LookupField();
    model.ksaOfficeToBeVisited = new LookupField();
    model.issuingCountryId = new LookupField();
    model.scpMembership = new LookupField();
    model.workLocationDuringTrip = [];
    model.purposeOfVisit = [];
    model.countryToBeVisited = new LookupField();
    model.cityToBeVisited = new LookupField();
    model.primeType = new LookupField();
    model.isMenaSponsoringPartner = new LookupField();
    model.accommodationRequired = new LookupField();
    model.universityDegree = new LookupField();
    model.accomodationSupportRequired = new LookupField();
    model.payroll = new LookupField();
    model.recommendedVisaType = new LookupField();
    model.recommendedEntryType = new LookupField();
    model.recommendedVisaDuration = new LookupField();
    model.performingBillableWork=new LookupField();
    model.degreeAttestationRequired = new LookupField();
    return model;
  }



  showValidations(type: ValidityTypes) {
    switch (type) {
      case ValidityTypes.DATAINVALID:
        this.toast.warning(`Can't save profile: please enter valid data!`);
        break;
      case ValidityTypes.INVALID:
        this.toast.warning(`Please enter the mandatory fields!`);
        break;
      case ValidityTypes.NOTDIRTY:
        this.toast.warning(`No changes to save!`);
        break;
      default:
        break;

    }
  }

  showOnSaveValidatons(country) {
    switch (country) {
      case CountryTypesValues.SaudiArabia:
        this.toast.warning(`Please select a Legal entity`);
        break;
      case CountryTypesValues.PAK:
        this.toast.warning(`Please select a Legal entity`);
        break;

      case CountryTypesValues.BHR:
      case CountryTypesValues.OMAN:
      case CountryTypesValues.QAT:
      case CountryTypesValues.KWT:
      case CountryTypesValues.UAE:
      case CountryTypesValues.EGY:
      case BusinessTravel.Value:
        this.toast.warning(`Please select an office location`);
        break;

    }
  }

  validImmDocs(
    uploadedFiles: any[],
    validDocuments: any[]) {
    const mandatoryFileIds = validDocuments.filter(doc => doc.isMandatory).map(doc => doc.docNameId);
    const anyOneMandateIds = validDocuments.filter(doc => doc.mandatoryType > 1).map(doc => doc.docTypeId);


    if (mandatoryFileIds.length === 0 && anyOneMandateIds.length === 0) {
      // validate true since there is no valid docs to be uploaded
      return true;
    } else if (validDocuments.length !== 0 && uploadedFiles.length !== 0) {
      // validate only if every mandatory id is presen in the uploaded doc ids.
      const uploadedFileIds = uploadedFiles.map(doc => doc.documentNameId);
      let res1 = mandatoryFileIds.every(id => uploadedFileIds.includes(id));

      const uploadedFileTypeIds = uploadedFiles.map(doc => doc.documentTypeId);
      let res2 = anyOneMandateIds.every(id => uploadedFileTypeIds.includes(id));

      return res1 && res2
    } else {
      return false;
    }
  }



  uniqueByPropertyName(arr) {
    let outputArray = arr.filter(function (v, i, self) {
      return i == self.indexOf(v);
    });

    return outputArray;
  }


  validEmployeeDocs(
    uploadedFiles: any[],
    validDocuments: any[],
    dependentDocs: number[]
  ) {

    let missingFileNames = [];
    let missingDependentFileNames = [];

    let finalFiles: EmployeeDocCombined[];
    finalFiles = uploadedFiles;

    let missingFiles = uploadedFiles.filter(x => x.mandatoryType == 1 && x.isUploaded == false).
      map(x => x.documentTypeName);


    // const mandatory = validDocuments.filter(x => x.isMandatory && !dependentDocs.includes(x.docNameId)).map(x => x.docNameId);
    // const anyOneMandateIds = validDocuments.filter(doc => doc.mandatoryType > 1).map(doc => doc.docTypeId);
    // let missingFiles = mandatory.filter(obj => !uploadedFiles.find(s => s.documentNameId == obj))
    // let missingAnyOneMandateFiles = anyOneMandateIds.filter(obj => !uploadedFiles.find(s => s.documentTypeId == obj))

    // const mandatoryDocNames = validDocuments.filter(x => x.isMandatory && dependentDocs.includes(x.docNameId)).map(x => x.docNameDisplayText);
    // let missingDepFile = mandatoryDocNames.filter(obj => !uploadedFiles.find(s => s.documentName == obj))
    // if (mandatory.length > 0 || mandatoryDocNames.length > 0 || anyOneMandateIds.length > 0) {

    //   missingDependentFileNames = this.uniqueByPropertyName(validDocuments.filter(x => missingDepFile.some(w => w == x.docNameDisplayText)), "docTypeDisplayText");
    //   missingDependentFileNames = missingDependentFileNames
    //   missingFileNames = this.uniqueByPropertyName(validDocuments.filter(x => missingFiles.some(w => w == x.docNameId)), "docTypeDisplayText");
    //   let missingAnyoneFileNames = this.uniqueByPropertyName(validDocuments.filter(x => missingAnyOneMandateFiles.some(w => w == x.docTypeId)), "docTypeDisplayText");


    //   if (missingFiles && missingFiles.length > 0 || missingDependentFileNames && missingDependentFileNames.length > 0 || missingAnyoneFileNames && missingAnyoneFileNames.length > 0) {
    //     return {
    //       valid: false, message: missingFileNames.concat(missingDependentFileNames, missingAnyoneFileNames).join(' , ').replace(/,(?=[^,]*$)/, ' and ') + ' .'
    //     };
    //   }
    //   else {
    //     return { valid: true, message: '' };
    //   }

    // }
    // else {

    //   return { valid: true, message: '' };
    // }


    if (missingFiles && missingFiles.length > 0) {

      //valid: false, message: missingFiles.join(' , ').replace(/,(?=[^,]*$)/ + ' .' };
      return { valid: false, message: this.uniqueByPropertyName(missingFiles).join(' , ').replace(/,(?=[^,]*$)/, ' and ') + ' . ' };

    }
    else {
      return { valid: true, message: '' };
    }

  }

  ValidateDocuments(
    uploadedFiles: any[],
    validDocuments: any[], isAdditionalDocUpload = false) {

    let missingFiles = uploadedFiles.filter(x => x.isMandatory && !x.isUploaded);
    let missingFileNames = [];

    const anyOneMandatoryTypeIds = uploadedFiles.filter(x => x.mandatoryType > 1);
    const anyOneMandatoryTypeUploaded = uploadedFiles.filter(x => x.mandatoryType > 1 && x.isUploaded);
    const missingAnyoneMandatory = anyOneMandatoryTypeIds.filter(obj => anyOneMandatoryTypeUploaded.every(s => s.documentTypeId !== obj.documentTypeId));

    if (missingFiles.length === 0 && missingAnyoneMandatory.length === 0) {
      // validate true since there is no valid docs to be uploaded
      return { valid: true, message: '' };
    }
    else if (uploadedFiles.length !== 0) {

      missingFileNames = missingFiles.concat(missingAnyoneMandatory);
      missingFileNames = missingFileNames.map(doc => doc.documentTypeName);
      missingFileNames = missingFileNames.filter((x, i, a) => a.indexOf(x) == i); // for getting unique items

      if (missingFileNames.length !== 0) {
        //missingFiles.push(missingFileNames);
        return { valid: false, message: ' The following mandatory documents are missing : ' + missingFileNames.join(' , ').replace(/,(?=[^,]*$)/, ' and ') + ' . Please upload all mandatory documents' };
      }
      else {
        return { valid: true, message: '' };
      }
    }
  }

  ValidateDocumentsEMP(
    uploadedFiles: any[],
    validDocuments: any[], isAdditionalDocUpload = false) {
    const mandatoryFiles = validDocuments.filter(doc => doc.isMandatory);
    const anyOneMandateFiles = validDocuments.filter(doc => doc.mandatoryType > 1);
    let missingFiles = [];
    let missingFileNames = [];

    if (mandatoryFiles.length === 0 && anyOneMandateFiles.length === 0) {
      // validate true since there is no valid docs to be uploaded
      return { valid: true, message: '' };
    } else if (validDocuments.length !== 0 && uploadedFiles.length !== 0) {
      var res1 = [];
      if (!isAdditionalDocUpload) {
        res1 = mandatoryFiles.filter(obj => uploadedFiles.every(s => s.documentNameId !== obj.docNameId));  // missing object from two arrays

      } else {
        res1 = mandatoryFiles.filter(obj => uploadedFiles.every(s => s.additionalReqId !== obj.additionalReqId));  // missing object from two arrays
      }

      const res2 = anyOneMandateFiles.filter(obj => uploadedFiles.every(s => s.documentTypeId !== obj.docTypeId));


      missingFileNames = res1.concat(res2);
      missingFileNames = missingFileNames.map(doc => doc.docTypeDisplayText);
      missingFileNames = missingFileNames.filter((x, i, a) => a.indexOf(x) == i); // for getting unique items

      if (missingFileNames.length !== 0) {
        missingFiles.push(missingFileNames);
        return { valid: false, message: ' The following mandatory documents are missing : ' + missingFiles.join(' , ').replace(/,(?=[^,]*$)/, ' and ') + ' . Please upload all mandatory documents' };
      }
      else {
        return { valid: true, message: '' };
      }
    } else {
      missingFiles = mandatoryFiles.concat(anyOneMandateFiles);
      missingFiles = missingFiles.map(doc => doc.docTypeDisplayText);
      missingFiles = missingFiles.filter((x, i, a) => a.indexOf(x) == i);
      return { valid: false, message: ' The following mandatory documents are missing : ' + missingFiles.join(' , ').replace(/,(?=[^,]*$)/, ' and ') + ' . Please upload all mandatory documents' };

    }
  }



  validExitDocs(uploadedFiles: any[],
    validDocuments: any[]) {
    return this.validImmDocs(uploadedFiles, validDocuments)
  }




  getSelectFieldOptionsExcept(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionsExcept(this.disablePassedId, dataSource$, parentKey, additionalConfig);
  }

  getSelectFieldOptionsExceptWithValue(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionsExceptWithValue(this.disablePassedId, dataSource$, parentKey, additionalConfig);
  }

  private disablePassedId(field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) {
    field.templateOptions.options = dataSource$.pipe(map(fields => {
      const fieldsCopy = [...fields];
      fieldsCopy.forEach(f => {
        f.disabled = f.id === id;
      })
      return fieldsCopy;
    }));
  }

  private _getSelectFieldOptionsExcept(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl(parentKey, field);
          ele.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(ele.value),
              tap(id => {
                if (!field.form.disabled) {
                  field.formControl.setValue(null);
                }
                tapFn(field, dataSource$, id);
              })
            )
            .subscribe();
        }
      };
    }

    return getMergedConfig(config, additionalConfig);
  }

  private _getSelectFieldOptionsExceptWithValue(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl(parentKey, field);
          ele.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(ele.value),
              tap(id => {

                tapFn(field, dataSource$, id);
              })
            )
            .subscribe();
        }
      };
    }

    return getMergedConfig(config, additionalConfig);
  }

  //disable multiple items in dropdown -  itemsToDisble
  getSelectFieldOptionsWithDisable(
    dataSource$: Observable<LookupField[]>,
    itemsToDisble: any[],
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getSelectFieldOptionsWithDisable(dataSource$, itemsToDisble, additionalConfig);
  }

  private _getSelectFieldOptionsWithDisable(
    dataSource$: Observable<LookupField[]>,
    itemsToDisble: any[],
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    config.hooks = {
      onInit: field => {
        field.templateOptions.options = dataSource$.pipe(
          takeUntil(this.destroyed$),
          map(fields => {
            let clone = JSON.parse(JSON.stringify(fields))
            clone.forEach(x => {
              x.disabled = itemsToDisble.includes(x.id);
            })
            return clone;
          }));
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  isAccessible(
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);

    const config: FormlyFieldConfig = {
      templateOptions: {
      },

      expressionProperties: {
        'templateOptions.required': (model: any, formState: any, field: FormlyFieldConfig) => {
          return this.required(model, isApprove);
        },
        'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {
          const disable = this.disabled(model, isApprove);

          if (disable && field.formControl.value !== null) {
            field.formControl.setValue(null);
          }
          return disable;
        }
      }
    };

    return getMergedConfig(config, additionalConfig);
  }
validateOfficeEntity(
  message: string,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    validators: {
      officeLEValidator: {
        expression: (c: AbstractControl) => {
          if (isNullOrUndefined(c.value)) {
            return true;
          }

          if (typeof c.value === 'number') {
            return c.value != 700;
          }

          if (typeof c.value === 'object' && 'id' in c.value) {
            return c.value.id != 700;
          }

          return true;
        },
        message: (error, field: FormlyFieldConfig) => message
      }
    },
    hooks: {
      onInit: (field) => {
        field.formControl.valueChanges.subscribe(() => {
          field.formControl.markAsTouched();
        });
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}
// Validator to check if one date is after another date, 
// pass field key for the first date and error message for validation failure
  validateDateAfterADate(
    firstDateOrFieldKey: string | Date,
    message: string,
    property: string = 'Second date',
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {},
      validators: {
        dateAfterAnother: {
          expression: (c) => {
            if (!c?.value) {
              return true; 
            }

            const form = c?.parent || c?.form?.root;
            if (!form) {
              return true; 
            }

            let firstDateValue: any;

        
            if (firstDateOrFieldKey instanceof Date) {
              firstDateValue = firstDateOrFieldKey;
            } else {
              const firstCtrl = form.get(firstDateOrFieldKey);
              if (!firstCtrl) {
                return true;
              }
              firstDateValue = firstCtrl.value;
            }

            const secondDateValue = c.value;

            if (!firstDateValue || !secondDateValue) {
              return true;
            }

         
            const toDate = (val: any): Date => {
              if (val instanceof Date) return val;
              if (typeof val === 'string' && val.includes('-')) {
                const [d, m, y] = val.split('-').map(Number);
                return new Date(y, m - 1, d);
              }
              return new Date(val);
            };

            const firstDate = toDate(firstDateValue);
            const secondDate = toDate(secondDateValue);

          
            return secondDate >= firstDate;
          },
          message: () => message, // pass error message from main file
        },
      },
    };

    return getMergedConfig(config, additionalConfig);
  }
  AcceptDateAfter(
    days: number,
    message: string,
    property: string,
    checkAcceptAndApprove = false,

    additionalConfig?: FormlyFieldConfig,
    validateEvenIfApprover = false): FormlyFieldConfig {
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        vname: {
          expression: (c) => {
            if (isNullOrUndefined(c.value)) {
              return true;
            }

            if (isApprove && !checkAcceptAndApprove) {
              return true;
            }

            // validateEvenIfApprover introduced since for UAE mission visa
            // a requirement was to check for 89days in approver section
            // Not validating with checkAcceptAndApprove since it is for different purpose
            if (isApprove && validateEvenIfApprover === false) {
              const datediff = differenceInCalendarDays(c.value, new Date());
              message = `${property} cannot be a past date`;
              return (datediff >= 0);
            }
            if (!isNullOrUndefined(c.value)) {
              const datediff = differenceInCalendarDays(c.value, new Date());
              return (datediff >= days);
            }
            return false;


          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    return getMergedConfig(config, additionalConfig);
  }

  UserProfileAcceptDateAfter(
    days: number,
    message: string,
    property: string,
    checkAcceptAndApprove = false,

    additionalConfig?: FormlyFieldConfig,
    validateEvenIfApprover = false): FormlyFieldConfig {
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        vname: {
          expression: (c) => {
            if (isNullOrUndefined(c.value)) {
              return true;
            }

            if (isApprove && !checkAcceptAndApprove) {
              return true;
            }

            if (isApprove && validateEvenIfApprover === false) {
              const datediff = differenceInCalendarDays(c.value, new Date());
              message = `${property} cannot be a past date`;
              return (datediff >= 0);
            }
            if (!isNullOrUndefined(c.value)) {
              const datediff = differenceInCalendarDays(c.value, new Date());
              return (datediff >= days);
            }
            return false;


          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    return getMergedConfig(config, additionalConfig);
  }

  AcceptDateBefore(
    days: number,
    message: string,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        vname: {
          expression: (c) => {
            if (isApprove) {
              return true;
            }
            if (!isNullOrUndefined(c.value)) {
              const datediff = differenceInCalendarDays(c.value, new Date());
              return (datediff <= days);
            }
            return false;


          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    return getMergedConfig(config, additionalConfig);
  }

  AcceptDateBeforeWithoutPastDate(
    days: number,
    message: string,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    let PastDateMessage: string = "Visa expiry date cannot be a past date";
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        vname: {
          expression: (c) => {
            if (isApprove) {
              return true;
            }
            if (!isNullOrUndefined(c.value)) {
              const datediff = differenceInCalendarDays(c.value, new Date());

              if (datediff < 0) {
                PastDateMessage = "Visa expiry date cannot be a past date";
                return false;

              }
              else {
                PastDateMessage = message;
                return (datediff <= days);
              }

            }
            return false;


          },
          message: (error, field: FormlyFieldConfig) => PastDateMessage,
        }
      },
    };

    return getMergedConfig(config, additionalConfig);
  }

  ValidateIssuanceDate(
    days: number,
    message: string,
    property: string,
    checkAcceptAndApprove = false,

    additionalConfig?: FormlyFieldConfig,
    validateEvenIfApprover = false): FormlyFieldConfig {
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        vname: {
          expression: (c) => {

            //if (isApprove && !checkAcceptAndApprove) {
            //  return true;
            //}

            // validateEvenIfApprover introduced since for UAE mission visa
            // a requirement was to check for 89days in approver section
            // Not validating with checkAcceptAndApprove since it is for different purpose
            if (isApprove && validateEvenIfApprover === false) {
              const datediff = differenceInCalendarDays(c.value, this.acceptDate);
              if (datediff < 0) {
                message = `${property} cannot be a past date`;
                return (datediff >= 0);
              }
              else {
                return (datediff <= days);
              }

            }
            return false;


          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    return getMergedConfig(config, additionalConfig);
  }

  required(model: any, isApproveOrAccept) {
    let req = false;

    if ((!isApproveOrAccept && !isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1074)
      || (isApproveOrAccept && !isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1074)) {
      req = true;
    }
    if ((!isApproveOrAccept && !isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1075)
      || (isApproveOrAccept && !isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1075)) {
      req = false;
    }
    return req;
  }

  disabled(model: any, isApproveOrAccept) {
    let dis = true;
    if ((!isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1074) || isApproveOrAccept) {
      dis = false;
    }
    if (!isApproveOrAccept && !isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1075) {
      dis = true;
    }
    return dis;
  }
  isDateGreaterThanToday(func: (date, dateToCompare) => boolean,
    message: string, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      validators: {
        dateInvalid: {

          expression: (c: any, formState: FormlyFieldConfig) => {
            let today = new Date();
            if (c && c.value && today) {
              return func(c.value, today);
            } else {
              return true;
            }
          },
          message: (error, field: FormlyFieldConfig) => message
        }
      },
    }
    config.hooks = {
      onInit: field => {

      }
    }
    return getMergedConfig(config, additionalConfig);
  }

  isDateGreaterThanDate(
    func: (date, dateToCompare) => boolean,
    message: string,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    let parentControl: AbstractControl;
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        dateInvalid: {
          expression: (c: any, formState: FormlyFieldConfig) => {
            if (c && c.value && parentControl && parentControl.value) {
              return func(c.value, parentControl.value);
            } else {
              return true;
            }
          },
          message: (error, field: FormlyFieldConfig) => message
        }
      },
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          // const validationMsg = 'Please enter a date before start date';
          const dateControl = field.formControl;
          parentControl = this.findFormControl(parentKey, field);

          parentControl.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              distinctUntilChanged(),
              tap(date => {
                if (dateControl && dateControl.value) {
                  dateControl.updateValueAndValidity();
                  setTimeout(() => {
                    dateControl.markAsTouched();
                  }, 1);
                }
              })
            )
            .subscribe();
        }
      };
    }

    return getMergedConfig(config, additionalConfig);
  }


  AcceptDateAfterMonthsExceptMissionVisa(
    pivotDate: Date,
    months: number,
    message: string,
    checkInAcceptAndApprove = true,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let parentControl: AbstractControl;
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        notAfterSpecifiedMonths: {
          expression: (c) => {
            if (isApprove && !checkInAcceptAndApprove) {
              return true;
            }
            if (parentControl && parentControl.value == 970) {
              //Validation not required for Mission visa --970
              return true;
            }
            if (c && c.value) {
              //Validation not required for Mission visa --970
              const futureDate = addMonths(pivotDate, months);
              return (futureDate <= c.value);
            }
            return false;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    config.hooks = {
      onInit: field => {
        const dateControl = field.formControl;
        parentControl = this.findFormControl("visaStatus.id", field);

        parentControl.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            distinctUntilChanged(),
            tap(() => {
              if (dateControl && dateControl.value) {
                dateControl.updateValueAndValidity();
                setTimeout(() => {
                  dateControl.markAsTouched();
                }, 1);
              }
            })
          )
          .subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }


  checkDateDifference(
    func: (date, dateToCompare) => number,
    days: number,
    message: string,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    let parentControl: AbstractControl;
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        dateInvalid: {
          expression: (c: any, formState: FormlyFieldConfig) => {
            if (c && c.value && parentControl && parentControl.value) {
              if (func(c.value, parentControl.value) > days) {
                return true;
              } else {
                return false;
              }


            } else {
              return true;
            }
          },
          message: (error, field: FormlyFieldConfig) => message
        }
      },
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          // const validationMsg = 'Please enter a date before start date';
          const dateControl = field.formControl;
          parentControl = this.findFormControl(parentKey, field);

          parentControl.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              distinctUntilChanged(),
              tap(date => {
                if (dateControl && dateControl.value) {
                  dateControl.updateValueAndValidity();
                  setTimeout(() => {
                    dateControl.markAsTouched();
                  }, 1);
                }
              })
            )
            .subscribe();
        }
      };
    }

    return getMergedConfig(config, additionalConfig);
  }
  ValidateCountryCode(
    validCode: string,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        showUsingTooltip: false
      },
    };

    config.hooks = {
      onInit: field => {
        const ele = field.formControl;
        if (ele.value != validCode && ele.value != null) {

          field.templateOptions.validityText = "Please ensure that the code entered is correct";

        } else {
          field.templateOptions.validityText = null;
        }
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(result => {
              if (result.countryCode != null && result.countryCode != validCode) {
                field.templateOptions.validityText = "Please ensure that the code entered is correct";

              } else {
                field.templateOptions.validityText = null;
              }
            })
          ).subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

ValidateChargeCode(
  message: string,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  let childControl: AbstractControl;
  let childControl1: AbstractControl;
  const config: FormlyFieldConfig = {
    templateOptions: {
      showUsingTooltip: false
    },
    validators: {
      chargeCodeValidator: {
        expression: (control: AbstractControl) => {
          const cc = (control.value || '').trim();
          if (!cc) {
            return true;
          }
          return /^[A-Za-z]-\w{8}$/.test(cc) && cc.length === 10;
        },
        message: (error, field: FormlyFieldConfig) =>
          field.templateOptions?.validityText || 'Invalid Charge Code',
      }
    }
  };

  config.hooks = {
    onInit: field => {
      const ele = field.formControl;
      childControl = this.findFormControl("engagementName", field);
      childControl1 = this.findFormControl("engPartnerName", field);
      ele.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(ele.value),
          tap(chargeCode => {
            const cc = (chargeCode || '').trim();
            childControl?.setValue(null);
            childControl?.enable();
            childControl1?.setValue(null);
            childControl1?.enable();
            field.templateOptions.validityText = null;
            const errors = ele.errors || {};
            delete errors['inactiveCode'];
            delete errors['apiError'];
            if (Object.keys(errors).length === 0) {
              ele.setErrors(null);
            } else {
              ele.setErrors(errors);
            }

            if (!cc) {
              return;
            }

            if (!/^[A-Za-z]-\w{8}$/.test(cc) || cc.length !== 10) {
              field.templateOptions.validityText =
                "The Charge code must start with a letter, have a hyphen as the second character, and be exactly 10 characters long.";
              ele.setErrors({ invalidFormat: true });
              return;
            }
            const currentErrors = ele.errors || {};
            if (currentErrors.invalidFormat) {
              delete currentErrors.invalidFormat;
              if (Object.keys(currentErrors).length === 0) {
                ele.setErrors(null);
              } else {
                ele.setErrors(currentErrors);
              }
            }

            this.validationApi.getChargeCodeDetails(cc).pipe(
              debounceTime(500),
              distinctUntilChanged(),
              tap((r: any) => {
               const asyncErrors = ele.errors || {};
                delete asyncErrors.inactiveCode;
                delete asyncErrors.apiError;
                delete asyncErrors.cancelledCode;
                if (r?.isActive === 2) {
                  field.templateOptions.validityText =
                    "The engagement code updated is inactive, please update an active engagement code to submit this request.";
                  asyncErrors['inactiveCode'] = true;
                  ele.setErrors(asyncErrors);
                }
                else if (r?.statusId === 3) {
                  field.templateOptions.validityText =
                    "The engagement code updated is Cancelled, please update an active engagement code to submit this request.";
                  asyncErrors['cancelledCode'] = true;
                  ele.setErrors(asyncErrors);
                }
                else if (r?.isActive === 3) {
                  field.templateOptions.validityText =
                    "This is a non-MENA charge code, please check to ensure it is active and interoperable code before submitting the request.";
                  if (Object.keys(asyncErrors).length === 0) {
                    ele.setErrors(null);
                  } else {
                    ele.setErrors(asyncErrors);
                  }
                }
                else if (r?.statusId === 4 || r?.statusId === 5) {
                  console.log('r?.statusId', r?.statusId);
                  field.templateOptions.validityText =
                    "The claim may be rejected because the charge code is currently in a pre-closing or closing status.";
                  if (Object.keys(asyncErrors).length === 0) {
                    ele.setErrors(null);
                  } else {
                    ele.setErrors(asyncErrors);
                  }
                  return;
                }
                else if (r?.isActive === 1) {
                  field.templateOptions.validityText = null;
                  childControl?.setValue(r.engagementName);
                  childControl1?.setValue(r.engPartnerName);
                  childControl?.disable();
                  childControl1?.disable();
                  if (Object.keys(asyncErrors).length === 0) {
                    ele.setErrors(null);
                  } else {
                    ele.setErrors(asyncErrors);
                  }
                } else {
                  field.templateOptions.validityText =
                    "This is a non-MENA charge code, please check to ensure it is active and interoperable code before submitting the request.";
                  if (Object.keys(asyncErrors).length === 0) {
                    ele.setErrors(null);
                  } else {
                    ele.setErrors(asyncErrors);
                  }
                }
              })
            ).subscribe();
          })
        ).subscribe();
    }
  };

  return getMergedConfig(config, additionalConfig);
}

  ValidateChargeCodeAndEnable(
    message: string,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    let childControl: AbstractControl;
    let childControl1: AbstractControl;
    let childControl2: AbstractControl;
    const config: FormlyFieldConfig = {
      templateOptions: {
        showUsingTooltip: false
      },
    };

    config.hooks = {
      onInit: field => {
        const ele = field.formControl;
        childControl = this.findFormControl("engagementName", field);
        childControl1 = this.findFormControl("engPartnerName", field);
        childControl2 = this.findFormControl("engManagerName", field);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(chargeCode => {
              const cc = nullSafe(() => chargeCode.trim(), '');
              childControl?.setValue(null);
              // childControl?.enable();
              childControl1?.setValue(null);
              childControl2?.setValue(null);
              // childControl1?.enable();
              if (cc.length >= 6) {
                this.validationApi.getCCDetails(cc).pipe(
                  debounceTime(2000),
                  distinctUntilChanged(),
                  tap(r => {
                    if (r.isActive === 2) {
                      field.templateOptions.validityText = "Charge code entered is invalid";
                    } else if (r.isActive === 3) {
                      field.templateOptions.validityText = "Charge code is not validated";
                      childControl.enable();
                      childControl1.enable();
                      childControl2.enable();
                    } else {
                      field.templateOptions.validityText = null;
                      childControl.setValue(r.engagementName)
                      childControl1.setValue(r.engPartnerName)
                      childControl2.setValue(r.engManagerName)
                      childControl.disable();
                      childControl1.disable();
                      childControl2.disable();
                    }
                  })).subscribe();
              } else if (cc.length >= 1) {
                field.templateOptions.validityText = "Charge code is not validated";
                childControl.enable();
                childControl1.enable();
                childControl2.enable();

              } else {
                field.templateOptions.validityText = null;
              }
            })
          ).subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  ValidateTravelDate(
    days: number,
    message: string,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        showUsingTooltip: false
      },
    };

    config.hooks = {
      onInit: field => {
        const ele = field.formControl;
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(dateOfTravel => {

              const datediff = differenceInCalendarDays(dateOfTravel, new Date());
              if (datediff <= days || dateOfTravel > new Date()) {
                field.templateOptions.validityText = message;
              }
              else {
                field.templateOptions.validityText = null;
              }
            })
          ).subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  validateJorDateOfTravel(
    property: string,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
    };
    config.hooks = {
      onInit: field => {
        const typeOfVisaId = this.findFormControl('typeOfVisa.id', field);
        const dateOfTravel = this.findFormControl('dateOfTravel', field);
        const ele = field.formControl;
        const startDate = addDays(new Date(), -1);
        const endDate = addDays(new Date(), 9);
        const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(dateTravel => {
              const datediff = differenceInCalendarDays(dateTravel, new Date());
              if (datediff < 0) {
                this.setError(false, field, { 'custom-error': `${property} cannot be a past date` });
                return;
              }
              if (typeOfVisaId.value == 15255) {
                const errorMessage = 'For "Normal visa" type, the travel date must be at least 10 working days before the request submission date. To proceed with this request, kindly change the travel date or select "Express visa" under visa type. Please note the express visa option attracts additional fees and can be processed within 3-4 working days.';
                if (isNullOrUndefined(dateTravel)) {
                  this.setError(true, field, { 'custom-error': errorMessage });
                }
                else if ((isApprove || !isNullOrUndefined(dateTravel)) && datediff < 10) {
                  this.setError(false, field, { 'custom-error': errorMessage });
                }
              }
            })
          ).subscribe();
        typeOfVisaId.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(typeOfVisaId.value),
            tap(typeOfvisa => {
              this.setError(true, field, { 'custom-error': null });
              const datediff = differenceInCalendarDays(dateOfTravel.value, new Date());
              if (datediff < 0) {
                this.setError(false, field, { 'custom-error': `${property} cannot be a past date` });
                return;
              }
              if (typeOfvisa == 15255) {
                const errorMessage = 'For "Normal visa" type, the travel date must be at least 10 working days before the request submission date. To proceed with this request, kindly change the travel date or select "Express visa" under visa type. Please note the express visa option attracts additional fees and can be processed within 3-4 working days.';
                if (isNullOrUndefined(dateOfTravel.value)) {
                  this.setError(true, field, { 'custom-error': errorMessage });
                }
                else if ((isApprove || !isNullOrUndefined(dateOfTravel.value)) && datediff < 10) {
                  this.setError(false, field, { 'custom-error': errorMessage });
                }
              }
            })
          ).subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }


  prepareImmEmailTemplatesObservable(
    visaTypeId: number,
    isAutoTemp: boolean,
    officeToBeVisitedID?: number,
    officeLEId?: number
  ): Observable<DeptCodeblock[]> {
    if (!visaTypeId) {
      return EMPTY;
    }
    let officeToBeVisitedIDValue = officeToBeVisitedID === null ? undefined : officeToBeVisitedID;
    let officeLEIdValue = officeLEId === null ? undefined : officeLEId;
    const cb$ = this.emailApi.getImmEmailTemplates(visaTypeId, isAutoTemp, officeToBeVisitedIDValue, officeLEIdValue).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    // cb$.subscribe(dcb => {
    //     this.deptCodeBlock$.next(dcb);
    // });
    return cb$;
  }
  // getImmEmailTemplateSelectFieldOptions(onChange: (obj: ImmigrationMailTemplateInfo) => void, additionalConfig?: FormlyFieldConfig,) {
  //   const config: FormlyFieldConfig = {
  //     templateOptions: {
  //       options: [],
  //       valueProp: (option) => option,
  //       compareWith: (o1, o2) => o1.id === o2.id,
  //       labelProp: "activityHeader"
  //     }
  //   };
  //   config.hooks = {
  //     onInit: field => {
  //       const vistypeId = this.findFormControl('visaTypeId.id', field);
  //       const isAuto = this.findFormControl('showSysTemplates', field);
  //       const officeToBeVisitedId = this.findFormControl('officeToBeVisited.id', field);
  //       const officeLEId = this.findFormControl('officeLE.id', field);
  //       field.formControl.valueChanges.pipe(
  //         takeUntil(this.destroyed$),
  //       ).subscribe(onChange);
  //       vistypeId.valueChanges
  //         .pipe(
  //           takeUntil(this.destroyed$),
  //           startWith(vistypeId.value),
  //           tap(id => {
  //             if (!field.form.disabled) {
  //               field.formControl.setValue(null);
  //             }
  //             if (id > 0) {
  //               field.templateOptions.options = this.prepareImmEmailTemplatesObservable(id, isAuto.value,officeToBeVisitedId.value,officeLEId.value);
  //             } else {
  //               field.templateOptions.options = EMPTY;
  //             }
  //           })
  //         ).subscribe();
  //     }
  //   };
  //   return getMergedConfig(config, additionalConfig);
  // }

  getImmEmailTemplateSelectFieldOptions(onChange: (obj: ImmigrationMailTemplateInfo) => void, additionalConfig?: FormlyFieldConfig,) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: (option) => option,
        compareWith: (o1, o2) => o1.id === o2.id,
        labelProp: "activityHeader"
      }
    };
    config.hooks = {
      onInit: field => {
        const vistypeId = this.findFormControl('visaTypeId.id', field);
        const isAuto = this.findFormControl('showSysTemplates', field);
        const officeToBeVisitedId = this.findFormControl('officeToBeVisited.id', field);
        const officeLEId = this.findFormControl('officeLE.id', field);
        field.formControl.valueChanges.pipe(
          takeUntil(this.destroyed$),
        ).subscribe(onChange);
        vistypeId.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(vistypeId.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (id > 0) {
                field.templateOptions.options = this.prepareImmEmailTemplatesObservable(id, isAuto.value, officeToBeVisitedId.value, officeLEId.value);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          ).subscribe();


        officeToBeVisitedId.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(officeToBeVisitedId.value),
            tap(officeid => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              field.templateOptions.options = this.prepareImmEmailTemplatesObservable(vistypeId.value, isAuto.value, officeid, officeLEId.value);
            })
          ).subscribe();

        officeLEId.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(officeLEId.value),
            tap(officeLEid => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              field.templateOptions.options = this.prepareImmEmailTemplatesObservable(vistypeId.value, isAuto.value, officeToBeVisitedId.value, officeLEid);
            })
          ).subscribe();


      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  validateRequestForSubmit(visaType: string, country: string, model: ImmigrationProfile): { valid: boolean, message?: string } {
    switch (country) {
      case 'SAU':
        if (visaType === 'IqamaIssuance' ||
          visaType === 'IqamaTransfer' ||
          visaType === 'EmploymentVisa' ||
          visaType === 'GOSIadditional') {
          if (model.nationality.id === 203 &&
            (model.nationalityType.id === 14570 || model.nationalityType.id === 14571)) {
            return { valid: false, message: 'The nationality type cannot be Expat and Expat(GCC National) while nationality is Saudi Arabia' }
          }
        }
      case CountryTypesValues.UAE:
        if (visaType === VisaTypesValues.ARETawteen) {
          if (Number(model.ageFrom) > Number(model.ageTo)) {
            return { valid: false, message: 'Age(from) cannot be greater than Age(To)' };
          }
        }
        break;
    }

    return { valid: true, message: '' };
  }
  validateDependentDetails(visaType: string, country: string, model: ImmigrationProfile): { valid: boolean, message?: string } {
    switch (country) {
      case CountryTypesValues.UAE:
        if (visaType === VisaTypesValues.AREDependentsVisaIssuance || visaType === VisaTypesValues.AREDependentsVisaRenewal
          || visaType === VisaTypesValues.AREDepVisaGccMarriedToExpat) {
          if (!isNullOrUndefined(model) && !isNullOrUndefined(model.childrenDetails) &&
            Number(model.childrenDetails.length) <= 15 && Number(model.spouseDetails.length) <= 15) {
            return { valid: false, message: 'Please add dependent details' };
          }
        }
        break;
    }
    return { valid: true, message: '' };
  }
  //omitSpecialChar- returns true if the string contains special characers other than '-'( allowed characters: A-Z,a-z,0-9,backspace,space and '-')
  omitSpecialChar(value: string): boolean {
    for (var i = 0; i < value.length; i++) {
      let asciiValue = value.charCodeAt(i)
      if (!((asciiValue > 64 && asciiValue < 91) || (asciiValue > 96 && asciiValue < 123) || asciiValue == 8 || asciiValue == 32 || asciiValue == 45 || (asciiValue >= 48 && asciiValue <= 57)))
        return true;
    }
    return false;
  }

  AcceptDateAfterMonths(
    pivotDate: Date,
    months: number,
    message: string,
    checkInAcceptAndApprove = true,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {

    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        notAfterSpecifiedMonths: {
          expression: (c) => {
            if (isApprove && !checkInAcceptAndApprove) {
              return true;
            }
            if (!isNullOrUndefined(c.value)) {
              const futureDate = addMonths(pivotDate, months);
              return (futureDate <= c.value);
            }
            return false;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };
    return getMergedConfig(config, additionalConfig);
  }

  AcceptDateBeforeMonths(
    pivotDate: Date,
    months: number,
    message: string,
    checkInAcceptAndApprove = true,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {

    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        notAfterSpecifiedMonths: {
          expression: (c) => {
            if (isApprove && !checkInAcceptAndApprove) {
              return true;
            }
            if (!isNullOrUndefined(c.value)) {
              const futureDate = addMonths(pivotDate, months);
              return (futureDate >= c.value);
            }
            return false;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };
    return getMergedConfig(config, additionalConfig);
  }

AcceptDateAfterANDBeforeYears(
  pivotDate: Date,
  minYears: number,
  maxYears: number,
  message: string,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
      templateOptions: {},
      validators: {
          notOutsideAgeRange: {
              expression: (c) => {
                  if (!isNullOrUndefined(c.value)) {
                      const minDate = subYears(pivotDate, maxYears); // 80 years ago
                      const maxDate = subYears(pivotDate, minYears); // 16 years ago

                      const inputDate = new Date(c.value);
                      if (inputDate >= minDate && inputDate <= maxDate) {
                          return true;
                      }
                  }
                  return false;
              },
              message: (error, field: FormlyFieldConfig) => message,
          },
      },
  };
  return getMergedConfig(config, additionalConfig);
}

  AcceptDateBetweenMonths(
    pivotDate: Date,
    fromMonth: number,
    toMonth: number,
    message: string,
    checkInAcceptAndApprove = true,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {

    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        notAfterSpecifiedMonths: {
          expression: (c) => {
            if (isApprove && !checkInAcceptAndApprove) {
              return true;
            }
            if (!isNullOrUndefined(c.value)) {
              const futureDate1 = addMonths(pivotDate, fromMonth);
              const futureDate2 = addMonths(pivotDate, toMonth);
              return (c.value >= futureDate1 && c.value <= futureDate2)
            }
            return false;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };
    return getMergedConfig(config, additionalConfig);
  }

  getValueChangesHook(field: string, form: FormlyFieldConfig) {
    const control = this.findFormControl(field, form);
    return control.valueChanges.pipe(takeUntil(this.destroyed$), startWith(control.value))
  }

filterHook(
  filterFunc: (value) => Array<any>,
  basedOnfield: string,
  dataSource: Observable<LookupField[]>,
    additionalConfig?: FormlyFieldConfig) {

  const config: FormlyFieldConfig = {
      templateOptions: {
      }
  };
  config.hooks = {
    onInit: field => {
      let isFirstRun = true;
      this.getValueChangesHook(basedOnfield, field)
          .pipe(tap(id => {
            field.templateOptions.options = EMPTY;

            // Always reset value on change, even if disabled
            if (!isFirstRun) {
              const savedValue = field.formControl.value;

              // Temporarily enable, set value, then disable again
              if (field.formControl.disabled) {
                field.formControl.enable({ emitEvent: false });
                field.formControl.setValue(savedValue, { emitEvent: false });
                field.formControl.disable({ emitEvent: false });
              } else {
                field.formControl.setValue(savedValue, { emitEvent: false });
              }
            }
            const filteredResult = filterFunc(id);
            if (!isNullOrUndefined(id) && filteredResult) {
              field.templateOptions.options = dataSource.pipe(map(x => x.filter(v => filteredResult.includes(v.id))));
            }
            if (!isNullOrUndefined(id) && !filteredResult) {
              field.templateOptions.options = dataSource;
            }
            isFirstRun = false;
          })
        )
        .subscribe();
    }
  };
  return getMergedConfig(config, additionalConfig);
}

  //for selecting values based on  two filters
  filterHookArray(
    filterFunc: (value) => Array<any>,
    basedOnfield: Array<any>,
    dataSource: Observable<LookupField[]>,
    additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
      }
    };
    config.hooks = {

      onInit: field => {
        const returnArray = [];
        basedOnfield.forEach((fieldval) => {
          returnArray.push({
            key: fieldval,
            value: 0
          })
          this.getValueChangesHook(fieldval, field)
            .pipe(tap(id => {
              field.props.options = EMPTY;
              if (!field.form.disabled && !field.form?.value) {
                field.formControl.setValue(null)
              }
              returnArray.find(x => x.key == fieldval).value = id;

              if (!isNullOrUndefined(id)) {
                const filteringValues = filterFunc(returnArray);
                if (filteringValues) {
                  field.props.options = dataSource.pipe(map(x => x.filter(v => filteringValues.includes(v.id))));
                }
              }

              if (!isNullOrUndefined(id)) {
                const filteringValues = filterFunc(returnArray);
                if (!filteringValues) {
                  field.props.options = dataSource;
                }
              }
            })
            ).subscribe();
        })

      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getnationalityFilterByPreboarding(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    nat$.subscribe(n => this.nationality$.next(n));

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: nat$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const pbTypeEle = this.findFormControl('preboardingType.id', field);
        const genderEle = this.findFormControl('gender.id', field);
        const ele = field.formControl;

        pbTypeEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(pbTypeEle.value),
            tap(id => {
              this.getNationalityforQAT_RPIssuance(id, genderEle.value, field, nat$)
            })
          ).subscribe();
        genderEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(genderEle.value),
            tap(id => {
              this.getNationalityforQAT_RPIssuance(pbTypeEle.value, id, field, nat$)
            })
          ).subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }


// Business Traveller Nationality type Validations
getBTNationalityTypeFieldOptionsBasedOnType(
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    key: "nationalityType.id",
    type: "select",
    templateOptions: {
      valueProp: "id",
      labelProp: "displayText",
      showUsingTooltip: false,
      validityText: null
    },
    validators: {
      nationalityTypeValidator: {
        expression: (control: AbstractControl, field?: FormlyFieldConfig) => {
          const natTypeId = control?.value;
          const rootForm = field?.form || control?.root; 
          const destinationCountry = rootForm?.get("countryToBeVisited")?.value;
          const destinationCountryId = destinationCountry?.id;

          const gccCountryIds = [1047, 1048, 1049, 1050, 1051, 1052];
          if (!natTypeId) {
            field!.templateOptions!.validityText = null;
            return true;
          }

          if ([14572, 14573].includes(natTypeId)) {
            field!.templateOptions!.validityText =
              "Nationals do not require a visa to visit their own country. Please update nationality type to proceed.";
            return false;
          }

          if (natTypeId === 14571 && destinationCountryId && gccCountryIds.includes(destinationCountryId)) {
            field!.templateOptions!.validityText =
              "GCC Nationals do not require a visa to visit other GCC countries. Please update nationality type to proceed.";
            return false;
          }

          field!.templateOptions!.validityText = null;
          return true;
        },
        message: (error, field: FormlyFieldConfig) =>
          field?.templateOptions?.validityText || "Invalid nationality type selection",
      }
    },
    hooks: {
      onInit: field => {
        const ctrl = field.formControl;
        const rootForm = field.form;
        const countryCtrl = rootForm?.get("countryToBeVisited");

        if (!ctrl) return;

        merge(
          ctrl.valueChanges.pipe(startWith(ctrl.value)),
          countryCtrl ? countryCtrl.valueChanges.pipe(startWith(countryCtrl.value)) : EMPTY
        )
        .pipe(takeUntil(this.destroyed$))
        .subscribe(() => {

          ctrl.updateValueAndValidity({ emitEvent: false });
        });
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}

  getNationalityFieldOptionsBasedonNationality(
    isGcc: boolean = false,
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    nat$.subscribe(n => this.nationality$.next(n));
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: nat$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const natTypeEle = this.findFormControl('nationalityType.id', field);
        const ele = field.formControl;
        let isFirst = true;
  
        natTypeEle.valueChanges.subscribe(natTypeId => {
          if (natTypeId === 14572 || natTypeId === 14573) {
            isFirst = false;
            const nationality = this.nationality$.getValue().find(n => n.value === this.immigrationCountry);
            ele.setValue(nationality?.id ?? null);
            ele.disable(); 
            field.templateOptions.options = this.nationality$.getValue().map(nat => {
              nat.disabled = nat.value === this.immigrationCountry; 
              return nat;
            });
          } else {
            if (!field.form.disabled) {
               if (!isFirst) {                
                  ele.enable();
                  ele.setValue(0);
                }
              // ele.enable();
              // ele.setValue(null);
              isFirst = false;
              if (natTypeId === 14570) {
                field.templateOptions.options = this.nationality$.getValue().map(nat => {
                  nat.disabled = nat.value === this.immigrationCountry;
                  return nat;
                });
              }
              else if (natTypeId === 14571) {
                field.templateOptions.options = this.nationality$.getValue().filter(i =>
                  [175, 241, 203, 188, 26, 127].includes(i.id)
                ).map(nat => {
                  nat.disabled = nat.value === this.immigrationCountry;
                  return nat;
                });
              }
              else {
                field.templateOptions.options = this.nationality$.getValue().map(nat => {
                  nat.disabled = nat.value === this.immigrationCountry;
                  return nat;
                });
              }
            }
          }
        });
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
  

  validateDOBOnRelationship(
    parentKey: string,
    additionalConfig?: FormlyFieldConfig,
    checkForApprover = false
  ): FormlyFieldConfig {
    let relationship: AbstractControl;
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    let message: string;
    //currentValueOfRelationship will have value when the value in relationship dropdown changes
    let currentValueOfRelationship;
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        childDOBInvalidErr: {
          expression: (c) => {

            if (isApprove && !checkForApprover) {
              return true;
            }

            if (c && c.value && c.parent && c.parent.value && c.parent.value.relationship.id && ((currentValueOfRelationship == 0 && c.parent.value.relationship.id == 9008) || currentValueOfRelationship == 9008)) {
              message = "Date of birth cannot be in the future";
              const datediff = differenceInCalendarDays(c.value, new Date());
              if (datediff > 0) {
                return (datediff <= 0);
              }
              message = "Dependent visa cannot be issued for children above 18 years old";
              const datediff1 = differenceInYears(c.value, new Date());
              return (datediff1 > -18);
            }

            if (c && c.value && c.parent && c.parent.value && c.parent.value.relationship.id && ((currentValueOfRelationship == 0 && c.parent.value.relationship.id != 9008) || currentValueOfRelationship != 9008)) {
              message = "Date of birth cannot be in the past 10 years or in the future";
              const datediff = differenceInYears(c.value, new Date());
              return (datediff <= 0 && datediff <= -10 && datediff >= -100);
            }
            return true;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const dob = field.formControl;
          relationship = this.findFormControl('relationship.id', field);
          currentValueOfRelationship = 0;
          relationship.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              distinctUntilChanged(),
              tap(date => {
                if (dob && dob.value) {
                  currentValueOfRelationship = date;
                  dob.updateValueAndValidity();
                  setTimeout(() => {
                    dob.markAsTouched();
                  }, 1);
                }
              })
            )
            .subscribe();
        }
      };
    }


    return getMergedConfig(config, additionalConfig);
  }


  validateRPExpiry(
    message: string,
    parentKey: string,
    additionalConfig?: FormlyFieldConfig,
    checkForApprover = false
  ): FormlyFieldConfig {
    let rpExpiryDate: AbstractControl;
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        durationRPExpiry: {
          expression: (c) => {

            if (isApprove && !checkForApprover) {
              return true;
            }

            if (c && c.value && rpExpiryDate && rpExpiryDate.value) {
              const datediff = differenceInDays(rpExpiryDate.value, new Date())
              return (c.value <= datediff);
            }
            return true;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const durationField = field.formControl;
          rpExpiryDate = this.findFormControl('rpExpiryDate', field);

          rpExpiryDate.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              distinctUntilChanged(),
              tap(date => {
                if (durationField && durationField.value) {
                  durationField.updateValueAndValidity();
                  setTimeout(() => {
                    rpExpiryDate.markAsTouched();
                  }, 1);
                }
              })
            )
            .subscribe();
        }
      };
    }


    return getMergedConfig(config, additionalConfig);
  }

  validateCivilIDExpiryOnVisatype(
    message: string,
    parentKey: string,
    additionalConfig?: FormlyFieldConfig,
    checkForApprover = false
  ): FormlyFieldConfig {
    let visaType: AbstractControl;
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);

    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        civilIdExp: {
          expression: (c) => {

            if (isApprove && !checkForApprover) {
              return true;
            }

            if (c && c.value && visaType && visaType.value && visaType.value == 9001) {
              const datediff = differenceInYears(c.value, new Date())
              return (datediff > 0);
            }
            return true;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const expDate = field.formControl;
          visaType = this.findFormControl('shortTermVisa.id', field);

          visaType.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              distinctUntilChanged(),
              tap(date => {
                if (expDate && expDate.value) {
                  expDate.updateValueAndValidity();
                  setTimeout(() => {
                    visaType.markAsTouched();
                  }, 1);
                }
              })
            )
            .subscribe();
        }
      };
    }


    return getMergedConfig(config, additionalConfig);
  }


  getNationalityWrtPbTypeAndGender(
    country: string,
    additionalConfig?: FormlyFieldConfig,
    filterMethod = (item) => item): FormlyFieldConfig {
    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    nat$.subscribe(n => this.nationality$.next(n));
    const isApprove = (this.route.url.indexOf('approve') > 0)
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: nat$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const pbTypeEle = this.findFormControl('preboardingType.id', field);
        const ele = field.formControl;
        const genderELe = this.findFormControl('gender.id', field);


        pbTypeEle.valueChanges.subscribe(pb => {
          if (pbTypeEle.value === 1046) {
            const nationalty = this.nationality$.getValue()
              .filter((item) => filterMethod(item))
              .find(n => n.value === nullSafe(() => country, ''));
            ele.setValue(nullSafe(() => nationalty.id, null));
            ele.disable();
          } else {
            if (!field.form.disabled && genderELe.value === 7) {
              field.templateOptions.options = this.nationality$.getValue()
                .filter((item) => filterMethod(item))
                .map(nat => {
                  nat.disabled = nat.value === country;
                  return nat;
                });
              ele.setValue(null);
              if (!isApprove) { ele.enable(); }
            } else {
              if (!field.form.disabled && genderELe.value === 8) {
                field.templateOptions.options = this.nationality$.getValue()
                  .map(nat => {
                    nat.disabled = nat.value === country;
                    return nat;
                  });
                ele.setValue(null);
                if (!isApprove) { ele.enable(); }
              }
            }
          }
        });



        genderELe.valueChanges.subscribe(pb => {
          if (pbTypeEle.value === 1046) {
            const nationalty = this.nationality$.getValue()
              .filter((item) => filterMethod(item))
              .find(n => n.value === nullSafe(() => country, ''));
            ele.setValue(nullSafe(() => nationalty.id, null));
            ele.disable();
          } else {
            if (!field.form.disabled && genderELe.value === 7) {
              field.templateOptions.options = this.nationality$.getValue()
                .filter((item) => filterMethod(item))
                .map(nat => {
                  nat.disabled = nat.value === country;
                  return nat;
                });
              ele.setValue(null);
              ele.enable();
            } else {
              if (!field.form.disabled && genderELe.value === 8) {
                field.templateOptions.options = this.nationality$.getValue()
                  .map(nat => {
                    nat.disabled = nat.value === country;
                    return nat;
                  });
                ele.setValue(null);
                ele.enable();
              }
            }
          }
        });

      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  displayPreviousEmploymentFileds(condition: (model: any) => boolean, additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
        if (condition(model)) {
        }
        return condition(model);
      },
    }

    return getMergedConfig(config, additionalConfig);
  }
  validatepreviousEmploymentFields(condn: boolean, additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      expressionProperties: {
        'templateOptions.disabled': (model: any, formState: any, field: FormlyFieldConfig) => {
          var disable = false;
          if (condn) {
            disable = true;
            if (condn && (!isNullOrUndefined(model.previousEmployee) && model.previousEmployee.id == 953))
              disable = false;
          }
          if (disable && isNullOrUndefined(field.formControl.value)) {
            field.formControl.setValue(undefined);
          }
          return disable;
        },
      }
    }
    return getMergedConfig(config, additionalConfig);
  }
  validateEndDate(message: string, parentKey, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let previousEmployerStartDate: AbstractControl;
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        endDate: {
          expression: (c) => {
            if (c && !isNullOrUndefined(c.value) && previousEmployerStartDate && !isNullOrUndefined(previousEmployerStartDate.value)) {
              let diff = (differenceInDays(c.value, previousEmployerStartDate.value))
              if (diff > 0) {
                return true;
              }
              else {
                return false
              }

            }
            return true;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      }
    };
    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {

          const dos = field.formControl;

          previousEmployerStartDate = this.findFormControl('lastEmployerDetail.lastEmployerStartDate', field);
          previousEmployerStartDate?.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              distinctUntilChanged(),
              tap(date => {
                if (dos && dos.value) {
                  dos.updateValueAndValidity();
                  setTimeout(() => {
                    previousEmployerStartDate.markAsTouched();
                  }, 1);
                }
              })
            )
            .subscribe();
          dos?.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              distinctUntilChanged(),
              tap(date => {
                if (dos && dos.value) {
                  dos.updateValueAndValidity();
                  setTimeout(() => {
                    previousEmployerStartDate.markAsTouched();
                  }, 1);
                }
              })
            )
            .subscribe();

        }
      }
    }
    return getMergedConfig(config, additionalConfig);
  }
  ValidateCurrentLocationBHR(
    message: string,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        nat: {
          expression: (c) => {
            if (!isNullOrUndefined(c.value) && c.value == 26) {
              return false;
            }
            return true;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };
    return getMergedConfig(config, additionalConfig);
  }

  getDurationOfStay(visaType) {
    return this.prepareDOSObservable(
      LookupTypeKeys.BUSINESS_VISA_DURATION_OF_STAY,
      visaType);
  }

  //ViSA-ENTRY-DURATION Autopopulate logic
  getVisaTypeFieldOption() {
  return this.getCountryVisaSelectFieldOption('visa');
}

getEntryTypeFieldOption() {
  return this.getCountryVisaSelectFieldOption('entry');
}

getDurationFieldOption() {
  return this.getCountryVisaSelectFieldOption('duration');
  }
  //ViSA-ENTRY-DURATION Autopopulate logic
getCountryVisaSelectFieldOption(
  fieldType?: 'visa' | 'entry' | 'duration',
  additionalConfig?: FormlyFieldConfig
) {
  const config: FormlyFieldConfig = {
    templateOptions: {
      options: [],
      valueProp: '',
      labelProp: '',
    },
  };

  config.hooks = {
    onInit: (field) => {
      const formState = field.options?.formState || (field.options.formState = {});
      const countryCtrl = this.findFormControl('countryToBeVisited.id', field);
      const billableCtrl = this.findFormControl('performingBillableWork.id', field);
      const visaCtrl = this.findFormControl('recommendedVisaType.id', field);
      const entryCtrl = this.findFormControl('recommendedEntryType.id', field);
      const durationCtrl = this.findFormControl('recommendedVisaDuration.id', field);

      const durationStayCtrl = this.findFormControl("bTdurationOfStay", field);

      setTimeout(() => {
        // ---------------- VISA TYPE ----------------
        if (fieldType === 'visa' && countryCtrl && billableCtrl) {
          combineLatest([
            countryCtrl.valueChanges.pipe(startWith(countryCtrl.value)),
            billableCtrl.valueChanges.pipe(startWith(billableCtrl.value)),
          ])
            .pipe(
              debounceTime(200),
              switchMap(([countryId, billableWorkId]) => {
                if (!countryId) return of([]);
                return this.lookupApi.getVisaOptions(countryId);
              }),
              tap((res) => {
                let filteredRes = res;


                if (billableCtrl?.value === 1074) {
                  filteredRes = res.filter((v) => v.isBillableWorkId === 1074);
                } else if (billableCtrl?.value === 1075) {

                  filteredRes = res.filter(
                    (v) => v.isBillableWorkId === 1074 || v.isBillableWorkId === 1075
                  );
                }

                if (visaCtrl && durationStayCtrl) { 
                    visaCtrl.addValidators([
                      (control: AbstractControl) => {  
                        const stayDuration = durationStayCtrl.value;
                        const stayDurationValue = stayDuration ? parseInt(String(stayDuration).split(" ")[0], 10) : 0; 
                        const durationType = stayDuration ? String(stayDuration).split(" ")[1] : '';                                          
                        if (stayDurationValue < 5 && control.value == 16226 && (durationType == 'day' || durationType == 'days')) {  
                          return {
                            invalidVisaForShortStay: true
                          };
                        }
                        return null;
                      },
                    ]);
                    visaCtrl.updateValueAndValidity();

                    //Revalidate when duration changes
                    durationStayCtrl.valueChanges.subscribe(() => {
                      visaCtrl.updateValueAndValidity();
                    });                   
                }

                const uniqueVisaTypes = filteredRes
                  .map((v) => ({
                    visaId: v.visaId,
                    visaName: v.visaName,
                      parentVisaTypeId: v.parentVisaTypeId,
                  }))
                  .filter(
                    (v, i, a) => a.findIndex((t) => t.visaId === v.visaId) === i
                  );

                formState.countryVisaMap = filteredRes.reduce((acc, v) => {
                  if (!acc[v.visaId]) acc[v.visaId] = [];
                  acc[v.visaId].push({
                    entryTypeId: v.entryTypeId,
                    entryTypeName: v.entryTypeName,
                    visaDurationId: v.visaDurationId,
                    visaDurationName: v.visaDurationName,
                       parentVisaTypeId: v.parentVisaTypeId,
                  });
                  return acc;
                }, {});

                field.templateOptions.options = uniqueVisaTypes;
                field.templateOptions.valueProp = 'visaId';
                field.templateOptions.labelProp = 'visaName';
                visaCtrl?.reset();
                entryCtrl?.reset();
                durationCtrl?.reset();
              })
            )
            .subscribe();
        }

        // ---------------- ENTRY TYPE ----------------
        if (fieldType === 'entry' && visaCtrl) {
          const updateEntryOptions = (visaId: any, shouldResetIfNotFound = true) => {
            const map = formState.countryVisaMap;
            const uniqueEntries =
              map?.[visaId]
                ?.map((v) => ({
                  entryTypeId: v.entryTypeId,
                  entryTypeName: v.entryTypeName,
                }))
                .filter(
                  (v, i, a) =>
                    a.findIndex((t) => t.entryTypeId === v.entryTypeId) === i
                ) || [];

            field.templateOptions.options = uniqueEntries;
            field.templateOptions.valueProp = 'entryTypeId';
            field.templateOptions.labelProp = 'entryTypeName';

            // Only reset if the current value is not in the new options and we should reset
            if (shouldResetIfNotFound && !uniqueEntries.find(e => e.entryTypeId === entryCtrl?.value)) {
              // Add a small delay to ensure form initialization is complete
              setTimeout(() => {
                if (!uniqueEntries.find(e => e.entryTypeId === entryCtrl?.value)) {
                  entryCtrl?.reset();
                  durationCtrl?.reset();
                }
              }, 100);
            }
          };

          // Handle value changes
          visaCtrl.valueChanges.pipe(
            debounceTime(100) // Add debounce to handle rapid changes
          ).subscribe((visaId) => {
            updateEntryOptions(visaId, true);
          });

          // Handle initial load if visaCtrl already has a value
          if (visaCtrl.value) {
            updateEntryOptions(visaCtrl.value, false); // Don't reset on initial load
          }
        }

        // ---------------- VISA DURATION ----------------
        if (fieldType === 'duration' && entryCtrl) {
          const updateDurationOptions = (entryId: any, shouldResetIfNotFound = true) => {
            const visaId = visaCtrl?.value;
            const map = formState.countryVisaMap;
            const durations =
              map?.[visaId]
                ?.filter((v) => v.entryTypeId === entryId)
                .map((v) => ({
                  visaDurationId: v.visaDurationId,
                  visaDurationName: v.visaDurationName,
                })) || [];

            field.templateOptions.options = durations;
            field.templateOptions.valueProp = 'visaDurationId';
            field.templateOptions.labelProp = 'visaDurationName';
            
            // Only reset if the current value is not in the new options and we should reset
            if (shouldResetIfNotFound && !durations.find(d => d.visaDurationId === durationCtrl?.value)) {
              // Add a small delay to ensure form initialization is complete
              setTimeout(() => {
                if (!durations.find(d => d.visaDurationId === durationCtrl?.value)) {
                  durationCtrl?.reset();
                }
              }, 100);
            }
          };
          
          // Handle value changes
          entryCtrl.valueChanges.pipe(
            debounceTime(100) // Add debounce to handle rapid changes
          ).subscribe((entryId) => {
            updateDurationOptions(entryId, true);
          });
          
          // Handle initial load if entryCtrl already has a value
          if (entryCtrl.value) {
            updateDurationOptions(entryCtrl.value, false); // Don't reset on initial load
          }
        }
      });
    },
  };

    return config;
  }


  //Current Visa type, Current Entry type, Current Duration type Autopopulate logic
  //ViSA-ENTRY-DURATION Autopopulate logic
  getCurrentVisaTypeFieldOption() {
    return this.getCurrentCountryVisaSelectFieldOption('visa');
  }

  getCurrentEntryTypeFieldOption() {
    return this.getCurrentCountryVisaSelectFieldOption('entry');
  }

  getCurrentDurationFieldOption() {
    return this.getCurrentCountryVisaSelectFieldOption('duration');
  }
  //ViSA-ENTRY-DURATION Autopopulate logic
  getCurrentCountryVisaSelectFieldOption(
    fieldType?: 'visa' | 'entry' | 'duration',
    additionalConfig?: FormlyFieldConfig
  ) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: '',
        labelProp: '',
      },
    };

    config.hooks = {
      onInit: (field) => {
        const formState = field.options?.formState || (field.options.formState = {});
        const countryCtrl = this.findFormControl('countryToBeVisited.id', field);
        const billableCtrl = this.findFormControl('performingBillableWork.id', field);
        const visaCtrl = this.findFormControl('currentTypeOfVisa.id', field);
        const entryCtrl = this.findFormControl('currentEntryType.id', field);
        const durationCtrl = this.findFormControl('currentVisaDuration.id', field);


        setTimeout(() => {
          // ---------------- VISA TYPE ----------------
          if (fieldType === 'visa' && countryCtrl && billableCtrl) {
            combineLatest([
              countryCtrl.valueChanges.pipe(startWith(countryCtrl.value)),
              billableCtrl.valueChanges.pipe(startWith(billableCtrl.value)),
            ])
              .pipe(
                debounceTime(200),
                switchMap(([countryId, billableWorkId]) => {
                  if (!countryId) return of([]);
                  return this.lookupApi.getVisaOptions(countryId);
                }),
                tap((res) => {
                  let filteredRes = res;


                  if (billableCtrl?.value === 1074) {
                    filteredRes = res.filter((v) => v.isBillableWorkId === 1074);
                  } else if (billableCtrl?.value === 1075) {

                    filteredRes = res.filter(
                      (v) => v.isBillableWorkId === 1074 || v.isBillableWorkId === 1075
                    );
                  }

                  const uniqueVisaTypes = filteredRes
                    .map((v) => ({
                      visaId: v.visaId,
                      visaName: v.visaName,
                    }))
                    .filter(
                      (v, i, a) => a.findIndex((t) => t.visaId === v.visaId) === i
                    );

                  formState.countryVisaMap = filteredRes.reduce((acc, v) => {
                    if (!acc[v.visaId]) acc[v.visaId] = [];
                    acc[v.visaId].push({
                      entryTypeId: v.entryTypeId,
                      entryTypeName: v.entryTypeName,
                      visaDurationId: v.visaDurationId,
                      visaDurationName: v.visaDurationName,
                    });
                    return acc;
                  }, {});

                  field.templateOptions.options = uniqueVisaTypes;
                  field.templateOptions.valueProp = 'visaId';
                  field.templateOptions.labelProp = 'visaName';
                  visaCtrl?.reset();
                  entryCtrl?.reset();
                  durationCtrl?.reset();
                })
              )
              .subscribe();
          }

          // ---------------- ENTRY TYPE ----------------
          if (fieldType === 'entry' && visaCtrl) {
            const updateEntryOptions = (visaId: any, shouldReset = true) => {
              const map = formState.countryVisaMap;
              const uniqueEntries =
                map?.[visaId]
                  ?.map((v) => ({
                    entryTypeId: v.entryTypeId,
                    entryTypeName: v.entryTypeName,
                  }))
                  .filter(
                    (v, i, a) =>
                      a.findIndex((t) => t.entryTypeId === v.entryTypeId) === i
                  ) || [];

              field.templateOptions.options = uniqueEntries;
              field.templateOptions.valueProp = 'entryTypeId';
              field.templateOptions.labelProp = 'entryTypeName';

              if (shouldReset) {
                // Add a small delay to ensure form initialization is complete
                setTimeout(() => {
                  entryCtrl?.reset();
                  durationCtrl?.reset();
                }, 100);
              }
            };

            // Handle value changes
            visaCtrl.valueChanges.pipe(
              debounceTime(100) // Add debounce to handle rapid changes
            ).subscribe((visaId) => {
              updateEntryOptions(visaId, true);
            });

            // Handle initial load if visaCtrl already has a value
            if (visaCtrl.value) {
              updateEntryOptions(visaCtrl.value, false); // Don't reset on initial load
            }
          }

        // ---------------- VISA DURATION ----------------
        if (fieldType === 'duration' && entryCtrl) {
          entryCtrl.valueChanges.subscribe((entryId) => {
            const visaId = visaCtrl?.value;
            const map = formState.countryVisaMap;
            const durations =
              map?.[visaId]
                ?.filter((v) => v.entryTypeId === entryId)
                .map((v) => ({
                  visaDurationId: v.visaDurationId,
                  visaDurationName: v.visaDurationName,
                })) || [];

            field.templateOptions.options = durations;
            field.templateOptions.valueProp = 'visaDurationId';
            field.templateOptions.labelProp = 'visaDurationName';
            durationCtrl?.reset();
          });
        }
      });
    },
  };

  return config;
}



  // Business Traveller Processed By Validations
  getBTProcessedByFieldOptionsBasedOnType(
    additionalConfig?: FormlyFieldConfig
  ): FormlyFieldConfig {
    const processedBy$ = this.prepareLookupObservable(LookupTypeKeys.PROCESSING_BY);

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: processedBy$,
        valueProp: "id",
        labelProp: "displayText",
        showUsingTooltip: false,
        required: false  
      }
    };

    config.hooks = {
      onInit: field => {
        const ctrl = field.formControl;
        const processingTeamCtrl = this.findFormControl("processingTeam.id", field);

        if (processingTeamCtrl) {
          processingTeamCtrl.valueChanges
            .pipe(takeUntil(this.destroyed$), startWith(processingTeamCtrl.value))
            .subscribe((teamId: number) => {
              processedBy$.pipe(take(1)).subscribe(allOptions => {
                let filteredOptions = [];

              //filtering logic by Processing Team ID
                switch (teamId) {
                  case 16256: // internal teams
                    filteredOptions = allOptions.filter(opt =>
                      [16260, 16261, 16262, 16263, 16264].includes(opt.id)
                    );
                    field.templateOptions.required = true;
                    break;

                  case 16257: // travel vendors
                    filteredOptions = allOptions.filter(opt =>
                      [16266, 16267, 16265, 16268].includes(opt.id)
                    );
                    field.templateOptions.required = true;
                    break;

                  case 16258: // visa vendors
                    filteredOptions = allOptions.filter(opt =>
                      [16265, 16269, 16270].includes(opt.id)
                    );
                    field.templateOptions.required = true;
                    break;

                  case 16259: // others
                    filteredOptions = allOptions;
                    field.templateOptions.required = false; 
                    break;

                  default:
                    filteredOptions = allOptions;
                    field.templateOptions.required = true;
                    break;
                }

           
                field.templateOptions.options = filteredOptions;
                // ctrl.setValue(null);               
              });
            });
        }
      }
    };

    return getMergedConfig(config, additionalConfig);
  }


getCalculatedDurationOfStay(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  let dateOfTravel: AbstractControl;
  let dateOfExit: AbstractControl;

  const config: FormlyFieldConfig = {
    templateOptions: {
      disabled: true, 
     // label: "Duration of stay",
    },   
    hooks: {
      onInit: (field) => {
        const durationField = field.formControl;    
       dateOfTravel = this.findFormControl("dateOfTravel", field);
        dateOfExit = this.findFormControl("dateOfExit", field);
        
        const calculateDuration = () => {
          const travelValue = dateOfTravel?.value;
          const exitValue = dateOfExit?.value;

          const travelDate = this.parseDate(travelValue);
          const exitDate = this.parseDate(exitValue);

          if (!travelDate || !exitDate || exitDate < travelDate) {
            durationField.setValue('', { emitEvent: false });
            return;
          }

          const totalDays = this.differenceInDays(exitDate, travelDate) + 1;
           
          let display = '';
          if (totalDays < 7) {
            display = `${totalDays} day${totalDays > 1 ? 's' : ''}`;
          } else if (totalDays < 30) {
            const weeks = Math.floor(totalDays / 7);
            display = `${weeks} week${weeks > 1 ? 's' : ''}`;
          } else if (totalDays < 365) {
            const months = Math.floor(totalDays / 30);
            display = `${months} month${months > 1 ? 's' : ''}`;
          } else {
            const years = Math.floor(totalDays / 365);
            display = `${years} year${years > 1 ? 's' : ''}`;
          }

          durationField.setValue(display);
        };

     
        calculateDuration();

     
        dateOfTravel?.valueChanges
          .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
          .subscribe(calculateDuration);

        dateOfExit?.valueChanges
          .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
          .subscribe(calculateDuration);
      },
    },
  };

  return getMergedConfig(config, additionalConfig);
}


private parseDate(dateInput: string | Date | any): Date | null {
  if (!dateInput) return null;

  if (dateInput instanceof Date) return dateInput;

  if (typeof dateInput === 'string') {
    const parts = dateInput.split('-').map(Number);
    if (parts.length !== 3) return null;
    const [day, month, year] = parts;
    return new Date(year, month - 1, day);
  }


  if (typeof dateInput === 'object' && dateInput.day && dateInput.month && dateInput.year) {
    return new Date(dateInput.year, dateInput.month - 1, dateInput.day);
  }

  return null;
}
getCalculatedRevisedDateOfExit(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    hooks: {
      onInit: (field) => {
        const revisedDateOfExit = field.formControl;
        const dateOfTravel = this.findFormControl('dateOfTravel', field);
        const dateOfExit = this.findFormControl('dateOfExit', field);

        if (dateOfTravel && dateOfExit && revisedDateOfExit) {
          const recalc = () => {
            const travel = this.parseDate(dateOfTravel.value);
            const exit = this.parseDate(dateOfExit.value);

            if (travel && exit && !isNaN(travel.getTime()) && !isNaN(exit.getTime())) {

             const diffInDays = this.differenceInDays(exit, travel)+1
              // Compute revised date
              const revised = new Date(travel);
              revised.setDate(travel.getDate() + diffInDays + 1);

              // Update model & form control
              field.model.revisedDateOfExit = revised;
              field.formControl.patchValue(revised, { emitEvent: false });
            } else {
              revisedDateOfExit.setValue(null, { emitEvent: false });
            }
          };

          // Watch for changes in both fields
          dateOfTravel.valueChanges?.subscribe(recalc);
          dateOfExit.valueChanges?.subscribe(recalc);

          // Trigger initial calculation
          recalc();
        }
      }
    },
    ...additionalConfig
  };

  return config;
}

enableFieldBasedonCountryTobeVisited(countryIds: number[], additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    hooks: {
      onInit: (field) => {
        const fieldControl = field.formControl;
        const countryCtrl = this.findFormControl('countryToBeVisited.id', field);

        if (countryCtrl && fieldControl) {

          const enableFields = () => {
            const countryCtrlValue = countryCtrl?.value;            
            if (countryIds.includes(countryCtrlValue)) { 
              fieldControl.enable(); 
            } else {                            
              fieldControl.disable();     
              // fieldControl.setValue(0);          
            }
          };

          // Watch for changes in countryToBeVisited
         countryCtrl.valueChanges?.subscribe(enableFields);

          // Trigger initial calculation
          enableFields();
        }
      }
    },
    ...additionalConfig
  };

  return config;
}

private differenceInDays(date1: Date, date2: Date): number {
  const diffTime = date1.getTime() - date2.getTime();
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
}


  validateDurationOfStay(
    dataSource$: Observable<LookupField[]>,
    message: string,
    checkForApprover = false,
    additionalConfig?: FormlyFieldConfig) {
    let dateOfTravel: AbstractControl;
    let visaType: AbstractControl;

    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);

    const config: FormlyFieldConfig = {
      templateOptions: {
        valueProp: "id",
        labelProp: "displayText"
      },
      validators: {
        invalidDOS: {
          expression: (c) => {
            if (c && c.value
              && dateOfTravel && dateOfTravel.value
              && visaType && visaType.value) {
              const threshold = +this.durationOfStay$.getValue().find(x => x.id == c.value).value;
              const diffInDays = differenceInDays(new Date(), dateOfTravel.value);
              return diffInDays <= threshold;
            }
            return true;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    config.hooks = {
      onInit: field => {
        const dos = field.formControl;
        dateOfTravel = this.findFormControl('dateOfTravel', field);
        visaType = this.findFormControl('shortTermVisa.id', field);

        dateOfTravel.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            distinctUntilChanged(),
            tap(date => {
              if (dos && dos.value) {
                dos.updateValueAndValidity();
                setTimeout(() => {
                  dateOfTravel.markAsTouched();
                }, 1);
              }
            })
          )
          .subscribe();

        visaType.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            distinctUntilChanged(),
            tap(date => {
              if (dos && dos.value) {
                dos.updateValueAndValidity();
                setTimeout(() => {
                  visaType.markAsTouched();
                }, 1);
              }
            })
          )
          .subscribe();

        this.getParentKeySubscription('shortTermVisa.id', dataSource$, field, this.tap_SelectFieldOptions)
      }
    }
    return getMergedConfig(config, additionalConfig);
  }


  validateDOBOnChild(
    parentKey: string,
    additionalConfig?: FormlyFieldConfig,
    checkForApprover = false
  ): FormlyFieldConfig {
    let relationship: AbstractControl;
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    let message: string
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        childDOBInvalidErr: {
          expression: (c) => {

            if (isApprove && !checkForApprover) {
              return true;
            }

            if (c && c.value && relationship && relationship.value && (relationship.value == 9008 || relationship.value == 12321)) {
              message = "Date of birth cannot be in the future"
              const datediff = differenceInCalendarDays(c.value, new Date())
              return (datediff <= 0);
            }
            if (c && c.value && relationship && relationship.value && relationship.value != 9008 && relationship.value != 12321) {
              message = "Date of birth cannot be in the past 10 years or in the future"
              const datediff = differenceInYears(c.value, new Date())
              return (datediff <= 0 && datediff <= -10 && datediff >= -100);
            }
            return true;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const dob = field.formControl;
          relationship = this.findFormControl('relationship.id', field);

          relationship.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              distinctUntilChanged(),
              tap(date => {

                if (dob && dob.value) {
                  dob.updateValueAndValidity();
                  setTimeout(() => {
                    relationship.markAsTouched();
                  }, 1);
                }
              })
            )
            .subscribe();
        }
      };
    }
    return getMergedConfig(config, additionalConfig);
  }
  getOfficeLocations(searchTerm) {
    return this.lookupApi.getAllTypeAheadOfficeLocations(this.immigrationCountry, searchTerm);
  }

  getAllOfficeLocations(searchTerm) {
    return this.lookupApi.getAllTypeAheadOfficeLocations('', searchTerm);
  }

  setCovidScenario(
    message: string,
    isCountryARE: () => boolean,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {

    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        countryARE: {
          expression: (c, field: FormlyFieldConfig) => {
            if (isCountryARE instanceof Function) {
              const isCountry = isCountryARE();
              if (c.value == 10800 && !isCountry) {
                return false
              }
            }
            return true;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    return getMergedConfig(config, additionalConfig);
  }



  getNationalityforQAT_RPIssuance(pbType: number, gender: number, field: any, nat$: Observable<LookupField[]>) {

    if (pbType === 1046) {  //National
      field.templateOptions.options = nat$.pipe(map(nat => nat.filter(nat => nat.value === this.immigrationCountry)));
    }
    else {
      if (gender === 7) {   //Male
        field.templateOptions.options = nat$.pipe(map(item => item.filter(i => [175, 241, 203, 188, 26, 127].includes(i.id))));
      }
      else {
        field.templateOptions.options = nat$.pipe(map(item => item.filter(i => ![175, 241, 203, 188, 26, 127].includes(i.id))));

      }
    }
  }

  getExitSubTypes() {
    return this.lookupApi.getExitSubTypes().pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );;
  }


  getExitCompanies() {
    return this.lookupApi.getExitCompanies().pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );;
  }

  getExitJobCateogory() {
    return this.lookupApi.getJobCategory().pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );;
  }



  getDepartBySMUSelectFieldOption(additionalConfig?: FormlyFieldConfig) {

    let smuId = -1;
    let leId = -1;
    let specialityId = -1;

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    config.hooks = {
      onInit: field => {
        const smuEle = this.findFormControl('competency.id', field);
        const leEle = this.findFormControl('company.id', field);
        const specialityEle = this.findFormControl('speciality.id', field);

        if (specialityEle)
          specialityEle.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(specialityEle.value),
              tap(id => {
                if (!field.form.disabled) {
                  field.formControl.setValue(null);
                }
                specialityId = id;
                if ((specialityId > 0 || smuId > 0) && leId > 0) {
                  field.templateOptions.options = this.prepareDepartmentsObservable(leId, smuId, specialityId);
                } else {
                  field.templateOptions.options = EMPTY;
                }
              })
            )
            .subscribe();

          smuEle.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(smuEle.value),
              tap(id => {
                if (!field.form.disabled) {
                  field.formControl.setValue(null);
                }
                smuId = id;
                if (smuId > 0 && leId > 0) {
                  field.templateOptions.options = this.prepareDepartmentsbySMULEObservable(leId, smuId, specialityId);
                } else {
                  field.templateOptions.options = EMPTY;
                }
              })
            )
            .subscribe();

        leEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(leEle.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              leId = id;
              if (smuId > 0 && leId > 0) {
                field.templateOptions.options = this.prepareDepartmentsbySMULEObservable(leId, smuId, specialityId);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  prepareDepartmentsbySMULEObservable(
    leId: number,
    smuId: number,
    specialityId: number
  ): Observable<LookupField[]> {
    if (!leId || !smuId) {
      return EMPTY;
    }
    const cb$ = this.lookupApi.getDeptCodeblocks(leId, smuId || 0, specialityId || 0).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
    cb$.subscribe(dcb => {
      this.deptCodeBlock$.next(dcb);
    });
    return cb$;
  }


  getLeBasedOnOfficeLoc(additionalConfig?: FormlyFieldConfig) {

    let locationId = -1;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    config.hooks = {
      onInit: field => {
        const locationEle = this.findFormControl('officeLocation.id', field);


        locationEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(locationEle.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              locationId = id;
              if (locationId > 0) {
                field.templateOptions.options = this.prepareOfficeEntityByOfficeLocObservable(locationId);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    }


    return getMergedConfig(config, additionalConfig);
  }


  prepareOfficeEntityByOfficeLocObservable(
    parentId?: number,
  ): Observable<OfficeEntity[]> {
    if (!!parentId && parentId > 0) {
      return this.lookupApi.getOfficeLEByOfficeLocation(parentId).pipe(
        takeUntil(this.destroyed$),
        shareReplay()
      );
    }

  }

  AcceptDateAfterYears(
    pivotDate: Date,
    years: number,
    message: string,
    checkInAcceptAndApprove = true,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let parentControl: AbstractControl;
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        notAfterSpecifiedMonths: {
          expression: (c) => {
            if (isApprove && !checkInAcceptAndApprove) {
              return true;
            }
            if (parentControl && parentControl.value == 970) {
              //Validation not required for Mission visa --970
              return true;
            }
            if (c && c.value) {
              //Validation not required for Mission visa --970
              const futureDate = addYears(pivotDate, years);
              return (futureDate <= c.value);
            }
            return false;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };
    return getMergedConfig(config, additionalConfig);
  }

  visaValidityBasedOnDurationOfStay(
    visa: string,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
      }
    };
    config.hooks = {
      onInit: field => {
        const durationOfStay = this.findFormControl('durationOfStay.id', field);
        const ele = field.formControl;
        ele.disable();


        durationOfStay.valueChanges.subscribe(pb => {
          if (durationOfStay.value === 10014) {


            ele.setValue(14);
          } else {
            if (durationOfStay.value === 10013 ||
              durationOfStay.value === 10015 ||
              durationOfStay.value === 10016) {

              ele.setValue(60);

            } else {
              ele.setValue(null);
            }

          }
        });

      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  SponsorIDvalidate(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
      }
    };
    config.hooks = {
      onInit: field => {
        const officeLE = this.findFormControl('officeLE.id', field);
        const ele = field.formControl;
        ele.disable();


        officeLE.valueChanges.subscribe(pb => {
          if (officeLE.value === 703) {


            ele.setValue(7000117205);
          } else if (officeLE.value === 704) {

            ele.setValue(7001515894);

          }
          else {
            ele.setValue(7037097727);
          }

        }
        );

      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  getGccNationalsBasedOnNationality(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
      }
    };
    config.hooks = {
      onInit: field => {
        const nationality = this.findFormControl('nationality.id', field);
        const ele = field.formControl;
        nationality.valueChanges.pipe(
          takeUntil(this.destroyed$),
          startWith(nationality.value),
          tap(duration => {
            //Bahrain, Kuwait, Oman, Qatar, Saudi Arabia, United Arab Emirates
            if (!isNullOrUndefined(duration)) {
              if (duration == 26 || duration === 127 || duration === 175 ||
                duration === 188 || duration === 203 || duration === 241) {
                ele.setValue(1074); //YES

                ele.updateValueAndValidity();
              }
              else {
                ele.setValue(1075); //NO
                ele.updateValueAndValidity();
              }
            }
            else {
              ele.setValue(null);
              ele.updateValueAndValidity();
            }
          }))
          .subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  getEwakalaIssuanceToAgentBasedOnImmCType(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
      }
    };
    config.hooks = {
      onInit: field => {
        const immCType = this.findFormControl('immigrationCaseType.id', field);
        const ele = field.formControl;
        immCType.valueChanges.subscribe(natvalue => {
          if (immCType.value === 14420) {
            ele.setValue(1074); //YES
            ele.disable();
          }
          else {
            ele.setValue(null);
             ele.disable();
            //ele.enable();
          }
        }
        )
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  getNationalityTypesBasedOnNationalityandOfficelocationCountry(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const prebo$ = this.prepareLookupObservable(LookupTypeKeys.ONBOARDING_TYPES);
    prebo$.subscribe(n => this.preboardingType$.next(n));

    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    nat$.subscribe(n => this.nationality$.next(n));
    const olc$ = this.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION_COUNTRY);
    olc$.subscribe(o => this.officeLocation$.next(o));

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: prebo$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const nationalityEle = this.findFormControl('nationality.id', field);
        const officeCountryEle = this.findFormControl('officeLocationCountry.id', field);
        const ele = field.formControl;

        nationalityEle.valueChanges.subscribe(natvalue => {
          var nationality;
          var country;
          if ((!isNullOrUndefined(natvalue)) && (!isNullOrUndefined(officeCountryEle.value))) {
            country = this.officeLocation$.getValue().find(o => o.id === officeCountryEle.value);
            nationality = this.nationality$.getValue().find(n => n.id === natvalue);

          }

          if ((!isNullOrUndefined(country)) && (!isNullOrUndefined(nationality))) {
            if (country.value === nationality.value) {
              ele.setValue(1046); //National
              ele.updateValueAndValidity();
            }
            else {
              ele.setValue(1045); //National
              ele.updateValueAndValidity();
            }
          }
          else {
            ele.setValue(null);
            ele.updateValueAndValidity();
          }

        });
        officeCountryEle.valueChanges.subscribe(officevalue => {
          var nationality1;
          var country1;
          if ((!isNullOrUndefined(officevalue)) && (!isNullOrUndefined(nationalityEle.value))) {
            country1 = this.officeLocation$.getValue().find(o => o.id === officevalue);
            nationality1 = this.nationality$.getValue().find(n => n.id === nationalityEle.value);

          }

          if ((!isNullOrUndefined(country1)) && (!isNullOrUndefined(nationality1))) {
            if (country1.value === nationality1.value) {
              ele.setValue(1046); //National
              ele.updateValueAndValidity();
            }
            else {
              ele.setValue(1045); //National
              ele.updateValueAndValidity();
            }
          }
          else {
            ele.setValue(null);
            ele.updateValueAndValidity();
          }

        });
      }
    };

    return getMergedConfig(config, additionalConfig);
  }
  getSelectFieldOptionsEnableAllNationality(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    nat$.subscribe(n => this.nationality$.next(n));
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: nat$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
  getSelectFieldOptionsEnableAllNationalityExceptGCC(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY).pipe(map(item => item.filter(i => ![26, 175, 188, 203, 241, 127].includes(i.id))));
    nat$.subscribe(n => this.nationality$.next(n));
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: nat$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getPbTypeWrtNationality(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let ele: AbstractControl;
    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    nat$.subscribe(n => {
      this.nationality$.next(n);
      ele.updateValueAndValidity();
    });
    const config: FormlyFieldConfig = {

      templateOptions: {

      }
    };


    config.hooks = {
      onInit: field => {
        const nationality = this.findFormControl('nationality', field);
        ele = field.formControl;
        nationality.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(nationality.value),
            tap(data => {
              const nationalityName = this.nationality$.getValue().find(x => x.value === this.immigrationCountry)

              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (nationalityName && data.id && data.id === nationalityName.id) {
                ele.setValue(1046);
                ele.disable();
              } else if (data.id) {
                ele.setValue(1045);
                ele.disable();
              } else {
                ele.setValue(null);
                ele.enable();
              }

            })
          )
          .subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  getVisaExpiryDateWrtVisaExtensionDate(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let ele: AbstractControl;
    const config: FormlyFieldConfig = {
      templateOptions: {

      }
    };
    config.hooks = {
      onInit: field => {
        const visaExtensionDate = this.findFormControl('visaExtensionDate', field);
        ele = field.formControl;
        visaExtensionDate.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(visaExtensionDate.value),
            tap(data => {
              if (!data) {
                ele.setValue(''); // Set visaExpiryDate to blank if visaExtensionDate is null
              } else {
                const newVisaExpiryDate = new Date(data);
                newVisaExpiryDate.setDate(newVisaExpiryDate.getDate() + 30);
                ele.setValue(newVisaExpiryDate); // Set visaExpiryDate to 30 days after visaExtensionDate
              }
              ele.disable();
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getVisaTypeWrtImmigrationCaseType(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let ele: AbstractControl;
    const config: FormlyFieldConfig = {
      templateOptions: {

      }
    };
    config.hooks = {
      onInit: field => {
        const immigrationCaseType = this.findFormControl('immigrationCaseType.id', field);
        ele = field.formControl;
        immigrationCaseType.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(immigrationCaseType.value),
            tap(data => {
              if (data === 1012) {
                ele.setValue(9000);
                ele.disable();
              } else if (data === 1011) {
                ele.setValue(9001);
                ele.disable();
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getDurationOfStayWrtImmigrationCaseType(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let ele: AbstractControl;
    const config: FormlyFieldConfig = {
      templateOptions: {

      }
    };
    config.hooks = {
      onInit: field => {
        const immigrationCaseType = this.findFormControl('immigrationCaseType.id', field);
        ele = field.formControl;
        immigrationCaseType.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(immigrationCaseType.value),
            tap(data => {
              console.log(ele);
              if (data === 1012) {
                ele.setValue(10009);
                ele.disable();
              } else if (data === 1011) {
                ele.setValue(15227);
                ele.disable();
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getSpecialExpactWrtNationalityType(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let ele: AbstractControl;
    const config: FormlyFieldConfig = {
      templateOptions: {

      }
    };
    config.hooks = {
      onInit: field => {
        const nationalityType = this.findFormControl('nationalityType.id', field);
        ele = field.formControl;
        nationalityType.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(nationalityType.value),
            tap(data => {
              if (data === 15233) {
                ele.setValue(true);
                ele.disable();
              }
              else {
                ele.setValue(false);
                ele.disable();
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getCitizenshipWrtNationality(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let ele: AbstractControl;
    const nat$ = this.prepareLookupObservable(LookupTypeKeys.NATIONALITY);
    nat$.subscribe(n => {
      this.nationality$.next(n);
      ele.updateValueAndValidity();
    });
    const config: FormlyFieldConfig = {

      templateOptions: {

      }
    };


    config.hooks = {
      onInit: field => {
        const nationality = this.findFormControl('nationality', field);
        ele = field.formControl;
        nationality.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(nationality.value),
            tap(data => {
              const nationalityId = data.id;

              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }

              let citizenshipId = this.getCitizenshipBasedOnNationality(nationalityId);
              ele.setValue(citizenshipId);
              ele.disable();

            })
          )
          .subscribe();
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  isTravellerInterMena(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const menaOffice$ = this.prepareMenaCountryLocations();
    menaOffice$.subscribe(n => this.menaOffice$.next(n));
    const config: FormlyFieldConfig = {
      templateOptions: {
      }
    };
    config.hooks = {
      onInit: field => {
        const currentLoc = this.findFormControl('employeeCurrentLocationCountry.id', field);
        const ele = field.formControl;
        currentLoc.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(currentLoc.value),
            tap(data => {
              if (data) {
                ele.disable();
                const menaOffice = this.menaOffice$.getValue().find(x => !isNullOrUndefined(x.filterKeyId) && x.id === data)
                if (!field.form.disabled) {
                  field.formControl.setValue(null);
                }
                if (!isNullOrUndefined(menaOffice)) {
                  ele.setValue(12070)
                  //InterMena
                } else {
                  ele.setValue(12071);
                  //IntraMena
                }
              }
              else {
                ele.setValue(null);
                // ele.enable();
              }

            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  DOBValidationOnRelationship(
    parentKey: string,
    additionalConfig?: FormlyFieldConfig,
    checkForApprover = false
  ): FormlyFieldConfig {
    let relationship: AbstractControl;
    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    let message: string
    const config: FormlyFieldConfig = {
      templateOptions: {
      },
      validators: {
        childDOBInvalidErr: {
          expression: (c) => {

            if (isApprove && !checkForApprover) {
              return true;
            }

            if (c && c.value && relationship && relationship.value && relationship.value == 9008) {
              message = "Date of birth cannot be in the future"
              const datediff = differenceInCalendarDays(c.value, new Date())
              return (datediff <= 0);
            }
            if (c && c.value && relationship && relationship.value && relationship.value != 9008) {
              message = "Date of birth cannot be in the past 10 years or in the future"
              const datediff = differenceInYears(c.value, new Date())
              return (datediff <= 0 && datediff <= -10 && datediff >= -100);
            }

            return true;
          },
          message: (error, field: FormlyFieldConfig) => message,
        }
      },
    };

    if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const dob = field.formControl;
          relationship = this.findFormControl('relationships.id', field);

          relationship.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              distinctUntilChanged(),
              tap(date => {

                if (dob && dob.value) {
                  dob.updateValueAndValidity();
                  setTimeout(() => {
                    relationship.markAsTouched();
                  }, 1);
                }
              })
            )
            .subscribe();
        }
      };
    }


    return getMergedConfig(config, additionalConfig);
  }

  getOfficeLocationBasedOnCountry(additionalConfig?: FormlyFieldConfig) {

    let countryId = 0;
    let countryValue = '';
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    config.hooks = {
      onInit: field => {
        const country = this.findFormControl('country.id', field);
        const visaType = this.findFormControl('visaTypeId.id', field);

        visaType.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(visaType.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              countryId = country.value;

              if (id > 0 && countryId > 0) {
                if (countryId === CountryTypeIds.SaudiArabia) {
                  countryValue = CountryTypesValues.SaudiArabia;
                }
                if (countryId === CountryTypeIds.UAE) {
                  countryValue = CountryTypesValues.UAE;
                }
                if (countryId === CountryTypeIds.BHR) {
                  countryValue = CountryTypesValues.BHR;
                }
                if (countryId === CountryTypeIds.KWT) {
                  countryValue = CountryTypesValues.KWT;
                }
                if (countryId === CountryTypeIds.OMN) {
                  countryValue = CountryTypesValues.OMAN;
                }
                if (countryId === CountryTypeIds.QAT) {
                  countryValue = CountryTypesValues.QAT;
                }
                if (countryId === CountryTypeIds.EGY) {
                  countryValue = CountryTypesValues.EGY;
                }
                if (countryId === CountryTypeIds.PAK) {
                  countryValue = CountryTypesValues.PAK;
                }
                if (countryId === CountryTypeIds.JOR) {
                  countryValue = CountryTypesValues.JOR;
                }
                field.templateOptions.options = this.lookupApi.getOfficeLocations(countryValue);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    }


    return getMergedConfig(config, additionalConfig);
  }
  getLegalEntityBasedOnCountry(additionalConfig?: FormlyFieldConfig) {

    let countryId = 0;
    let countryValue = '';
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: "id",
        labelProp: "displayText"
      }
    };

    config.hooks = {
      onInit: field => {
        const country = this.findFormControl('country.id', field);
        const visaType = this.findFormControl('visaTypeId.id', field);

        visaType.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(visaType.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              countryId = country.value;

              if (id > 0 && countryId > 0) {
                if (countryId === CountryTypeIds.SaudiArabia) {
                  countryValue = CountryTypesValues.SaudiArabia;
                }
                if (countryId === CountryTypeIds.UAE) {
                  countryValue = CountryTypesValues.UAE;
                }
                if (countryId === CountryTypeIds.BHR) {
                  countryValue = CountryTypesValues.BHR;
                }
                if (countryId === CountryTypeIds.KWT) {
                  countryValue = CountryTypesValues.KWT;
                }
                if (countryId === CountryTypeIds.OMN) {
                  countryValue = CountryTypesValues.OMAN;
                }
                if (countryId === CountryTypeIds.QAT) {
                  countryValue = CountryTypesValues.QAT;
                }
                if (countryId === CountryTypeIds.EGY) {
                  countryValue = CountryTypesValues.EGY;
                }
                if (countryId === CountryTypeIds.JOR) {
                  countryValue = CountryTypesValues.JOR;
                }
                field.templateOptions.options = this.lookupApi.getOfficeLEByCountryCode(countryValue);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          )
          .subscribe();
      }
    }


    return getMergedConfig(config, additionalConfig);
  }

  getExitEmailTemplateSelectFieldOptions(onChange: (obj: ExitMailTemplateInfo) => void, additionalConfig?: FormlyFieldConfig,) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: [],
        valueProp: (option) => option,
        compareWith: (o1, o2) => o1.id === o2.id,
        labelProp: "activityHeader"
      }
    };
    config.hooks = {
      onInit: field => {
        const exitTypeId = this.findFormControl('exitType.id', field);
        const isAuto = this.findFormControl('showSysTemplates', field);
        const exitSubType = this.findFormControl('exitSubType.id', field);
        const officeLoc = this.findFormControl('officeLocation.id', field);
        const nationality = this.findFormControl('nationalityType.id', field);

        field.formControl.valueChanges.pipe(
          takeUntil(this.destroyed$),
        ).subscribe(onChange);
        exitTypeId.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(exitTypeId.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if ((id > 0 && isAuto.value === true) || (id > 0 && officeLoc.value != null)) {
                field.templateOptions.options = this.prepareExitEmailTemplatesObservable(exitTypeId.value, isAuto.value, exitSubType.value, officeLoc.value, nationality.value);
              } else {
                field.templateOptions.options = EMPTY;
              }
            })
          ).subscribe();

        exitSubType.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(exitTypeId.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }

              if (exitTypeId.value > 0) {
                field.templateOptions.options = this.prepareExitEmailTemplatesObservable(exitTypeId.value, isAuto.value, exitSubType.value, officeLoc.value, nationality.value);
              }
              if (id === 0) {
                field.templateOptions.options = EMPTY;
              }
            })
          ).subscribe();

        officeLoc.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(exitTypeId.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (exitTypeId.value > 0) {
                field.templateOptions.options = this.prepareExitEmailTemplatesObservable(exitTypeId.value, isAuto.value, exitSubType.value, officeLoc.value, nationality.value);
              } if (id === 0) {
                field.templateOptions.options = EMPTY;
              }
            })
          ).subscribe();

        nationality.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(exitTypeId.value),
            tap(id => {
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (exitTypeId.value > 0) {
                field.templateOptions.options = this.prepareExitEmailTemplatesObservable(exitTypeId.value, isAuto.value, exitSubType.value, officeLoc.value, nationality.value);
              } if (id === 0) {
                field.templateOptions.options = EMPTY;
              }
            })
          ).subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }


  prepareExitEmailTemplatesObservable(
    exitTypeId: number,
    isAutoTemp: boolean,
    exitSubTypeId?: number,
    officeLoc?: number,
    nationality?: number,

  ): Observable<DeptCodeblock[]> {
    if (!exitTypeId) {
      return EMPTY;
    }
    let exitSubType = exitSubTypeId === null ? undefined : exitSubTypeId;
    let officeLocation = officeLoc === null ? undefined : officeLoc;
    let nationalityType = nationality === null ? undefined : nationality;
    const cb$ = this.emailApi.getExitEmailTemplates(exitTypeId, isAutoTemp, exitSubType, officeLocation, nationalityType).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );

    return cb$;
  }


  getEmployeeDetailsById(
    emailId: string
  ): Observable<EmployeeProfile> {
    return this.empProfile.getProfileRequestbyEmail(emailId).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  getPJCGUI(
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    let ptc: AbstractControl;
    const emp$ = this.prepareEmployeeByRoleObservable(RoleType.PTC);
    emp$.subscribe(n => {
      this.ptc$.next(n);
      ptc.updateValueAndValidity();
    });
    const config: FormlyFieldConfig = {
      templateOptions: {

      }
    };
    config.hooks = {
      onInit: field => {
        ptc = this.findFormControl('otc.id', field);
        const ele = field.formControl;
        //let isFirst=true;

        ptc.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ptc.value),
            tap(id => {
              // if(isFirst){
              //   isFirst= false;
              //   return;              
              // }
              if (!field.form.disabled) {
                field.formControl.setValue(null);
              }
              if (id > 0) {

                const ptcEmail = this.ptc$.getValue().find(x => x.id === id)
                if (!isNullOrUndefined(ptcEmail?.email)) {
                  this.empProfile.getProfileRequestbyEmail(ptcEmail.email).subscribe(
                    res => {
                      if (res && !isNullOrUndefined(res.gui)) {
                        ele.setValue(res.gui);
                        ele.disable();
                      } else {
                        //ele.setValue(null);
                        ele.enable();
                      }
                    }
                  )
                }

              } else {
                //ele.setValue(null);
                ele.enable();
              }
            })
          )
          .subscribe();
      }
    }


    return getMergedConfig(config, additionalConfig);
  }

  isExit(): boolean {
    return this.route.url.indexOf('exit') > 0;
  }
  isImmigration(): boolean {
    return this.route.url.indexOf('immigration') > 0;
  }
  isProfileUpdate(): boolean {
    return this.route.url == "/user" || (this.route.url.indexOf('immigration') > 0 && this.route.url.indexOf('profile') > 0 && this.route.url.indexOf('search') > 0);
  }


  getCitizenshipBasedOnNationality(nationalityId: number): number {

    let citizenshipId = 0;

    //Bahrain, Kuwait, Oman, Qatar, United Arab Emirates
    if (!isNullOrUndefined(nationalityId)) {
      if (nationalityId == 26 || nationalityId === 127 || nationalityId === 175 ||
        nationalityId === 188 || nationalityId === 241) {
        citizenshipId = 14426;//GCC National
      }
      //Saudi Arabia
      else if (nationalityId == 203) {
        citizenshipId = 14427; //KSA National            
      }
      else {
        citizenshipId = 14425;//Expat
      }
    }
    return citizenshipId;
  }


  getNationalityTypeSelectFieldOptions(
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    return this._getNationalityTypeSelectFieldOptions(this.tap_SelectFieldOptions, dataSource$, parentKey, additionalConfig);
  }

  private _getNationalityTypeSelectFieldOptions(
    tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const ele = this.findFormControl('officeLocationCountry.id', field);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(id => {
              if (!isNullOrUndefined(ele.value) && (ele.value === 1048)) {
                field.props.options = EMPTY;
                field.props.options = dataSource$;
                field.formControl.enable();
              }
              else {
                field.props.options = EMPTY;
                field.props.options = dataSource$.pipe(map(items => items.filter(f => ![15233].includes(f.id))));
                field.formControl.enable();
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
getExceptionStatus(
    //tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        //const ele = field.formControl;
        const ele = this.findFormControl('eduDocAttestationId',field);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(id => {
              if ([15076,15077].includes(id)) {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$;
              }
              else{
                field.formControl.setValue(null);
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
 reset(additionalConfig?: FormlyFieldConfig,parentKey?: string,val?:number
    ): FormlyFieldConfig {
      let prevValueOfParent = 0;
      const config: FormlyFieldConfig = {
        templateOptions: {
          valueProp: "id",
          labelProp: "displayText"
        }
      };
      config.hooks = {
        onInit: field => {
          //const ele = field.formControl;
          const ele = this.findFormControl(parentKey,field);
          ele.valueChanges
            .pipe(
              takeUntil(this.destroyed$),
              startWith(ele.value),
              tap(id => {
                if (![val].includes(id)) {
                   field.formControl.setValue(undefined);
                }
              })
            )
            .subscribe();
        }
      };
      return getMergedConfig(config, additionalConfig);
    }
  updateDateProperty(model, pathWithProp) {


    const propertiesToUpdate = pathWithProp.map(x => ({ path: x.split(".") }));
    for (const { path } of propertiesToUpdate) {
      let obj = model;
      const lastKeyIndex = path.length - 1;
      for (let i = 0; i < lastKeyIndex; i++) {

        obj = obj[path[i]];

        if (typeof obj !== "object" || obj === null) {
          return;
        }
      }

      if (obj[path[lastKeyIndex]]) {

        obj[path[lastKeyIndex]] = getDateAsUTC(obj[path[lastKeyIndex]]);

      }

    }

  }


  setAutoPopulatedValue(
    fieldId: number,
    additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
      }
    };
    config.hooks = {
      onInit: field => {
        let ele = field.formControl;
        ele.patchValue(fieldId, "");
      }
    };

    return getMergedConfig(config, additionalConfig);
  }

  isStringValidJson(str: string): boolean {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;

    }
  }
  //function to validate expiry dates on current date and previous date
  validateExpiryDate(pbProfileData, pbMasterData, formArray) {
    let expiryMessage = []; //to store messages if new expiry date is less than old expiry date
    let currentDateMessage = []; //to store messages if new expiry date is less than current
    let currentDateExpId = 0;
    let expiId = 0;
    let officeLocationCountry = pbMasterData.officeLocationCountry?.id; //for country specific expiry date validation
    const getDependentDetails = (data) => (data ? JSON.parse(data).formData : null);
    //get dependent details
    const childrenDetails = getDependentDetails(pbProfileData.childrenDetails);
    const masterChildrenDetails = getDependentDetails(pbMasterData.childrenDetails);
    const spouseDetails = getDependentDetails(pbProfileData.spouseDetails);
    const masterSpouseDetails = getDependentDetails(pbMasterData.spouseDetails);
    const formControls = [
      // { controlName: 'iqamaExpiryDate', label: 'Iqama Expiry' },
      { controlName: 'rpExpiryDate', label: 'Residency Permit (RP) expiry' },
      { controlName: 'passportExpiryDate', label: 'Passport Expiry' },
      // Add more mappings as needed
    ];
    //check if expiry dates field are valid and push to expiryDates array. if invalid no need to validate
    const expiryDates = [];
    formControls.forEach(({ controlName, label }) => {
      const control = formArray?.controls[0]?.controls[controlName];
      if (control && control.status === 'VALID') {
        //check if existing date is not null
        if (pbMasterData[controlName] != null) {
          expiryDates.push({
            label,
            newExpDate: pbProfileData[controlName],
            oldExpDate: pbMasterData[controlName]
          });
        }
      }
    });
    //dependent expiry date validation
    const processDependentDetails = (details, masterDetails, relation) => {
      if (!details) return [];
      const dependentExpiryDates = []; //stores messages for dependents
      details.forEach(dependent => {
        const masterDependent = masterDetails?.find(m => m.dependentId === dependent.dependentId);

        // stores dependent new expiry,old expiry and new expiry date
        dependentExpiryDates.push(
          {
            label: `${relation} Passport Expiry - ${dependent.firstName}`,
            newExpDate: dependent.passportExpiryDate ? new Date(dependent.passportExpiryDate) : null,
            oldExpDate: masterDependent?.passportExpiryDate ? new Date(masterDependent.passportExpiryDate) : null
          },
          {
            label: `${relation} Residency Permit (RP) expiry - ${dependent.firstName}`,
            newExpDate: dependent.visaExpiryDate ? new Date(dependent.visaExpiryDate) : null,
            oldExpDate: masterDependent?.visaExpiryDate ? new Date(masterDependent.visaExpiryDate) : null
          }
        );
        //country specific expiry dates
        //   if (officeLocationCountry === 1051) {
        //     dependentExpiryDates.push({
        //       label: `${relation} CPR expiry - ${dependent.firstName}`,
        //       newExpDate: dependent.cprExpiryDate ? new Date(dependent.cprExpiryDate) : null,
        //       oldExpDate: masterDependent?.cprExpiryDate ? new Date(masterDependent.cprExpiryDate) : null
        //     });
        //   } else if (officeLocationCountry === 1050) {
        //     dependentExpiryDates.push({
        //       label: `${relation} Civil ID expiry - ${dependent.firstName}`,
        //       newExpDate: dependent.civilIdExpiryDate ? new Date (dependent.civilIdExpiryDate) : null,
        //       oldExpDate: masterDependent?.civilIdExpiryDate ? new Date (masterDependent.civilIdExpiryDate) : null
        //     });
        // }
      });
      return dependentExpiryDates.map(({ label, newExpDate, oldExpDate }) => ({
        label,
        newExpDate: newExpDate ? new Date(newExpDate) : null,
        oldExpDate: oldExpDate ? new Date(oldExpDate) : null,
      }));
    };
    //storing dependent expiry dates
    expiryDates.push(...processDependentDetails(childrenDetails, masterChildrenDetails, 'Child'));
    expiryDates.push(...processDependentDetails(spouseDetails, masterSpouseDetails, 'Spouse'));
    expiryDates.forEach(exp => {
      const currentDate = new Date();
      //if new exp date or old exp  is null no need to validate . applicable for non mandatory fields
      //First checks if new exp dates is less than current else proceeds to check old and new expiry dates
      if (getDateAsUTC(exp.newExpDate) < getDateAsUTC(currentDate) && getDateAsUTC(exp.newExpDate) !== null) {
        currentDateMessage.push(exp.label);
        currentDateExpId += 1;
      }
      else if (getDateAsUTC(exp.newExpDate) < getDateAsUTC(exp.oldExpDate) && getDateAsUTC(exp.newExpDate) !== null && getDateAsUTC(exp.oldExpDate) !== null) {
        expiryMessage.push(exp.label);
        expiId += 1;
      }
    });
    //return message;
    //let finalMessage = this.uniqueByPropertyName(expiryMessage).join(', ').replace(/,(?=[^,]*$)/, ' and ') + '. ';
    let finalMessage = this.uniqueByPropertyName(expiryMessage).join('<br/>') + '. ';
    let finalCurrentDateMessage = this.uniqueByPropertyName(currentDateMessage).join('<br>') + '. ';
    if (currentDateExpId > 0) {
      return { id: currentDateExpId, isCurrent: true, message: finalCurrentDateMessage }
    }
    else {
      return { id: expiId, isCurrent: false, message: finalMessage };
    }
  }

  getEmpCategoryOptionsWithFilter(dataSource$: Observable<LookupField[]>, filterItems?: number[], disabledItems?: number[], additionalConfig?: FormlyFieldConfig, id?: number
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        dataSource$.subscribe(res => {
          let fieldOptions = res;
          if (filterItems && filterItems.length > 0) {
            fieldOptions = fieldOptions.filter(f => filterItems.includes(f.id));
          }
          if (disabledItems && disabledItems.length > 0) {
            fieldOptions.forEach(x => {
              x.disabled = disabledItems.includes(x.id);
            });
          }
          if (id && [1079, 1080, 1081].includes(id)) {
            fieldOptions = fieldOptions.filter(f => f.id === 717);
          } else if (id) {
            fieldOptions = fieldOptions.filter(f => f.id !== 717);
          }
          field.templateOptions.options = fieldOptions;
          field.formControl.valueChanges.subscribe((fieldValue) => {
            const option = fieldOptions.find(x => x.id === fieldValue);
            if (option && option.disabled) {
              field.templateOptions.options = fieldOptions.filter(x => !x.disabled || x.id === fieldValue);
            } else {
              field.templateOptions.options = fieldOptions.filter(x => !x.disabled);
            }
          });
          field.formControl.updateValueAndValidity();
        });
      }
    };
    return getMergedConfig(config, additionalConfig);
  }

  getRequiredSelectFieldOptions(dataSource$: Observable<LookupField[]>, additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        dataSource$.subscribe(res => {
          let fieldOptions = res;
          if (isNullOrUndefined(this.visaTypeId) || this.visaTypeId == 0) {
            let urlObj = new URL(window.location.href);
            let pathSegments = urlObj.pathname.split('/');
            let visaTypeValue = pathSegments[pathSegments.length - 1];
            this.visaTypes$.pipe(
              map(x => x.find(x => x.value === visaTypeValue))
            ).subscribe(x => {
              this.visaTypeId = x.id;
            });
          }
          this.lookupApi.getMappedLookUpFieldValues(LookupTypeKeys.IMMIGRATION_CASE_TYPE, this.visaTypeId).subscribe(
            data => {
              if (data.length > 0) {
                fieldOptions = fieldOptions.filter(f => data.includes(f.id));
                field.formControl.updateValueAndValidity();
              }
            });
          field.templateOptions.options = fieldOptions;

          field.formControl.valueChanges.subscribe((fieldValue) => {
            if (field.key === 'immigrationCaseType.id') {
              const option = fieldOptions.find(x => x.id === fieldValue);
              if (option && option.disabled) {
                field.templateOptions.options = fieldOptions.filter(x => !x.disabled || x.id === fieldValue);
              } else {
                field.templateOptions.options = fieldOptions.filter(x => !x.disabled);
              }
            }
          });
          field.formControl.updateValueAndValidity();
        });
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
  prepareICTObservable(): Observable<UserRole[]> {
    return this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.IMMIGRATION_CASE_TYPE]).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  getMappedLookUpFieldValues() {
    return this.lookupApi.getMappedLookUpFieldValues(LookupTypeKeys.IMMIGRATION_CASE_TYPE, this.visaTypeId)
  }
  getWPDetailsFromJobTitle(additionalConfig?: FormlyFieldConfig): FormlyFieldConfig {
    const wpJobTitle$ = this.prepareWorkPermitJobTitleObservable();
    wpJobTitle$.subscribe(n => this.workpermitJobTitles$.next(n));

    const config: FormlyFieldConfig = {
      templateOptions: {
        options: wpJobTitle$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const wpJobTitleEle = this.findFormControl('mohreJobTitleId.id', field);
        const wpJobCodeEle = this.findFormControl('workPermitJobCode', field);
        const wpCategoryEle = this.findFormControl('workPermitCategory', field)
        wpJobTitleEle.valueChanges.subscribe(jt => {
          const selectedJobTitle = this.workpermitJobTitles$.getValue().find(n => n.id === jt);
          if (selectedJobTitle) {
            wpJobCodeEle.setValue(selectedJobTitle.jobCode);
            wpCategoryEle.setValue(selectedJobTitle.skillCategory)
          }
        });
      }
    }
    return getMergedConfig(config, additionalConfig);
  }

  prepareWorkPermitJobTitleObservable(parentId?: number, filterKey?: number): Observable<ServiceLine[]> {
    return this.lookupApi.getWorkPermitJobTitles(undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      shareReplay()
    );
  }
  canEditCompletedImmProfile(model:ImmigrationProfile){
      if(model.immigrationStatus.id == ImmStatusType.COMPLETED && 
       this.authService.hasClaim("imm-CompletedProfileAccess")){
        return true;
      }
      return false;
  }
  canCompleteEditedImmProfile(model:ImmigrationProfile){
    if(this.authService.hasClaim("imm-CompletedProfileAccess") && model.editCompletedProfile){
      return true;
    }
    return false;
  }

  completeImmProfileEdit(isComplete: boolean, isEditable: boolean, profile: any, modelId: number): Observable<any> {
    const confirmationMessage = isComplete 
      ? "Are you sure you want to complete this profile?" 
      : "Are you sure you want to edit this completed profile?";

    const confirmationTitle = isComplete ? "Confirm complete" : "Confirm Edit";

    return new Observable(observer => {
      this.dialog.showConfirmationBox(
        confirmationTitle,
        confirmationMessage,
        () => {
          this.immigrationService.editCompletedImmProfile(modelId, isComplete, isEditable, profile)
            .subscribe(data => {
              if (data) {
                observer.next(data);
                observer.complete();
              }
            }, err => {
              this.toast.error("Something went wrong!");
              observer.error(err);
            });
        },
        () => {
          observer.complete();
        }
      );
    });
  }

  AcceptDateBeforeYears(
    pivotDate: Date,
    years: number,
    message: string,
    checkInAcceptAndApprove = true,
    additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {

    const isApprove = (this.route.url.indexOf('approve') > 0) || (this.route.url.indexOf('accept') > 0);
    const config: FormlyFieldConfig = {
        templateOptions: {
        },
        validators: {
            notAfterSpecifiedYears: {
                expression: (c) => {
                    if (isApprove && !checkInAcceptAndApprove) {
                        return true;
                    }
                    if (!isNullOrUndefined(c.value)) {
                        const futureDate = addYears(pivotDate, years); // Changed from addMonths to addYears
                        return (futureDate >= c.value);
                    }
                    return true;
                },
                message: (error, field: FormlyFieldConfig) => message,
            }
        },
    };
    return getMergedConfig(config, additionalConfig);
}
//  AddTooltipToControlWhen(tooltipMessage: string, val?: number,key?:string,additionalConfig?:FormlyFieldConfig): FormlyFieldConfig {
// const config: FormlyFieldConfig = {
//       templateOptions: {
//         valueProp: "id",
//         labelProp: "displayText"
//       }
//     };
//     config.hooks = {
//       onInit: field => {
//         const ele = this.findFormControl(key, field);
//         field.formControl.valueChanges.pipe(
//             takeUntil(this.destroyed$),
//             startWith(ele.value),
//             tap(id => {
//           if (id === val) {
//            //this.AddTooltipToControl(tooltipMessage);
//            //return{
//           field.templateOptions.tooltip.content = tooltipMessage;
//           field.templateOptions.wrappers = ['tooltip-field'];
//           };
//         })
//         ).subscribe();
//       }
//     }
//    return getMergedConfig(config, additionalConfig);
//   }
// }

getSelectFieldWithFilter(
    //tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const ele = this.findFormControl('doesNewJoinerSponsorDep', field);
        //const transferEle = this.findFormControl('transferTypeID', field); 
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap((id) => {
              if (!(id === 1074)) {
                field.templateOptions.options = EMPTY;
                field.formControl.setValue(null);
              }
              else {
                field.templateOptions.options = EMPTY;
                 field.templateOptions.options = dataSource$;
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }


// getSelectFieldWithFilterGDA(
//     //tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
//     dataSource$: Observable<LookupField[]>,
//     parentKey?: string,
//     additionalConfig?: FormlyFieldConfig,
//   ): FormlyFieldConfig {
//     let prevValueOfParent = 0;
//     const config: FormlyFieldConfig = {
//       templateOptions: {
//         options: dataSource$,
//         valueProp: "id",
//         labelProp: "displayText"
//       }
//     };
//     config.hooks = {
//       onInit: field => {
//         const gda = this.findFormControl("gdaProcessRequirement", field);
//         //const transferEle = this.findFormControl('transferTypeID', field); 
//         gda.valueChanges
//           .pipe(
//             takeUntil(this.destroyed$),
//             startWith(gda.value),
//             tap(id => {
//               if (!(id === 7072)) {
//                 field.templateOptions.options = EMPTY;
//                 field.formControl.setValue(null);
//               }
//               else {
//                 field.templateOptions.options = EMPTY;
//                  field.templateOptions.options = dataSource$;
//               }
//             })
//           )
//           .subscribe();
//       }
//     };
//     return getMergedConfig(config, additionalConfig);
//   }
  getSelectFieldWithFilterGDA(
    //tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        //const ele = field.formControl;
        const ele = this.findFormControl('gdaProcessRequirement',field);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(id => {
              if (id !== 7072) {
                field.formControl.setValue(null);
                field.formControl.disable();
              }
              else{
                
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$;
                field.formControl.enable();
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
setNullWithFilter(
    el :string,val:number,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const ele = this.findFormControl(el, field);
        //const transferEle = this.findFormControl('transferTypeID', field); 
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap((id) => {
              if (!(id === val)) {
                field.formControl.setValue(null);
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
setExitFormality(
    dataSource$: Observable<LookupField[]>,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const transferEle = this.findFormControl('homeCountryVisaCancellationStatus', field);
        const ele = this.findFormControl('itClearance', field); 
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap((id) => {
              if (id === 7075 && transferEle.value === 7078) //7081
                 {
                field.formControl.setValue(7081);
                //field.formControl.disable();
              }
              else if(id === 7076 && transferEle.value === 7079) {
                field.formControl.setValue(7082);
                //field.formControl.disable();
              }
              else if(id === 7077 || transferEle.value === 7080) {
                field.formControl.setValue(7083);
                //field.formControl.disable();
              }
              else{
                field.formControl.setValue(null);
                //field.formControl.disable();
              }
            })
          )
          .subscribe();
          transferEle.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(transferEle.value),
            tap((id) => {
              if (id === 7078 && ele.value === 7075) 
                 {
                field.formControl.setValue(7081);
                //field.formControl.disable();
              }
              else if(id === 7079 && ele.value === 7076) {
                field.formControl.setValue(7082);
                //field.formControl.disable();
              }
              else if(id === 7080 || ele.value === 7077) {
                field.formControl.setValue(7083);
                //field.formControl.disable();
              }
              else{
                field.formControl.setValue(null);
                //field.formControl.disable();
              }
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
      getITClearance(
    //tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        const ele = this.findFormControl('itITInformation.haveCurrentOfficeEquipment.id', field);
        ele.valueChanges
          .pipe(
            takeUntil(this.destroyed$),
            startWith(ele.value),
            tap(id => {
              if (id === 1074) {
                field.templateOptions.options = EMPTY;
                field.templateOptions.options = dataSource$;
              }
               else {
               field.formControl.setValue(null);
                field.formControl.disable();
             }
              //field.templateOptions.options = !isNullOrUndefined(ele.value) && dataSource$.pipe(map(x => x.filter(v => v.id == ele.value)))[0].disabled ? res.filter(x => !x.disabled || x.id == fieldValue) : res.filter(x => !x.disabled);
            })
          )
          .subscribe();
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
  getSelectedLEByCurrentLocation(
    //tapFn: (field: FormlyFieldConfig, dataSource$: Observable<LookupField[]>, id: any) => void,
    dataSource$: Observable<LookupField[]>,
    parentKey?: string,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };

   // if (parentKey && parentKey.length > 0) {
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl('currentLocationCountryID', field);
         //iif (ele) {
            ele.valueChanges
              .pipe(
                takeUntil(this.destroyed$),
                startWith(ele.value),
                tap(id => {
                 if ( !isNullOrUndefined(id)) {
                field.templateOptions.options = this.officeEntityByCurrentLocationCountryObservable(id)//dataSource$.pipe(map(items => items.filter(f => f.parentFieldId == id)));
                field.formControl.setValue(null);
              }
              else {
                field.templateOptions.options = EMPTY;
                 //field.templateOptions.options = dataSource$;
              }
                  //tapFn(field, dataSource$, id);
                })
              )
              .subscribe();
          }
        //}
      };
   // }
    return getMergedConfig(config, additionalConfig);
  }
  getImmCaseTypeByCurrentLocation(
    dataSource$: Observable<LookupField[]>,
    profileId:  number,
    additionalConfig?: FormlyFieldConfig,
  ): FormlyFieldConfig {
    let prevValueOfParent = 0;
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
      config.hooks = {
        onInit: field => {
          const ele = this.findFormControl('currentLocationCountryID', field);
          const pb = this.findFormControl('newJoinerWorkPermit', field);
          let pbType1 =0;
            ele.valueChanges
              .pipe(
                takeUntil(this.destroyed$),
                startWith(ele.value),
                tap(id => {
                 
                 if ( !isNullOrUndefined(id)) {
                   this.getParentIdByCurrentLocationCountryObservable(id,profileId).subscribe((res)=>{
                    var r = res;
                field.templateOptions.options = this.getImmigrationTypes(dataSource$,res['item1'],res['item2'])//dataSource$.pipe(map(items => items.filter(f => f.parentFieldId == id)));
                //field.formControl.setValue(null);
                   });
              }
              else {
                field.templateOptions.options = EMPTY;
                 //field.templateOptions.options = dataSource$;
              }
                })
              )
              .subscribe();
              pb.valueChanges
              .pipe(
                takeUntil(this.destroyed$),
                startWith(ele.value),
                tap(id => {
                 if ( id !== 2346) {
          
                field.formControl.setValue(null);
                field.formControl.disable();
                   }              
              else {
               this.getParentIdByCurrentLocationCountryObservable(ele.value,profileId).subscribe((res)=>{
                field.templateOptions.options = this.getImmigrationTypes(dataSource$,res['item1'],res['item2'])
               }
              )
            }
          })
          )
              .subscribe();
           }
      };
    return getMergedConfig(config, additionalConfig);
  }
  private getImmigrationTypes(immigrationCaseType$:Observable<LookupField[]>,country:number,pbType:number) {
      if (country) {
                
        var pbTypeId = pbType;
  
        switch (country) {
          case 1047:
            return immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1004, 1005, 1008, 1009, 1011, 1012, 1013, 1014, 1015, 1018, 1019, 12210, 12211,15068].includes(f.id))));
            break;
          case 1048:
            return immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1002, 1003, 1005, 1010, 1016, 1017, 12271].includes(f.id))));
            break;
          case 1050:
            return immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1002, 1003, 1005, 1010, 1011, 1012, 1016, 1017].includes(f.id))));
            break;
          case 1049:
            return immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1002, 1003, 1004, 1005, 1008, 1009, 1010, 1011, 1012, 1016, 1017, 12025, 12026].includes(f.id))));
            break;
          case 1052:
            return immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1002, 1003, 1004, 1005, 1010, 1011, 1012, 1016, 12271].includes(f.id))));
            break;
          case 1051:
            return immigrationCaseType$.pipe(map(items => items.filter(f => [1001, 1002, 1003, 1004, 1005, 1010, 1011, 1012, 1016,12211].includes(f.id))));
            break;
          case 1053:
            return immigrationCaseType$.pipe(map(items => items.filter(f => [1004,1005,1010,12270].includes(f.id))));
            break;
          case 1054:
            return immigrationCaseType$.pipe(map(items => items.filter(f => [1004,1005,1010,12270].includes(f.id))));
            break;
          case 1055:
          case 6250:         
          case 6251:         
          case 6252:  
            if(pbTypeId == 1045){
              return immigrationCaseType$.pipe(map(items => items.filter(f => [1004,1005,12270].includes(f.id))));
            }else{
              return immigrationCaseType$.pipe(map(items => items.filter(f => [1010,12270].includes(f.id))));
            }
            break;                
          default:
            return immigrationCaseType$;
            break;
        }
      } else {
        return null//immigrationCaseType$;
      }
    }

//to fetch the country and disable based on office location city
getCountryBasedOnCity(
  dataSource$: Observable<LookupField[]>,
  cityFieldKey: string,
  additionalConfig?: FormlyFieldConfig
): FormlyFieldConfig {
  const config: FormlyFieldConfig = {
    templateOptions: {
      options: dataSource$,
      valueProp: 'id',
      labelProp: 'displayText',
      compareWith: (a: any, b: any) => a == b,      
    },
    hooks: {
      onInit: (field) => {
        const cityControl = this.findFormControl(cityFieldKey, field);
        if (!cityControl) return;
        cityControl.valueChanges
          .pipe(takeUntil(this.destroyed$))
          .subscribe(cityId => {           
            if (!cityId) return;

            this.prepareOfcLocationsWithCountryCode()
              .pipe(take(1))
              .subscribe(cities => {
                const selectedCity = cities.find(c => c.id === cityId);
                console.log(selectedCity)
                const parentCountryId = selectedCity?.parentFieldId;

                if (parentCountryId) {                 
                  setTimeout(() => {
                    //setting and disabling office location country
                    field.formControl.setValue(parentCountryId);
                    field.formControl.disable();
                  });
                }
              });
          });
      }
    }
  };

  return getMergedConfig(config, additionalConfig);
}
  prepareEmployeeCategoryOptions(): Observable<LookupField[]> {
    return this.lookupApi.getLookupFieldsByType(LookupTypeKeys.EMPLOYEE_CATEGORY_TYPES, undefined, undefined).pipe(
      takeUntil(this.destroyed$),
      map(arr => arr.filter(item => !LookupFieldKeys.EXCLUDED_EMP_CATEGORY_IDS.includes(item.id))),
      shareReplay()
    );
  }
prepareContractTypeOptions(): Observable<LookupField[]> {
  return this.lookupApi.getLookupFieldsByType(LookupTypeKeys.CONTRACT_TYPES, undefined, undefined).pipe(
    takeUntil(this.destroyed$),
    map(arr => {
      arr.forEach(item => {
        item.displayText = item.displayText +' - '+ item.parentFieldValue;
      });
      return arr;
    }),
    map(arr => arr.filter(item => ! LookupFieldKeys.EXCLUDED_CONTRACT_TYPE_IDS.includes(item.id))),
    shareReplay()
  );
}
  getPlainTextFromHtml(htmlContent: string): string {
    if (!htmlContent) {
      return '';
    }

    // Replace HTML elements with text equivalents
    let formattedText = htmlContent
      // Replace <br> and <br/> tags with line breaks
      .replace(/<br\s*\/?>/gi, '\n')
      // Replace </p> tags with double line breaks for paragraph separation
      .replace(/<\/p>/gi, '\n\n')
      // Replace <p> tags (opening) with nothing (content remains)
      .replace(/<p[^>]*>/gi, '')
      // Replace </div> tags with line breaks
      .replace(/<\/div>/gi, '\n')
      // Replace <div> tags with nothing
      .replace(/<div[^>]*>/gi, '')
      // Replace </h1,h2,h3,h4,h5,h6> tags with double line breaks
      .replace(/<\/h[1-6]>/gi, '\n\n')
      // Replace <h1,h2,h3,h4,h5,h6> tags with nothing
      .replace(/<h[1-6][^>]*>/gi, '')
      // Replace list items with line breaks and bullets
      .replace(/<li[^>]*>/gi, '• ')
      .replace(/<\/li>/gi, '\n')
      // Remove all remaining HTML tags
      .replace(/<[^>]*>/g, '')
      // Decode HTML entities
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");

    // Clean up extra whitespace but preserve intentional line breaks
    return formattedText
      .replace(/[ \t]+/g, ' ')  // Replace multiple spaces/tabs with single space
      .replace(/\n\s*\n\s*\n/g, '\n\n')  // Replace multiple line breaks with double line breaks
      .trim();
  }

onVisaTypeChange(selectedVisaTypeId: any, field: any): void {

  const form = field.parent.formControl;

  // If no visa type is selected, clear the visa dates
  if (isNullOrUndefined(selectedVisaTypeId) || selectedVisaTypeId === '') {
    form.patchValue({
      'visaIssuanceDate': null,
      'visaExpiryDate': null
    });
    return;
  }

  const countryToBeVisitedCtrl = this.findFormControl('countryToBeVisited.id', field);
  const countryToBeVisited = countryToBeVisitedCtrl?.value;
  if(countryToBeVisited === CountryTypeIds.SaudiArabia){ 
    return;
  }
  // Get parent field ID from the visa options stored in form state
  const formState = field.options?.formState || {};
  const countryVisaMap = formState.countryVisaMap;

  let parentFieldId = null;
  if (countryVisaMap && countryVisaMap[selectedVisaTypeId]) {
    // Get the first entry for this visa type (they should all have same parentFieldId)
    const visaEntry = countryVisaMap[selectedVisaTypeId][0];
    parentFieldId = visaEntry?.parentVisaTypeId;
  }

  if (!isNullOrUndefined(parentFieldId)) {
    const gpn = this.findFormControl('gpn', field)?.value;
    const gui = this.findFormControl('gui', field)?.value;
    
    if (isNullOrUndefined(gpn) || isNullOrUndefined(gui) || gpn == '' || gui == '') {
      this.toast.warning("Please fill GPN and GUI fields to autopopulate the visa dates");
      return;
    }
    else{
    this.loader.show();     
    this.immigrationService.getBTFieldData(parentFieldId, gpn, gui).subscribe((response) => {
        let hasUpdates = false;       
        
          const currentVisaIssuanceDate = form.value.visaIssuanceDate;
          if( isNullOrUndefined(response?.visaExpiryDate))
          {
             form.patchValue({'visaExpiryDate': null});
          }
          form.patchValue({
            'visaIssuanceDate': response?.visaIssuanceDate
          });
          hasUpdates = true;

          // Handle visaExpiryDate - always update whether value or null
          const currentVisaExpiryDate = form.value.visaExpiryDate;
          if( isNullOrUndefined(response?.visaIssuanceDate))
          {
             form.patchValue({'visaIssuanceDate': null});
          }
          form.patchValue({
            'visaExpiryDate': response?.visaExpiryDate
          });
          hasUpdates = true;
       // }        
        this.loader.clear();
      }, (error) => {
        this.toast.error("Error fetching visa data");
        this.loader.clear();
      });
    }
  }
  }

  //hide active values from dropdown. Will not impact exisitng values.
  getActiveOptionsExcludingHiddenValues(dataSource$: Observable<LookupField[]>, filterItems?: number[], disabledItems?: number[], additionalConfig?: FormlyFieldConfig, id?: number
  ): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        options: dataSource$,
        valueProp: "id",
        labelProp: "displayText"
      }
    };
    config.hooks = {
      onInit: field => {
        dataSource$.subscribe(res => {
          let fieldOptions = res;
          if (filterItems && filterItems.length > 0) {
            fieldOptions = fieldOptions.filter(f => filterItems.includes(f.id));
          }
          if (disabledItems && disabledItems.length > 0) {
            // fieldOptions.forEach(x => {
            //   x.disabled = disabledItems.includes(x.id);
            // });
            // Clone each option so the shared (shareReplay-cached) lookup objects
            // are never mutated; otherwise the disabled flag leaks into other dropdowns.
             fieldOptions = fieldOptions.map(x =>
              Object.assign(new LookupField(), x, { disabled: disabledItems.includes(x.id) }));
          }
          field.templateOptions.options = fieldOptions;
          field.formControl.valueChanges.subscribe((fieldValue) => {
            const option = fieldOptions.find(x => x.id === fieldValue);
            if (option && option.disabled) {
              field.templateOptions.options = fieldOptions.filter(x => !x.disabled || x.id === fieldValue);
            } else {
              field.templateOptions.options = fieldOptions.filter(x => !x.disabled);
            }
          });
          field.formControl.updateValueAndValidity();
        });
      }
    };
    return getMergedConfig(config, additionalConfig);
  }
}
